import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf) */
  JSON: any;
  BigInt: any;
  JSONObject: any;
  Decimal: any;
  /** A `Timestamp` represents a point in time independent of any time zone or calendar, represented as seconds and fractions of seconds at nanosecond resolution in UTC Epoch time. */
  Timestamp: any;
  UUID: any;
  /** The `Int32` scalar type represents non-fractional signed whole numeric values. Int32 can represent values between -(2^31) and 2^31 - 1.  */
  Int32: any;
  /** The `Int64` scalar type represents non-fractional signed whole numeric values. Int64 can represent values between -(2^63) and 2^63 - 1.  */
  Int64: any;
  Uint64: any;
  Time: any;
  Upload: any;
  Void: any;
};

export type Query = {
  __typename?: 'Query';
  apiReady?: Maybe<Scalars['Boolean']>;
  authenticationFlow?: Maybe<AuthenticationFlow>;
  busSchedules?: Maybe<Array<Maybe<CommonSchedules>>>;
  /** Return startDateTime and endDateTime as formatted UTC strings */
  campaignDates?: Maybe<CampaignDates>;
  campaignHistoryListGet?: Maybe<Array<Maybe<CampaignHistoryList>>>;
  campaignKyc?: Maybe<CampaignKyc>;
  /** Query uses Users JWT to find their Memberships See CampaignMembership type for details */
  campaignMemberships: Array<CampaignMembership>;
  /** List campaigns based on logged-in user */
  campaigns?: Maybe<CampaignList>;
  /** List of saved search filters for campaigns of current user. */
  campaignSearchFiltersGet?: Maybe<Array<Maybe<CampaignSearchFilter>>>;
  consumers?: Maybe<Array<Maybe<Consumer>>>;
  currentPrefunds?: Maybe<PrefundList>;
  currentWalletOrganization?: Maybe<Organization>;
  /** List of contact templates based on current user */
  customContactTemplatesGet?: Maybe<Array<Maybe<CustomContactTemplates>>>;
  dailyCalendarEvents?: Maybe<Array<Maybe<DailyCalendarEvent>>>;
  dailyCalendarPreparations?: Maybe<Array<Maybe<DailyCalendarPreparation>>>;
  daySchedules?: Maybe<Array<Maybe<CommonSchedules>>>;
  donationLevelsByFundraiserId: Array<DonationLevel>;
  donationTopEarner?: Maybe<DonationTopEarner>;
  /** Blocking this query for now, however it can be used securely within campaign memberships This query will work for both group leaders & participants */
  donorEmailAddresses?: Maybe<DonorEmailAddresses>;
  donorEmailData?: Maybe<Array<Maybe<DonorEmailData>>>;
  donorPersonListEntries?: Maybe<Array<Maybe<DonorPersonListEntry>>>;
  donorPhoneNumbers?: Maybe<DonorPhoneNumbers>;
  /** List all activity types of campaigns. Used by Drive */
  driveActivityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Get details of campaigns. This endpoint need to considered to combined with searchDriveCampaign endpoint */
  driveCampaignDetails?: Maybe<DriveCampaignDetails>;
  /** Get statistics of the set of campaigns returned by the filter. This endpoint are meant to be used with the searchDriveCampaigns endpoint. Arguments should be the same. */
  driveCampaignSearchStats?: Maybe<DriveCampaignSearchStatistics>;
  /** Show details of a specific event */
  driveEvent?: Maybe<DriveEvent>;
  /** List events */
  driveEvents?: Maybe<DriveEventResults>;
  /** List organization types used by Drive */
  driveOrganizationTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List all salesreps */
  driveSalesreps?: Maybe<Array<Maybe<DriveAmSalesReps>>>;
  /** List all salesreps which had re-assigned any campaigns to current user. This endpoint is applicable for account-manager only. */
  driveSalesrepsByAccountManager?: Maybe<Array<Maybe<DriveAmSalesReps>>>;
  /** List all salesreps which managed by current user. This endpoint is applicable for sales manager only. */
  driveSalesrepsByManager?: Maybe<Array<Maybe<DriveAmSalesReps>>>;
  /**
   * Search Raise users by UserDirectory 's id
   * @deprecated Use UserDirectory 's users query instead
   */
  driveUsers?: Maybe<DriveUsersResult>;
  /** List Event-Tracker's venues */
  driveVenues?: Maybe<Array<Maybe<DriveVenue>>>;
  event: Event;
  eventCalendar?: Maybe<Array<Maybe<CommonCalendar>>>;
  eventContractItems?: Maybe<Array<Maybe<ContractItem>>>;
  eventOfficial: Official;
  eventOfficials?: Maybe<Array<Maybe<Official>>>;
  eventParticipants: EventParticipants;
  eventPreparations: EventPreparations;
  eventPreparationsByEvent?: Maybe<Array<Maybe<EventPreparations>>>;
  events?: Maybe<Array<Maybe<Event>>>;
  eventsParticipants?: Maybe<Array<Maybe<EventParticipants>>>;
  eventsPreparations?: Maybe<Array<Maybe<EventPreparations>>>;
  eventTransportDetails?: Maybe<Array<Maybe<EventTransportDetails>>>;
  eventWorker: Worker;
  eventWorkers?: Maybe<Array<Maybe<Worker>>>;
  facilities?: Maybe<Array<Maybe<Facility>>>;
  facility: Facility;
  facilityCalendar?: Maybe<Array<Maybe<CommonCalendar>>>;
  facilityGrid?: Maybe<Array<Maybe<CommonGrid>>>;
  facilitySchedules?: Maybe<Array<Maybe<CommonSchedules>>>;
  family?: Maybe<Family>;
  feeReportSheets?: Maybe<Array<Maybe<CommonSheet>>>;
  financialAcctId?: Maybe<Array<Maybe<FinancialAcctNode>>>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserDonations?: Maybe<FundraiserDonations>;
  /** resourceId is the fundraiserId */
  fundraiserEntityResources?: Maybe<FundraiserEntityResource>;
  fundraiserGroups?: Maybe<Array<Maybe<FundraiserGroup>>>;
  fundraiserRaisedAmount?: Maybe<FundraiserRaisedAmount>;
  fundraiserRewardsDetails?: Maybe<Array<Maybe<FundraiserRewardsProduct>>>;
  fundraiserTopDonation?: Maybe<FundraiserTopDonation>;
  fundraiserUserRole?: Maybe<FundraiserUserRole>;
  galleryItems?: Maybe<GalleryItems>;
  getCampaignRoster?: Maybe<Array<Maybe<Roster>>>;
  getFundraiserUserID?: Maybe<Scalars['Int']>;
  getInsightsUserOrgs: Array<Maybe<InsOrg>>;
  getParticipantDonationLinkData?: Maybe<ParticipantDonationLinkResult>;
  getSalesRepHome: HmSalesRep;
  /** List of group leaders */
  groupLeaders?: Maybe<GroupLeaderList>;
  infoSheets?: Maybe<Array<Maybe<CommonSheet>>>;
  insightsCampaignDonations: Array<Maybe<InsCampaignDonation>>;
  insightsCampaignRaiseEntityInfo: InsCampaignRaiseEntityInfo;
  insightsCampaignsData: InsCampaignsData;
  insightsCampaignSettlements: Array<Maybe<InsCampaignSettlement>>;
  insightsDonorParticipantContacts: Array<Maybe<InsDonorParticipantContact>>;
  insightsOrgsCampaignsSummary: Array<Maybe<InsOrgCampaignSummary>>;
  insightsSalesRepInfo?: Maybe<InsSalesRepInfo>;
  invite?: Maybe<InviteInfo>;
  level: Level;
  levelGrid?: Maybe<Array<Maybe<CommonGrid>>>;
  levels?: Maybe<Array<Maybe<Level>>>;
  manageUsersList?: Maybe<ManageUsersList>;
  me?: Maybe<UserWithPermissions>;
  notices?: Maybe<Array<Maybe<Notice>>>;
  officialDuties: OfficialDuties;
  officialPoolById: OfficialPool;
  officialPools?: Maybe<Array<Maybe<OfficialPool>>>;
  officialSchedules?: Maybe<Array<Maybe<OfficialSchedules>>>;
  officialsDuties?: Maybe<Array<Maybe<OfficialDuties>>>;
  opponent: Opponent;
  opponentEventsApplyFilters?: Maybe<Array<Maybe<EventsOpponent>>>;
  opponents?: Maybe<Array<Maybe<Opponent>>>;
  opponentSchedules?: Maybe<Array<Maybe<CommonSchedules>>>;
  org?: Maybe<Array<Maybe<Org>>>;
  orgs?: Maybe<Array<Maybe<Org>>>;
  orgUserAssociations?: Maybe<Array<Maybe<UserNode>>>;
  /** This query will return OTK Fundraiser Product details */
  otkFundraiserData?: Maybe<Array<Maybe<OtkFundraiserProduct>>>;
  /** This query will return OTK Participant details */
  otkParticipantDetails?: Maybe<Array<Maybe<OtkParticipantData>>>;
  participantDonations?: Maybe<ParticipantDonations>;
  participantDonationsRaised: ParticipantDonationsRaised;
  /** This query will return the incentives a Participant earned for a given fundraiser */
  participantEarnedRewardsDetails?: Maybe<Array<Maybe<ParticipantRewardsData>>>;
  participantGroup?: Maybe<ParticipantGroup>;
  participantGuardianEmailQuery?: Maybe<ParticipantGuardianEmail>;
  /** This query will return Participant Rewards details */
  participantRewardsDetails?: Maybe<Array<Maybe<ParticipantRewardsData>>>;
  /** List of participants */
  participants?: Maybe<ParticipantList>;
  participantSSOId?: Maybe<ParticipantSsoid>;
  participantTextTemplate?: Maybe<ParticipantTextTemplate>;
  participantTopDonation?: Maybe<ParticipantTopDonation>;
  payouts: Array<Maybe<Payout>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  prefund?: Maybe<Prefund>;
  prefunds?: Maybe<PrefundList>;
  /** List of pre-made contact templates */
  premadeContactTemplatesGet?: Maybe<Array<Maybe<PremadeContactTemplate>>>;
  preparation: Preparation;
  preparationReportSheets?: Maybe<Array<Maybe<PreparationSheet>>>;
  preparations?: Maybe<Array<Maybe<Preparation>>>;
  /** This resolver is only for testing purposes at this time */
  primaryGroupLeader?: Maybe<PrimaryGroupLeader>;
  /** Identifier uses fundraiser join_code or slug */
  publicFundraiserData?: Maybe<PublicFundraiserData>;
  publicParticipantData?: Maybe<PublicParticipantData>;
  roles?: Maybe<Array<Maybe<Role>>>;
  schoolInfo: SchoolInfo;
  schoolInfos?: Maybe<Array<Maybe<SchoolInfo>>>;
  /** Search campaigns */
  searchDriveCampaigns?: Maybe<DriveCampaignList>;
  /** Search Raise's Organization. @Deprecated: should be replaced by Orgs API */
  searchDriveOrganizationsByName?: Maybe<DriveOrganizationList>;
  season: Season;
  seasonByYearAndTeam?: Maybe<Array<Maybe<Season>>>;
  seasonEventWizard?: Maybe<Array<Maybe<Event>>>;
  seasons?: Maybe<Array<Maybe<Season>>>;
  shipments: ShipmentResponse;
  spendBudgetExport?: Maybe<ExportFile>;
  spendBudgets?: Maybe<SpendBudgetResponse>;
  spendBudgetsSummary?: Maybe<SpendBudgetSummaryResponse>;
  spendCategories?: Maybe<SpendCategoryResponse>;
  spendDataForHome: HmSpendData;
  spendGroup?: Maybe<SpendGroup>;
  spendGroupById?: Maybe<SpendGroup>;
  spendGroupRosterById?: Maybe<SpendRoster>;
  spendGroupRosters?: Maybe<SpendGroupRosterResponse>;
  spendGroups?: Maybe<SpendGroupResponse>;
  spendInvites?: Maybe<SpendInviteResponse>;
  spendInvoiceById?: Maybe<SpendInvoice>;
  spendInvoices?: Maybe<SpendInvoiceResponse>;
  spendInvoicesExport?: Maybe<ExportFile>;
  spendInvoicesMock?: Maybe<SpendMockInvoiceResponse>;
  spendOrganization?: Maybe<SpendOrganization>;
  spendOrganizationById?: Maybe<SpendOrganization>;
  spendOrganizations?: Maybe<Array<Maybe<SpendOrganization>>>;
  spendPaymentScheduleById?: Maybe<SpendPaymentSchedule>;
  spendPaymentSchedules?: Maybe<Array<Maybe<SpendPaymentSchedule>>>;
  spendPolicy?: Maybe<SpendPolicy>;
  spendRoleCurrent?: Maybe<SpendRole>;
  spendRoles?: Maybe<SpendRoleResponse>;
  spendRosters?: Maybe<SpendRosterResponse>;
  spendTransactions?: Maybe<SpendBankTransactionResponse>;
  spendTransactionsExport?: Maybe<ExportFile>;
  sponsor?: Maybe<Sponsor>;
  sponsorAssets?: Maybe<Assets>;
  sponsorCartAsset?: Maybe<SponsorsOnAssets>;
  sponsorCartAssets?: Maybe<Array<Maybe<Asset>>>;
  sponsorCountForAssets?: Maybe<AssetsCount>;
  sponsorDataForHome: HmSponsorData;
  sponsorDistrict: SponsorDistrict;
  sponsorDistricts?: Maybe<SponsorDistricts>;
  sponsoredSponsorshipGroups?: Maybe<SponsoredSponsorShipGroups>;
  sponsorEnabledPaymentMethod?: Maybe<PaymentMethod>;
  sponsorIndustries?: Maybe<Array<Maybe<Industry>>>;
  sponsorInvitationCheckByMailId?: Maybe<Scalars['Boolean']>;
  sponsorPackageDetails?: Maybe<SponsoredSponsorShipGroup>;
  sponsorPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  sponsors?: Maybe<Sponsors>;
  sponsorSchool: SponsorSchool;
  sponsorSchoolProgram: SponsorSchoolProgram;
  sponsorSchoolPrograms?: Maybe<SponsorSchoolPrograms>;
  sponsorSchools?: Maybe<SponsorSchools>;
  sponsorSchoolUsers?: Maybe<Array<Maybe<Link>>>;
  sponsorshipGroup: SponsorshipGroup;
  sponsorshipGroupAccountLink?: Maybe<AccountLink>;
  sponsorshipGroupActivities?: Maybe<Array<Maybe<Activity>>>;
  sponsorshipGroupActivity?: Maybe<Activity>;
  sponsorshipGroupAsset: Asset;
  sponsorshipGroupAssets?: Maybe<Assets>;
  sponsorshipGroupAssetTypes?: Maybe<Array<Maybe<AssetType>>>;
  sponsorshipGroupAssetTypeValues?: Maybe<Array<Maybe<AssetTypeValue>>>;
  sponsorshipGroupInvites?: Maybe<Invites>;
  sponsorshipGroupOrders?: Maybe<SponsorshipGroupOnOrders>;
  sponsorshipGroupOrdersStats?: Maybe<SponsorshipGroupOrdersStats>;
  sponsorshipGroupPricingForCurrentYear?: Maybe<SumResponse>;
  sponsorshipGroupPrimaryContact?: Maybe<SponsorshipGroupUser>;
  sponsorshipGroups?: Maybe<SponsorshipGroups>;
  sponsorshipHistory?: Maybe<Array<Maybe<Packages>>>;
  sponsorshipOrders?: Maybe<SponsoredOrders>;
  sponsorshipPackages?: Maybe<MySponsorships>;
  sponsorState?: Maybe<SponsorState>;
  sponsorStates?: Maybe<Array<Maybe<SponsorState>>>;
  sponsorSubDistrict: SponsorSubDistrict;
  sponsorSubDistricts?: Maybe<SponsorSubDistricts>;
  sponsorUsers?: Maybe<Array<Maybe<Link>>>;
  /** This is Store-Query. That is used to get store using storeId(Int) as param. Own-Used By Store-Dashboard-Team */
  store?: Maybe<StoreUnionType>;
  /** This is Store-Best-Seller-query. That is used to get the store best sellers products. using storeId (Int) as param. Own-Used By Store-Dashboard-Team */
  storeBestSeller?: Maybe<StoreBaseSellerUnionType>;
  /** This is Store-Campaigns-Query. That is used to get campaigns & userinfo using context object. Own-Used By Store-Dashboard-Team. The query is secured by GraphQL-Shield and Super-Admin role should be required by user to access this query */
  storeCampaigns?: Maybe<StoreCampaignUnionType>;
  storeDataForHome: HmStore;
  /** This is Store-Filter-Query. That is used to get stores using campaignIds(array) storesId(array) offset(int) limit(int) as param. Own-Used By Store-Dashboard-Team */
  storeFilter?: Maybe<StoresFilterUnionType>;
  /** This is Store-Managers-query. That is used to get store using campaignIds array(Int) as param. Own-Used By Store-Dashboard-Team */
  storeManagers?: Maybe<StoreManagerUnionType>;
  /** This is Store-New-Activity-Flag-Query. That is used to check store points activities for activity-center. Using scopeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storeNewActivityFlag?: Maybe<StoreNewActivityUnionType>;
  /** This is Store-New-Orders-Check-Query. That is used to check new store order. using storeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storeNewOrdersCheck?: Maybe<StoreNewOrdersCheckUnionType>;
  /** This is Store-Order-Query. That is used to get a specific order using orderId(Int) as param. Own-Used By Store-Dashboard-Team */
  storeOrder?: Maybe<StoreOrderUnionType>;
  /** This is Store-Orders-By-Store-Query. That is used to get all orders per store that saved in our DB using storeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storeOrdersByStore?: Maybe<StoreOrdersUnionType>;
  /** This is Store-Orders-Filter-Query. That is used to get store order. using storeId array(Int) as param. Own-Used By Store-Dashboard-Team */
  storeOrdersFilter?: Maybe<StoreOrdersListingUnionType>;
  /** This is Store-Orders-Summary-Query. That is used to get store order summery about processing, complete, shipped using storeId as param. Own-Used By Store-Dashboard-Team */
  storeOrdersSummary?: Maybe<StoreOrdersSummaryUnionType>;
  /** This is Store-Campaigns-Query. That is used to get participants. using campaignIds array(Int) Own-Used By Store-Dashboard-Team. The query is secured by GraphQL-Shield and Super-Admin role should be required by user to access this query */
  storeParticipants?: Maybe<StoreParticipantUnionType>;
  /** This is Store-Point-Activity-Query. That is used to get store points activities for export-csv using scopeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storePointActivity?: Maybe<StorePointsActivityReturnUnionType>;
  /** This is Store-Points-Activity-Filter-Query. That is used to get store points activities using input StorePointsActivityFilter as param. Own-Used By Store-Dashboard-Team */
  storePointsActivityFilter?: Maybe<StorePointsActivityFilterUnionType>;
  /** This is Store-Points-Earned-Graph-Query. That is used to show us how much points earn by store in one month. Using scopeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storePointsEarnedGraph?: Maybe<StorePointsEarnedGraphUnionType>;
  /** This is Store-Product-Query. That is used to get product . using productId (Int) as param. Own-Used By Store-Dashboard-Team */
  storeProduct?: Maybe<StoreProduct>;
  /** This is Store-Products-Query. That is used to get the store products. using storeId (Int) as param. Own-Used By Store-Dashboard-Team */
  storeProducts?: Maybe<Array<Maybe<StoreProduct>>>;
  /** This is Stores-Query. That is used to get store using campaignIds array(Int) as param. Own-Used By Store-Dashboard-Team */
  stores?: Maybe<CampaignStoresUnionType>;
  /** This is Store-Sales-Graph-Query. That is used to show sales in last 30 days which sub-devided by week. using input StoreSalesReport as param. Own-Used By Store-Dashboard-Team */
  storeSalesGraph?: Maybe<StoreSalesGraphUnionType>;
  /** This is Stores-Order-Details-Query. That is used to get store order details about sales, orders, points for store-listing screan. using storeId array(Int) as param. Own-Used By Store-Dashboard-Team */
  storesOrderDetails?: Maybe<StoreOrdersDetailsUnionType>;
  /** This is Store-Tickets-Query. That is used to retrieve all the tickets details that is created by store on zendesk. Using scopeId(Int) as param. Own-Used By Store-Dashboard-Team */
  storeTickets?: Maybe<StoreTicketUnionType>;
  team: Team;
  teamOfficials?: Maybe<Array<Maybe<TemplateOfficial>>>;
  teamOrgSchedules?: Maybe<Array<Maybe<CommonSchedules>>>;
  teamPreparations?: Maybe<Array<Maybe<TemplatePreparation>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  teamWorkers?: Maybe<Array<Maybe<TemplateWorker>>>;
  twispCardBalances?: Maybe<Array<Maybe<TwispCardBalances>>>;
  twispCards?: Maybe<Array<Maybe<TwispCards>>>;
  twispStripeHooks?: Maybe<Array<Maybe<TwispStripeHooks>>>;
  twispTransactions?: Maybe<Array<Maybe<TwispTransactions>>>;
  unconfirmedEvents?: Maybe<UnconfirmedEventsList>;
  user?: Maybe<User>;
  userAssociations?: Maybe<Array<Maybe<Org>>>;
  userFitting?: Maybe<UserFitting>;
  userPermissions?: Maybe<UserPermissionsList>;
  userPublic?: Maybe<UserPublic>;
  users?: Maybe<Users>;
  userSponsor?: Maybe<Link>;
  userSponsorSchool?: Maybe<Link>;
  vaultAccountStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  vaultCard: Card;
  vaultKyb: VaultKyb;
  vaultKyc: VaultKyc;
  vaultVgsValue: Scalars['String'];
  vehicle: Vehicle;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  workerPoolById: WorkerPool;
  workerPools?: Maybe<Array<Maybe<WorkerPool>>>;
};


export type QueryAuthenticationFlowArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryBusSchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryCampaignDatesArgs = {
  campaignId: Scalars['String'];
};


export type QueryCampaignHistoryListGetArgs = {
  fundraiserId?: InputMaybe<Scalars['Int']>;
};


export type QueryCampaignKycArgs = {
  campaignId: Scalars['String'];
};


export type QueryCampaignsArgs = {
  accountManagerIds?: InputMaybe<Array<Scalars['Int']>>;
  daysClosed?: InputMaybe<Scalars['String']>;
  daysToLaunch?: InputMaybe<Scalars['String']>;
  fetchAllCampaigns?: InputMaybe<Scalars['Boolean']>;
  getTeamSelling?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salesrepIds?: InputMaybe<Array<Scalars['Int']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<SortField>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryConsumersArgs = {
  hidden?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDailyCalendarEventsArgs = {
  input?: InputMaybe<GetDailyCalendarEventsByDateInput>;
};


export type QueryDailyCalendarPreparationsArgs = {
  input?: InputMaybe<GetDailyCalendarPreparationsByEventInput>;
};


export type QueryDaySchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryDonationLevelsByFundraiserIdArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryDonationTopEarnerArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryDonorEmailAddressesArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryDonorEmailDataArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryDonorPersonListEntriesArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryDonorPhoneNumbersArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryDriveCampaignDetailsArgs = {
  fundraiserId: Scalars['Int'];
};


export type QueryDriveCampaignSearchStatsArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  campaignName?: InputMaybe<Scalars['String']>;
  campaignStatuses?: InputMaybe<Array<CampaignStatus>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  fundraiserId?: InputMaybe<Scalars['Int']>;
  hasIncentive?: InputMaybe<Scalars['Boolean']>;
  maxTeamSize?: InputMaybe<Scalars['Int']>;
  maxTotalRaisedCents?: InputMaybe<Scalars['Int']>;
  minTeamSize?: InputMaybe<Scalars['Int']>;
  minTotalRaisedCents?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationTypes?: InputMaybe<Array<Scalars['String']>>;
  salesrepIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  territories?: InputMaybe<Array<Scalars['String']>>;
  usStates?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDriveEventArgs = {
  id: Scalars['ID'];
};


export type QueryDriveEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<DriveEventSearchInput>;
};


export type QueryDriveSalesrepsByManagerArgs = {
  type?: InputMaybe<SalesrepType>;
};


export type QueryDriveUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DriveUserSearchInput>;
};


export type QueryDriveVenuesArgs = {
  where?: InputMaybe<DriveVenueSearchInput>;
};


export type QueryEventArgs = {
  input?: InputMaybe<GetEventByIdInput>;
};


export type QueryEventCalendarArgs = {
  input?: InputMaybe<CommonCalendarFiltersInput>;
};


export type QueryEventContractItemsArgs = {
  input?: InputMaybe<EventContractItemInput>;
};


export type QueryEventOfficialArgs = {
  input?: InputMaybe<GetOfficialByIdInput>;
};


export type QueryEventParticipantsArgs = {
  input?: InputMaybe<GetEventParticipantsByIdInput>;
};


export type QueryEventPreparationsArgs = {
  input?: InputMaybe<GetEventPreparationsByIdInput>;
};


export type QueryEventPreparationsByEventArgs = {
  input?: InputMaybe<GetEventPreparationsByEventIdInput>;
};


export type QueryEventWorkerArgs = {
  input?: InputMaybe<GetWorkerByIdInput>;
};


export type QueryFacilityArgs = {
  input?: InputMaybe<GetFacilityByPlaceNameInput>;
};


export type QueryFacilityCalendarArgs = {
  input?: InputMaybe<CommonCalendarFiltersInput>;
};


export type QueryFacilityGridArgs = {
  input?: InputMaybe<CommonGridFiltersInput>;
};


export type QueryFacilitySchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryFeeReportSheetsArgs = {
  input?: InputMaybe<CommonSheetFiltersInput>;
};


export type QueryFinancialAcctIdArgs = {
  acctId: Scalars['ID'];
};


export type QueryFundraiserArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryFundraiserDonationsArgs = {
  fundraiserId: Scalars['String'];
  take: Scalars['Int'];
};


export type QueryFundraiserEntityResourcesArgs = {
  resourceId: Scalars['Int'];
};


export type QueryFundraiserGroupsArgs = {
  joinCode: Scalars['String'];
};


export type QueryFundraiserRaisedAmountArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryFundraiserRewardsDetailsArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryFundraiserTopDonationArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryFundraiserUserRoleArgs = {
  fundraiserId: Scalars['Int'];
};


export type QueryGalleryItemsArgs = {
  fundraiserId: Scalars['String'];
};


export type QueryGetCampaignRosterArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetInsightsUserOrgsArgs = {
  userId: Scalars['Int'];
};


export type QueryGetParticipantDonationLinkDataArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryGetSalesRepHomeArgs = {
  zip: Scalars['String'];
};


export type QueryGroupLeadersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  groupLeaderId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryInfoSheetsArgs = {
  input?: InputMaybe<CommonSheetFiltersInput>;
};


export type QueryInsightsCampaignDonationsArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryInsightsCampaignRaiseEntityInfoArgs = {
  campaignId: Scalars['Int'];
};


export type QueryInsightsCampaignsDataArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryInsightsCampaignSettlementsArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryInsightsDonorParticipantContactsArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryInsightsOrgsCampaignsSummaryArgs = {
  orgCampaignIds: Array<InputMaybe<InsOrgCampaignSummaryInput>>;
};


export type QueryInsightsSalesRepInfoArgs = {
  salesRepEmail: Scalars['String'];
};


export type QueryInviteArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLevelArgs = {
  input?: InputMaybe<GetLevelByIdInput>;
};


export type QueryLevelGridArgs = {
  input?: InputMaybe<CommonGridFiltersInput>;
};


export type QueryManageUsersListArgs = {
  input?: InputMaybe<ManageUsersListOptions>;
};


export type QueryOfficialDutiesArgs = {
  input?: InputMaybe<GetOfficialDutiesByIdInput>;
};


export type QueryOfficialPoolByIdArgs = {
  input?: InputMaybe<GetOfficialPoolByIdInput>;
};


export type QueryOfficialSchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryOpponentArgs = {
  input?: InputMaybe<GetOpponentBySchoolCodeInput>;
};


export type QueryOpponentEventsApplyFiltersArgs = {
  input?: InputMaybe<GetEventsFilteredByOpponentStartAndEndDate>;
};


export type QueryOpponentSchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryOrgArgs = {
  hierarchy?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryOrgsArgs = {
  nameIncludes: Scalars['String'];
};


export type QueryOrgUserAssociationsArgs = {
  orgId: Scalars['ID'];
  product: Product;
};


export type QueryOtkFundraiserDataArgs = {
  fundraiserId: Scalars['ID'];
};


export type QueryOtkParticipantDetailsArgs = {
  fundraiserId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryParticipantDonationsArgs = {
  fundraiserId: Scalars['String'];
  participantId: Scalars['String'];
  take: Scalars['Int'];
};


export type QueryParticipantDonationsRaisedArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryParticipantEarnedRewardsDetailsArgs = {
  fundraiserId: Scalars['String'];
  userId: Scalars['Int'];
};


export type QueryParticipantGroupArgs = {
  campaignId: Scalars['String'];
  userId: Scalars['Int'];
};


export type QueryParticipantGuardianEmailQueryArgs = {
  userId: Scalars['Int'];
};


export type QueryParticipantRewardsDetailsArgs = {
  fundraiserId: Scalars['String'];
  userId: Scalars['Int'];
};


export type QueryParticipantsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  participantId?: InputMaybe<Scalars['Int']>;
};


export type QueryParticipantSsoIdArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryParticipantTextTemplateArgs = {
  fundraiserId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryParticipantTopDonationArgs = {
  fundraiserId: Scalars['String'];
  participantId: Scalars['String'];
};


export type QueryPayoutsArgs = {
  campaignId: Scalars['Int'];
};


export type QueryPrefundArgs = {
  fundraiserId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPrefundsArgs = {
  fundraiser?: InputMaybe<FundraiserSearchParams>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<OrganizationSearchParams>;
  status?: InputMaybe<Array<InputMaybe<Fundraiser_Status>>>;
};


export type QueryPreparationArgs = {
  input?: InputMaybe<GetPreparationByIdInput>;
};


export type QueryPreparationReportSheetsArgs = {
  input?: InputMaybe<CommonSheetFiltersInput>;
};


export type QueryPrimaryGroupLeaderArgs = {
  campaignId: Scalars['String'];
};


export type QueryPublicFundraiserDataArgs = {
  fundraiserId?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
};


export type QueryPublicParticipantDataArgs = {
  userId: Scalars['Int'];
};


export type QueryRolesArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySchoolInfoArgs = {
  input?: InputMaybe<GetSchoolInfoByIdInput>;
};


export type QuerySearchDriveCampaignsArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  campaignName?: InputMaybe<Scalars['String']>;
  campaignStatuses?: InputMaybe<Array<CampaignStatus>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  fundraiserId?: InputMaybe<Scalars['Int']>;
  hasIncentive?: InputMaybe<Scalars['Boolean']>;
  isPendingSettlement?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxTeamSize?: InputMaybe<Scalars['Int']>;
  maxTotalRaisedCents?: InputMaybe<Scalars['Int']>;
  minTeamSize?: InputMaybe<Scalars['Int']>;
  minTotalRaisedCents?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationTypes?: InputMaybe<Array<Scalars['String']>>;
  salesrepIds?: InputMaybe<Array<Scalars['Int']>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<SortField>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  territories?: InputMaybe<Array<Scalars['String']>>;
  usStates?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchDriveOrganizationsByNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationName?: InputMaybe<Scalars['String']>;
};


export type QuerySeasonArgs = {
  input?: InputMaybe<SeasonByIdInput>;
};


export type QuerySeasonByYearAndTeamArgs = {
  input?: InputMaybe<SeasonByYearTeamInput>;
};


export type QuerySeasonEventWizardArgs = {
  input?: InputMaybe<SeasonEventWizardInput>;
};


export type QueryShipmentsArgs = {
  externalId?: InputMaybe<ShipmentInput>;
};


export type QuerySpendBudgetsArgs = {
  groupId?: InputMaybe<Scalars['String']>;
};


export type QuerySpendBudgetsSummaryArgs = {
  groupId?: InputMaybe<Scalars['String']>;
};


export type QuerySpendCategoriesArgs = {
  filterBy?: InputMaybe<CategoryFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
};


export type QuerySpendDataForHomeArgs = {
  udid: Scalars['String'];
};


export type QuerySpendGroupByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpendGroupRosterByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpendGroupRostersArgs = {
  filterBy?: InputMaybe<GroupRosterFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
};


export type QuerySpendInvitesArgs = {
  filterBy?: InputMaybe<InviteFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
};


export type QuerySpendInvoiceByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpendInvoicesArgs = {
  filterBy?: InputMaybe<InvoiceFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySpendInvoicesExportArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  playerFilter?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};


export type QuerySpendInvoicesMockArgs = {
  filterBy?: InputMaybe<InvoiceFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySpendOrganizationByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpendOrganizationsArgs = {
  filterBy?: InputMaybe<OrganizationFilterEnum>;
};


export type QuerySpendPaymentScheduleByIdArgs = {
  id: Scalars['String'];
};


export type QuerySpendPaymentSchedulesArgs = {
  groupIdOrSeasonId?: InputMaybe<Scalars['String']>;
};


export type QuerySpendRoleCurrentArgs = {
  sessionId: Scalars['String'];
};


export type QuerySpendRostersArgs = {
  filterBy?: InputMaybe<RosterFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
};


export type QuerySpendTransactionsArgs = {
  filterBy?: InputMaybe<TransactionFilterEnum>;
  filterValue?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySpendTransactionsExportArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
};


export type QuerySponsorArgs = {
  id: Scalars['String'];
};


export type QuerySponsorAssetsArgs = {
  orderBy?: InputMaybe<OrderByClauseGroups>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseAssets>;
};


export type QuerySponsorCartAssetArgs = {
  assetId: Scalars['String'];
  sponsorId: Scalars['String'];
};


export type QuerySponsorCartAssetsArgs = {
  sponsorId: Scalars['String'];
};


export type QuerySponsorCountForAssetsArgs = {
  schoolId: Scalars['String'];
};


export type QuerySponsorDataForHomeArgs = {
  orgId: Scalars['String'];
};


export type QuerySponsorDistrictArgs = {
  id: Scalars['String'];
};


export type QuerySponsorDistrictsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySponsoredSponsorshipGroupsArgs = {
  name: Scalars['String'];
  orderBy?: InputMaybe<OrderByClauseGroups>;
  skip?: InputMaybe<Scalars['Int']>;
  sponsorId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySponsorEnabledPaymentMethodArgs = {
  sponsorId: Scalars['String'];
};


export type QuerySponsorInvitationCheckByMailIdArgs = {
  email: Scalars['String'];
  sponsorshipGroupId: Scalars['String'];
};


export type QuerySponsorPackageDetailsArgs = {
  packageId: Scalars['String'];
};


export type QuerySponsorPaymentMethodsArgs = {
  sponsorId: Scalars['String'];
};


export type QuerySponsorsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sponsorshipGroupId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseSponsors>;
};


export type QuerySponsorSchoolArgs = {
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySponsorSchoolProgramArgs = {
  id: Scalars['String'];
};


export type QuerySponsorSchoolProgramsArgs = {
  from?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySponsorSchoolsArgs = {
  from?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySponsorSchoolUsersArgs = {
  schoolId: Scalars['String'];
};


export type QuerySponsorshipGroupArgs = {
  id: Scalars['String'];
};


export type QuerySponsorshipGroupAccountLinkArgs = {
  sponsorshipGroupId: Scalars['String'];
};


export type QuerySponsorshipGroupActivityArgs = {
  id: Scalars['String'];
};


export type QuerySponsorshipGroupAssetArgs = {
  id: Scalars['String'];
};


export type QuerySponsorshipGroupAssetsArgs = {
  orderBy?: InputMaybe<OrderByClauseGroups>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseAssets>;
};


export type QuerySponsorshipGroupAssetTypesArgs = {
  where?: InputMaybe<WhereClauseAssetTypes>;
};


export type QuerySponsorshipGroupAssetTypeValuesArgs = {
  assetTypeId: Scalars['String'];
};


export type QuerySponsorshipGroupInvitesArgs = {
  orderBy?: InputMaybe<OrderByClauseInvites>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseInvites>;
};


export type QuerySponsorshipGroupOrdersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseSponsorshipGroupOrders>;
};


export type QuerySponsorshipGroupOrdersStatsArgs = {
  sponsorshipGroupId: Scalars['String'];
};


export type QuerySponsorshipGroupPricingForCurrentYearArgs = {
  schoolId: Scalars['String'];
};


export type QuerySponsorshipGroupPrimaryContactArgs = {
  sponsorshipGroupId?: InputMaybe<Scalars['String']>;
};


export type QuerySponsorshipGroupsArgs = {
  orderBy?: InputMaybe<OrderByClauseGroups>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClauseSponsorShipGroups>;
};


export type QuerySponsorshipHistoryArgs = {
  sponsorId: Scalars['String'];
  sponsorshipGroupId: Scalars['String'];
};


export type QuerySponsorshipOrdersArgs = {
  name: Scalars['String'];
  orderBy?: InputMaybe<OrderByPackages>;
  skip?: InputMaybe<Scalars['Int']>;
  sponsorId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClausePackages>;
};


export type QuerySponsorshipPackagesArgs = {
  name: Scalars['String'];
  orderBy?: InputMaybe<OrderByPackages>;
  skip?: InputMaybe<Scalars['Int']>;
  sponsorId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereClausePackages>;
};


export type QuerySponsorStateArgs = {
  id: Scalars['String'];
};


export type QuerySponsorSubDistrictArgs = {
  id: Scalars['String'];
};


export type QuerySponsorSubDistrictsArgs = {
  from?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySponsorUsersArgs = {
  sponsorId: Scalars['String'];
};


export type QueryStoreArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreBestSellerArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreDataForHomeArgs = {
  fundraiserId?: InputMaybe<Array<Scalars['Int']>>;
  uEmail: Scalars['String'];
};


export type QueryStoreFilterArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  scopeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryStoreManagersArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStoreNewActivityFlagArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreNewOrdersCheckArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreOrderArgs = {
  orderId: Scalars['Int'];
};


export type QueryStoreOrdersByStoreArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreOrdersFilterArgs = {
  input?: InputMaybe<StoreFilterInput>;
};


export type QueryStoreOrdersSummaryArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStoreParticipantsArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStorePointActivityArgs = {
  scopeId: Scalars['Int'];
};


export type QueryStorePointsActivityFilterArgs = {
  input?: InputMaybe<StorePointsActivityFilter>;
};


export type QueryStorePointsEarnedGraphArgs = {
  input?: InputMaybe<StorePointsEarned>;
};


export type QueryStoreProductArgs = {
  productId: Scalars['Int'];
};


export type QueryStoresArgs = {
  campaignIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStoreSalesGraphArgs = {
  input?: InputMaybe<StoreSalesReport>;
};


export type QueryStoresOrderDetailsArgs = {
  dateSearch?: InputMaybe<Scalars['Int']>;
  scopeIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStoreTicketsArgs = {
  scopeId: Scalars['Int'];
};


export type QueryTeamArgs = {
  input?: InputMaybe<TeamByCodeInput>;
};


export type QueryTeamOfficialsArgs = {
  input?: InputMaybe<OfficialByIdInput>;
};


export type QueryTeamOrgSchedulesArgs = {
  input?: InputMaybe<CommonSchedulesFiltersInput>;
};


export type QueryTeamPreparationsArgs = {
  input?: InputMaybe<PreparationByIdInput>;
};


export type QueryTeamWorkersArgs = {
  input?: InputMaybe<WorkerByIdInput>;
};


export type QueryTwispCardBalancesArgs = {
  index?: InputMaybe<TwispCardBalances_Indexes>;
  limit?: InputMaybe<Scalars['Int32']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Sort>;
  where?: InputMaybe<Where>;
};


export type QueryTwispCardsArgs = {
  index?: InputMaybe<TwispCards_Indexes>;
  limit?: InputMaybe<Scalars['Int32']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Sort>;
  where?: InputMaybe<Where>;
};


export type QueryTwispStripeHooksArgs = {
  index?: InputMaybe<TwispStripeHooks_Indexes>;
  limit?: InputMaybe<Scalars['Int32']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Sort>;
  where?: InputMaybe<Where>;
};


export type QueryTwispTransactionsArgs = {
  index?: InputMaybe<TwispTransactions_Indexes>;
  limit?: InputMaybe<Scalars['Int32']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Sort>;
  where?: InputMaybe<Where>;
};


export type QueryUnconfirmedEventsArgs = {
  input?: InputMaybe<UnconfirmedEventsFiltersInput>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryUserAssociationsArgs = {
  id: Scalars['ID'];
  product: Product;
};


export type QueryUserFittingArgs = {
  userID: Scalars['ID'];
};


export type QueryUserPermissionsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryUserPublicArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  isInternal?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  snapRaiseId?: InputMaybe<Scalars['Int']>;
  snapSpendId?: InputMaybe<Scalars['Int']>;
};


export type QueryUserSponsorArgs = {
  userId: Scalars['String'];
};


export type QueryUserSponsorSchoolArgs = {
  userId: Scalars['String'];
};


export type QueryVaultAccountStatusArgs = {
  accountId: Scalars['ID'];
};


export type QueryVaultCardArgs = {
  id: Scalars['String'];
};


export type QueryVaultKybArgs = {
  id: Scalars['ID'];
};


export type QueryVaultKycArgs = {
  id: Scalars['ID'];
};


export type QueryVaultVgsValueArgs = {
  value: Scalars['String'];
};


export type QueryVehicleArgs = {
  input?: InputMaybe<GetVehicleByIdInput>;
};


export type QueryWorkerPoolByIdArgs = {
  input?: InputMaybe<GetWorkerPoolByIdInput>;
};

export type AuthenticationFlow = {
  __typename?: 'AuthenticationFlow';
  name?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type CommonSchedulesFiltersInput = {
  activity?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  facilities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  homeAway?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opponents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleType?: InputMaybe<Scalars['String']>;
};

export type CommonSchedules = {
  __typename?: 'CommonSchedules';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  bus_departure_location?: Maybe<Scalars['String']>;
  bus_early_dismissal_time?: Maybe<Scalars['String']>;
  bus_estimated_return_time?: Maybe<Scalars['String']>;
  bus_time?: Maybe<Scalars['String']>;
  cancellation_status?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  opponent?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type CampaignDates = {
  __typename?: 'CampaignDates';
  endDateTime: Scalars['String'];
  isAllDay?: Maybe<Scalars['Boolean']>;
  startDateTime: Scalars['String'];
};

/** Resigned campaigns */
export type CampaignHistoryList = {
  __typename?: 'CampaignHistoryList';
  CampaignHistoryEndDate?: Maybe<Scalars['String']>;
  CampaignHistorySlug?: Maybe<Scalars['String']>;
  CampaignHistoryStartDate?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  campaignTotalRaised?: Maybe<Scalars['Int']>;
};

export type CampaignKyc = {
  __typename?: 'CampaignKyc';
  status?: Maybe<CampaignKycStatusEnum>;
};

export enum CampaignKycStatusEnum {
  ActionNeeded = 'ACTION_NEEDED',
  Pending = 'PENDING',
  Unsubmitted = 'UNSUBMITTED',
  Verified = 'VERIFIED'
}

/** CampaignMembership is our way of securing information based on a users membership type. When a user queries campaignMemberships they can get information on their memberships based on who they are as defined in the JWT. Example of how to use:https://www.notion.so/snap-mobile/Campaign-1b4c4a055bc84aaf8290f078f57a5193 */
export type CampaignMembership = AdminCampaign | GroupLeaderCampaign | ParticipantCampaign | SupporterCampaign;

/** See CampaignMembership for details */
export type AdminCampaign = {
  __typename?: 'AdminCampaign';
  id: Scalars['ID'];
};

/** See CampaignMembership for details */
export type GroupLeaderCampaign = {
  __typename?: 'GroupLeaderCampaign';
  basicStatus: BasicCampaignStatus;
  donationLink: Scalars['String'];
  goalInDollars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isCocoach: Scalars['Boolean'];
  joinCode?: Maybe<Scalars['String']>;
  /** Getting Kyc status adds time to your query **expensive** */
  kyc?: Maybe<CampaignKyc>;
  name: Scalars['String'];
  /** Primary group leader */
  primary?: Maybe<PrimaryGroupLeader>;
  /** Getting roster adds time to your query */
  roster?: Maybe<Array<Maybe<Roster>>>;
  status: CampaignStatus;
  teamSize?: Maybe<Scalars['Int']>;
  totalCentsRaised?: Maybe<Scalars['Int']>;
  whyDonateText?: Maybe<Scalars['String']>;
};

export enum BasicCampaignStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Upcoming = 'UPCOMING'
}

/** Primary Group Leader The primary group leader is the main contact for a fundraiser The association is not direct with a user but made through email */
export type PrimaryGroupLeader = {
  __typename?: 'PrimaryGroupLeader';
  /** Signifies user is primary group leader. Extra query. */
  currentUserIsPrimary: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Roster = {
  __typename?: 'Roster';
  id?: Maybe<Scalars['ID']>;
  members?: Maybe<Array<Maybe<RosterMember>>>;
  name?: Maybe<Scalars['String']>;
};

export type RosterMember = {
  __typename?: 'RosterMember';
  association?: Maybe<CampaignMemberAssociation>;
  id?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['String']>;
  wasDeleted?: Maybe<Scalars['Boolean']>;
};

export enum CampaignMemberAssociation {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Cocoach = 'COCOACH',
  Coparticipant = 'COPARTICIPANT',
  Participant = 'PARTICIPANT',
  Supporter = 'SUPPORTER'
}

export enum CampaignStatus {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Archive = 'ARCHIVE',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Final = 'FINAL',
  PendingApproval = 'PENDING_APPROVAL',
  Settled = 'SETTLED'
}

/** See CampaignMembership for details */
export type ParticipantCampaign = {
  __typename?: 'ParticipantCampaign';
  basicStatus: BasicCampaignStatus;
  campaignDates?: Maybe<CampaignDates>;
  donationsRaised?: Maybe<ParticipantDonationsRaised>;
  /** Getting donor email addresses adds time to your query */
  donorEmailAddresses?: Maybe<DonorEmailAddresses>;
  donorEmailData?: Maybe<Array<Maybe<DonorEmailData>>>;
  donorPersonListEntries?: Maybe<Array<Maybe<DonorPersonListEntry>>>;
  /** Getting donor phone numbers adds time to your query */
  donorPhoneNumbers?: Maybe<Array<Maybe<DonationInviteSmsData>>>;
  galleryItems?: Maybe<GalleryItems>;
  group?: Maybe<ParticipantGroup>;
  id: Scalars['ID'];
  isCoparticipant?: Maybe<Scalars['Boolean']>;
  isTopEarner: Scalars['Boolean'];
  joinCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  newStack_participantFundraiserLink?: Maybe<Scalars['String']>;
  otk?: Maybe<Array<Maybe<OtkParticipantData>>>;
  participantGoal?: Maybe<Scalars['Int']>;
  participantGuardianEmails?: Maybe<ParticipantGuardianEmail>;
  participantRewardsData?: Maybe<Array<Maybe<ParticipantRewardsData>>>;
  primaryColor: Scalars['String'];
  raiseUserId?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  status: CampaignStatus;
  userFitting?: Maybe<UserFitting>;
};

export type ParticipantDonationsRaised = {
  __typename?: 'ParticipantDonationsRaised';
  numberOfDonations: Scalars['Int'];
  subtotalCents: Scalars['Int'];
};

export type DonorEmailAddresses = {
  __typename?: 'DonorEmailAddresses';
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DonorEmailData = {
  __typename?: 'DonorEmailData';
  deliveryStatus?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  followUpNumber?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type DonorPersonListEntry = {
  __typename?: 'DonorPersonListEntry';
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DonationInviteSmsData = {
  __typename?: 'DonationInviteSMSData';
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
  status: Scalars['String'];
};

export type GalleryItems = {
  __typename?: 'GalleryItems';
  campaignLogo?: Maybe<Scalars['String']>;
  campaignLogoThumb?: Maybe<Scalars['String']>;
  carouselItems?: Maybe<Array<Maybe<CarouselItem>>>;
};

export type CarouselItem = {
  __typename?: 'CarouselItem';
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ParticipantGroup = {
  __typename?: 'ParticipantGroup';
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type OtkParticipantData = {
  __typename?: 'OtkParticipantData';
  id: Scalars['ID'];
  incentives?: Maybe<OtkProduct>;
  size?: Maybe<Scalars['String']>;
};

export type OtkProduct = {
  __typename?: 'OtkProduct';
  fitting?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** This is the base image for the otk item. It will not include the fundraiser logo. */
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  sizes?: Maybe<Scalars['String']>;
};

export type ParticipantGuardianEmail = {
  __typename?: 'ParticipantGuardianEmail';
  guardianEmail?: Maybe<Scalars['String']>;
  secondaryGuardianEmail?: Maybe<Scalars['String']>;
};

export type ParticipantRewardsData = {
  __typename?: 'ParticipantRewardsData';
  id?: Maybe<Scalars['Int']>;
  incentives?: Maybe<FundraiserRewardsProduct>;
  size?: Maybe<Scalars['String']>;
};

export type FundraiserRewardsProduct = {
  __typename?: 'FundraiserRewardsProduct';
  default?: Maybe<Scalars['Boolean']>;
  fitting?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sizes?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
};

export type UserFitting = {
  __typename?: 'UserFitting';
  fitting?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** See CampaignMembership for details */
export type SupporterCampaign = {
  __typename?: 'SupporterCampaign';
  id: Scalars['ID'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortField {
  ClosedStatus = 'CLOSED_STATUS',
  DaysLeft = 'DAYS_LEFT',
  EndDate = 'END_DATE',
  KycStatus = 'KYC_STATUS',
  Name = 'NAME',
  Participation = 'PARTICIPATION',
  Preload = 'PRELOAD',
  SettlementDetails = 'SETTLEMENT_DETAILS',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TotalRaised = 'TOTAL_RAISED'
}

export type CampaignList = {
  __typename?: 'CampaignList';
  count?: Maybe<Scalars['Int']>;
  list: Array<Maybe<Campaign>>;
  offset?: Maybe<Scalars['Int']>;
};

/** @deprecated: will be merged with DriveCampaign instead This type is for Drive's Campaign Management. Users must have the Drive's permission to access any data. We are working on migrating this type to DriveCampaign. */
export type Campaign = {
  __typename?: 'Campaign';
  /** Account Manager of Campaign */
  accountManager?: Maybe<AccountManager>;
  /** Activity type of campaign. e.g. 'football', 'baseball', etc. */
  activityType?: Maybe<Scalars['String']>;
  /** URL for Generated Report of (Active) Campaign */
  campaignActiveReportUrl?: Maybe<Scalars['String']>;
  /** City + State string of campaign. e.g. 'Dallas, TX' */
  campaignTerritory?: Maybe<Scalars['String']>;
  /** Donations statistics of campaign. All values will be 0 if campaign is 'upcoming' */
  donations?: Maybe<Donations>;
  /** Participant email delivery info of campaigns */
  emails?: Maybe<EmailsInfo>;
  /** End date of fundraiser */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Entity ID of campaign. This ID used to obtain financial/payment info */
  entityId?: Maybe<Scalars['Int']>;
  /** Date when campaign is finalized */
  finalizedDate?: Maybe<Scalars['DateTime']>;
  /** Shipping status for gear items. Values are 'delivered','pre_transit','in_transit','failure','available_for_pickup','unknown','out_for_delivery', 'return_to_sender','cancelled','error' */
  gearStatus?: Maybe<Scalars['String']>;
  /** Group Leader */
  groupLeader?: Maybe<GroupLeader>;
  /** Deal ID of campaign in Hubspot. */
  hubspotId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Cover image of campaign */
  image?: Maybe<Scalars['String']>;
  /** Initial goal amount to fundraise in cents */
  initialGoalCents?: Maybe<Scalars['Int']>;
  /** Link to invite participants to the campaign */
  inviteParticipantUrl?: Maybe<Scalars['String']>;
  /** Unique join-code of campaign */
  joinCode?: Maybe<Scalars['Int']>;
  /** URL for the fundraiser KYC Form. */
  kycFormUrl?: Maybe<Scalars['String']>;
  /** Campaign kyc status */
  kycStatus?: Maybe<CampaignKycStatusResult>;
  /** Mailing address of campaign. */
  mailingAddress?: Maybe<Scalars['String']>;
  /** MDM Contact of Campaign */
  mdm?: Maybe<MdmDetails>;
  name?: Maybe<Scalars['String']>;
  /** Statistics info of campaign participants */
  participants?: Maybe<ParticipantsInfo>;
  /** Last withdrawal payment status. Values are 'Initializing', 'Processing', 'Transferred', 'Cut', 'Deposited', 'Expired' or 'Failed' */
  paymentStatus?: Maybe<Scalars['String']>;
  /** Payment type when campaign finalized. Values are 'Check to Office', 'Check to Salesrep', 'Check to Fundraiser', or 'Direct Deposit'. */
  paymentType?: Maybe<Scalars['String']>;
  /** Base64 generated CSV file for preload emails report of event */
  preloadReport?: Maybe<Scalars['String']>;
  /** Download URL for Final Receipt (PDF) of settled campaigns */
  receiptDownloadUrl?: Maybe<Scalars['String']>;
  /** Settlement Details for Closed Campaigns */
  settlementDetails?: Maybe<SettlementDetails>;
  /** Settlement Confirmation Status for Closed Campaigns. Values are 'UNSUBMITTED', 'IN_REVIEW' and 'VERIFIED' */
  settlementStatus?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** Start date of fundraiser */
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  /** Size of team/group of campaign */
  teamSize?: Maybe<Scalars['Int']>;
  /** Not in-use. Deprecated */
  testEmails?: Maybe<Scalars['String']>;
  /** Total amount raised in cents */
  totalRaisedCents?: Maybe<Scalars['Int']>;
  /** The total raised combined this organization has previously ran campaigns */
  totalRaisedHistory?: Maybe<Scalars['Int']>;
  /** Tracking link for shipping gear items. */
  trackingLink?: Maybe<Scalars['String']>;
};

export type AccountManager = DriveUser & {
  __typename?: 'AccountManager';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type DriveUser = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** Donation Statistics. Will change name to CampaignDonationStats later. */
export type Donations = {
  __typename?: 'Donations';
  /** Total of distinct donors in campaigns */
  AskedToShare?: Maybe<Scalars['Int']>;
  /** Total count of donations in campaign */
  count?: Maybe<Scalars['Int']>;
  /** Total donation amount in cents raised through email */
  emailTotal?: Maybe<Scalars['Int']>;
  /** Total donation amount in cents raised other methods outside text, email and social */
  extraTotal?: Maybe<Scalars['Int']>;
  /** Total of donation amount in cents raised through forward to friends. */
  fowardTotal?: Maybe<Scalars['Int']>;
  /** Total quantity of gear items purchased in campaign. */
  gearAdded?: Maybe<Scalars['Int']>;
  /** Total count of distinct donors that purchased gears. */
  gearPurchased?: Maybe<Scalars['Int']>;
  /** Total of purchase amount in cents of gear (OTK) items */
  gearTotal?: Maybe<Scalars['Int']>;
  /** Total donation amounts in cents through retaining supporters from previous closed campaign. Share Type is 'reisgn_a' or 'resign_b' */
  legacySupporters?: Maybe<Scalars['Int']>;
  /** Total count of distinct donors who are new and donated campaigns through share-type 'supporter_referral' */
  newSupporters?: Maybe<Scalars['Int']>;
  /** Total count of donors who are retaining supporters from previous closed campaign. Share Type is 'reisgn_a' or 'resign_b' */
  pastSupporters?: Maybe<Scalars['Int']>;
  /** Total donation amount in cents raised through social media */
  socialTotal?: Maybe<Scalars['Int']>;
  /** Total donation amount in cents raised through sms/text */
  textTotal?: Maybe<Scalars['Int']>;
};

/** Information of a emails for a camapgin */
export type EmailsInfo = {
  __typename?: 'EmailsInfo';
  /** Total emails bounced back due to failed delivery */
  bounced?: Maybe<Scalars['Int']>;
  /** Total emails loaded by particpants */
  loaded?: Maybe<Scalars['Int']>;
  /** The schedule (timezone-sensitive) thatthe emails are scheduled to release */
  scheduledReleaseDate?: Maybe<ScheduledReleaseInfo>;
  /** Total emails sent */
  sent?: Maybe<Scalars['Int']>;
  /** The datetime the emails were sent out */
  sentAt?: Maybe<Scalars['DateTime']>;
};

/** Information of a emails scheduled for cron jobs */
export type ScheduledReleaseInfo = {
  __typename?: 'ScheduledReleaseInfo';
  /** The date and time for release */
  date?: Maybe<Scalars['DateTime']>;
  /** The timezone for scheduled release */
  timezone?: Maybe<Scalars['String']>;
};

export type GroupLeader = {
  __typename?: 'GroupLeader';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CampaignKycStatusResult = {
  __typename?: 'CampaignKycStatusResult';
  data?: Maybe<CampaignKycStatus>;
  type?: Maybe<CampaignKycType>;
};

/** Fixed statuses for a campaigns kyc */
export enum CampaignKycStatus {
  ActionRequired = 'action_required',
  InReview = 'in_review',
  RequireDocs = 'require_docs',
  Unsubmitted = 'unsubmitted',
  Unverified = 'unverified',
  Verified = 'verified'
}

/** Fixed type for a campaigns kyc */
export enum CampaignKycType {
  Stripe = 'stripe',
  Wepay = 'wepay'
}

export type MdmDetails = DriveUser & {
  __typename?: 'MDMDetails';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ParticipantsInfo = {
  __typename?: 'ParticipantsInfo';
  count?: Maybe<Scalars['Int']>;
  loggedInCount?: Maybe<Scalars['Int']>;
  withAtLeastOneDonation?: Maybe<Scalars['Int']>;
  withAtLeastTwentyInvites?: Maybe<Scalars['Int']>;
};

/** Settlement details for closed campaign. */
export type SettlementDetails = {
  __typename?: 'SettlementDetails';
  /** The amount in cents that campaigns was advanced in Wallet. */
  advanceAmount?: Maybe<Scalars['Int']>;
  /** Address to send out check to */
  checkingAddress?: Maybe<Scalars['String']>;
  /** The type of snap fee being collected. e.g. 'standard', '1+1', '20%/15%', etc. */
  feeType?: Maybe<Scalars['String']>;
  /** Total cost of incentives in cents */
  gearCost?: Maybe<Scalars['Int']>;
  /** Code to build logo */
  incLogo?: Maybe<Scalars['String']>;
  /** Primary color to build logo */
  incLogoPrimaryColor?: Maybe<Scalars['String']>;
  /** Script to build logo */
  incLogoScript?: Maybe<Scalars['String']>;
  /** Secondary color to build logo */
  incLogoSecondaryColor?: Maybe<Scalars['String']>;
  /** Filename of Logo of Group of Campaign */
  logoImage?: Maybe<Scalars['String']>;
  /** The amount in cents that campaigns was manual-advanced in Raise. */
  manualAdvanceAmount?: Maybe<Scalars['Int']>;
  /** Net raised amount in cents. Equals totalRaised minus snapFee and adds the otkBonus. It is the amount client received in their check/deposit. */
  netRaisedTotal?: Maybe<Scalars['Int']>;
  /** Notes of campaign */
  notes?: Maybe<Scalars['String']>;
  /** Legal Name of Organization */
  organizationLegalName?: Maybe<Scalars['String']>;
  /** TIN of Organization */
  organizationTin?: Maybe<Scalars['String']>;
  /** Total bonus amount that team will receive through otk purchase cost (usually 10%) in cents. */
  otkBonus?: Maybe<Scalars['Int']>;
  /** Link to OTK Logo */
  otkLogoUrl?: Maybe<Scalars['String']>;
  /** Percentage of participation of campaign */
  participationPercent?: Maybe<Scalars['Int']>;
  /** Notes for settlement for this campaign */
  settlementNotes?: Maybe<Scalars['String']>;
  /** Default Shipping address to send out gears/merchandise/check */
  shippingAddress?: Maybe<Scalars['String']>;
  /** Total Fee in cents that Raise collects from campaigns */
  snapFee?: Maybe<Scalars['Int']>;
};

export type CampaignSearchFilter = {
  __typename?: 'CampaignSearchFilter';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Collection (key/values) of saved search criteria. */
  filterCriteria?: Maybe<Scalars['JSON']>;
  /** Name of the saved search filter. */
  filterName?: Maybe<Scalars['String']>;
  /** ID of saved search filters. */
  id?: Maybe<Scalars['Int']>;
};

export type Consumer = {
  __typename?: 'Consumer';
  accessBy?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['String'];
  inApps: Scalars['Boolean'];
  logo: Scalars['String'];
  mask: Scalars['String'];
  modal?: Maybe<ConsumerModal>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ConsumerModal = {
  __typename?: 'ConsumerModal';
  descriptions: Array<Maybe<Scalars['String']>>;
  header: Scalars['String'];
};

export type PrefundList = {
  __typename?: 'PrefundList';
  list: Array<Prefund>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type Prefund = {
  __typename?: 'Prefund';
  card?: Maybe<Card>;
  cardType?: Maybe<Card_Type>;
  createdAt?: Maybe<Scalars['String']>;
  fundraiser: Fundraiser;
  id: Scalars['ID'];
  organization: Organization;
  prefundAmount: Scalars['Int'];
  shippingService?: Maybe<Shipping_Service>;
  status: Prefund_Status;
};

/** Owned by vault Extended by wallet Card issued by vault via Stripe */
export type Card = {
  __typename?: 'Card';
  cardholderId?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<VaultCardType>;
  cvv?: Maybe<Scalars['String']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  gatewayId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last4?: Maybe<Scalars['String']>;
  metadata?: Maybe<VaultCardMetadata>;
  spendingLimitAmount?: Maybe<Scalars['Int']>;
  spendingLimitInterval?: Maybe<VaultSpendingLimitInterval>;
  status?: Maybe<VaultCardStatus>;
  walletEverActivated?: Maybe<Scalars['Boolean']>;
};

/** Is the card physical (needs to mailed out) or virtual */
export enum VaultCardType {
  Physical = 'physical',
  Virtual = 'virtual'
}

/** Additional data passed into the Stripe api Can be read in Stripe dashboard */
export type VaultCardMetadata = {
  __typename?: 'VaultCardMetadata';
  description?: Maybe<Scalars['String']>;
  walletId?: Maybe<Scalars['String']>;
};

/** The interval that the spending limit interval of a card is reset */
export enum VaultSpendingLimitInterval {
  AllTime = 'all_time',
  Daily = 'daily',
  Monthly = 'monthly',
  PerAuthorization = 'per_authorization',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

/** Current status of card */
export enum VaultCardStatus {
  Active = 'active',
  /** To deactivate a card set it to canceled */
  Canceled = 'canceled',
  /** Cards ship inactive */
  Inactive = 'inactive'
}

export enum Card_Type {
  Physical = 'physical',
  Virtual = 'virtual'
}

export type Fundraiser = {
  __typename?: 'Fundraiser';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['Int']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  netRaised?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  prefund?: Maybe<Prefund>;
  salesRep?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<Fundraiser_Status>;
  totalRaised?: Maybe<Scalars['Int']>;
};

export type Organization = {
  __typename?: 'Organization';
  address?: Maybe<Scalars['String']>;
  altName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inviteEmail?: Maybe<Scalars['String']>;
  last4Tin?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<FinancialAddress>;
  modId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nces?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<FinancialAddress>;
  region?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type FinancialAddress = {
  __typename?: 'FinancialAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum Fundraiser_Status {
  Active = 'active',
  Approved = 'approved',
  Archive = 'archive',
  Closed = 'closed',
  Deleted = 'deleted',
  Final = 'final',
  PendingApproval = 'pending_approval',
  Settled = 'settled'
}

export enum Shipping_Service {
  Express = 'express',
  Priority = 'priority',
  Standard = 'standard'
}

export enum Prefund_Status {
  Active = 'Active',
  Closed = 'Closed',
  Pending = 'Pending'
}

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Information of custom email templates */
export type CustomContactTemplates = {
  __typename?: 'CustomContactTemplates';
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type GetDailyCalendarEventsByDateInput = {
  eventDate: Scalars['Date'];
};

export type DailyCalendarEvent = {
  __typename?: 'DailyCalendarEvent';
  activity?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  departure_location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  early_dismissal_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  estimated_return_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['Date']>;
  eventId?: Maybe<Scalars['Int']>;
  eventTransportDetails?: Maybe<Array<Maybe<EventTransportDetails>>>;
  location?: Maybe<Scalars['String']>;
  num_buses?: Maybe<Scalars['Int']>;
  officials?: Maybe<Array<Maybe<Official>>>;
  opponent?: Maybe<Scalars['String']>;
  preparations?: Maybe<Array<Maybe<Preparation>>>;
  schoolInfo?: Maybe<SchoolInfo>;
  season_team?: Maybe<Scalars['Int']>;
  season_years?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  workers?: Maybe<Array<Maybe<Worker>>>;
};

export type EventTransportDetails = {
  __typename?: 'EventTransportDetails';
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type Official = {
  __typename?: 'Official';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  duty?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars['Int']>;
  first_name?: Maybe<Scalars['String']>;
  home_phone?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last_name?: Maybe<Scalars['String']>;
  offic_id?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['String']>;
  pay_code?: Maybe<Scalars['String']>;
  received?: Maybe<Scalars['String']>;
  salary?: Maybe<Scalars['Float']>;
  ssn?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  voucher_number?: Maybe<Scalars['String']>;
  work_phone?: Maybe<Scalars['String']>;
  worker_name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  activity?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bus_fee?: Maybe<Scalars['Float']>;
  bus_time?: Maybe<Scalars['String']>;
  cancellation_status?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  conference?: Maybe<Scalars['String']>;
  conference_event_id?: Maybe<Scalars['Int']>;
  conference_id?: Maybe<Scalars['Int']>;
  confirmed?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  departure_location?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  early_dismissal_required?: Maybe<Scalars['String']>;
  early_dismissal_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  estimated_return_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['Date']>;
  event_id: Scalars['Int'];
  event_preparations_event_preparations_eventToevent?: Maybe<Array<Maybe<EventPreparations>>>;
  exists_in_mls?: Maybe<Scalars['Int']>;
  fee?: Maybe<Scalars['Float']>;
  g_s?: Maybe<Scalars['String']>;
  gate_revenue?: Maybe<Scalars['Float']>;
  headline?: Maybe<Scalars['String']>;
  impact_event?: Maybe<Scalars['String']>;
  lead?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  loss_points?: Maybe<Scalars['Int']>;
  num_buses?: Maybe<Scalars['Int']>;
  officials?: Maybe<Array<Maybe<Official>>>;
  opponent?: Maybe<Scalars['String']>;
  opponent_code?: Maybe<Scalars['String']>;
  opponent_score?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  prep_setup?: Maybe<Scalars['String']>;
  promote?: Maybe<Scalars['String']>;
  results?: Maybe<Scalars['String']>;
  revenue?: Maybe<Scalars['Float']>;
  rollover?: Maybe<Scalars['String']>;
  season_team?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['String']>;
  team_score?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tournament?: Maybe<Scalars['String']>;
  trans_id?: Maybe<Scalars['Int']>;
  transport_comments?: Maybe<Scalars['String']>;
  transportation?: Maybe<Scalars['String']>;
  update_at?: Maybe<Scalars['Date']>;
  web_dir?: Maybe<Scalars['String']>;
  win_points?: Maybe<Scalars['Int']>;
  workers?: Maybe<Array<Maybe<Worker>>>;
  years?: Maybe<Scalars['String']>;
};

export type EventPreparations = {
  __typename?: 'EventPreparations';
  comments?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['String']>;
};

export type Worker = {
  __typename?: 'Worker';
  duty?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  organization?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['String']>;
  pay_code?: Maybe<Scalars['String']>;
  pay_rate?: Maybe<Scalars['Float']>;
  salary?: Maybe<Scalars['Float']>;
  ssn?: Maybe<Scalars['String']>;
  woker_name?: Maybe<Scalars['String']>;
  worker_end_time?: Maybe<Scalars['String']>;
  worker_start_time?: Maybe<Scalars['String']>;
  worker_type?: Maybe<Scalars['String']>;
};

export type Preparation = {
  __typename?: 'Preparation';
  duty?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted?: Maybe<Scalars['Boolean']>;
  qty?: Maybe<Scalars['String']>;
};

export type SchoolInfo = {
  __typename?: 'SchoolInfo';
  ad?: Maybe<Scalars['String']>;
  ad_contract_signee?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  ccemail?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  conf_text_type?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_reminder?: Maybe<Scalars['String']>;
  email_reminder_officials?: Maybe<Scalars['String']>;
  email_reminder_workers?: Maybe<Scalars['String']>;
  enable_cc_email_as_origin?: Maybe<Scalars['String']>;
  enable_ml_updates?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mascot?: Maybe<Scalars['String']>;
  message_board_read_at?: Maybe<Scalars['Date']>;
  ml_key?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  principal?: Maybe<Scalars['String']>;
  school_timezone?: Maybe<Scalars['String']>;
  SchoolName?: Maybe<Scalars['String']>;
  secondary_ad_email?: Maybe<Scalars['String']>;
  secondary_ad_name?: Maybe<Scalars['String']>;
  signed_contract_notification?: Maybe<Scalars['String']>;
  ssn_on_file?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_org?: Maybe<Scalars['String']>;
  state_org_abbreviation?: Maybe<Scalars['String']>;
  use_security?: Maybe<Scalars['String']>;
  web_password?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type GetDailyCalendarPreparationsByEventInput = {
  event: Scalars['Int'];
};

export type DailyCalendarPreparation = {
  __typename?: 'DailyCalendarPreparation';
  comments?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['String']>;
};

export type DonationLevel = {
  __typename?: 'DonationLevel';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  level: DonationLevels;
  rewardDescription?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum DonationLevels {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export type DonationTopEarner = {
  __typename?: 'DonationTopEarner';
  participantID?: Maybe<Scalars['Int']>;
};

export type DonorPhoneNumbers = {
  __typename?: 'DonorPhoneNumbers';
  phone?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Campaign/Fundraiser details information. NOTE: In the future, we might merged with DriveCampaign or Campaign */
export type DriveCampaignDetails = {
  __typename?: 'DriveCampaignDetails';
  /** Account Balance of campaign. */
  accountBalance?: Maybe<AccountBalanceReturn>;
  /** The activity/sport of this campaign, e.g. 'football', 'wrestling', etc. */
  activityType?: Maybe<Scalars['String']>;
  /** The amount in cents that campaigns was advanced in Wallet. */
  advanceAmount?: Maybe<Scalars['Int']>;
  /** Bill type when settled/finalized. Values are 'invoice', 'regular' and 'default' */
  billType?: Maybe<Scalars['String']>;
  /** Credit Card Fee Payer. Values are 'customer' or 'snap'. */
  ccFeePayer?: Maybe<Scalars['String']>;
  /** Charge back fee in cents. The charge from payment processor when a donor cancels their donation through their bank instead of getting a refund from us directly. (usually $15 per) */
  chargebackFee?: Maybe<Scalars['Int']>;
  /** The statistic of a donation of campaigns */
  donationStats?: Maybe<DriveCampaignDonationStats>;
  /** The statistics of emails delivered/sent */
  emailDelivery?: Maybe<EmailsInfo>;
  /** The type of snap fee being collected. e.g. 'standard', '1+1', '20%/15%', etc. */
  feeType?: Maybe<Scalars['String']>;
  /** Total incentives price in cents. */
  gearCost?: Maybe<Scalars['Int']>;
  /** Group leader of a campaign */
  groupLeader?: Maybe<DriveGroupLeader>;
  id: Scalars['Int'];
  /** Cover Image for Campaign */
  image?: Maybe<Scalars['String']>;
  /** Goal of how much a fundraiser wants to raise */
  initialGoalCents?: Maybe<Scalars['Int']>;
  /** kyc processor. Values are 'wepay' or 'stripe' */
  kycProcessor?: Maybe<Scalars['String']>;
  /** kyc status of a campaign. Values are 'pending', 'active', 'inactive', etc. */
  kycStatus?: Maybe<Scalars['String']>;
  /** The address to ship the check for this campaign */
  mailingAddress?: Maybe<Scalars['String']>;
  /** The amount in cents that campaigns was manual-advanced in Raise. */
  manualAdvanceAmount?: Maybe<Scalars['Int']>;
  /** Net raised amount in cents. Equals totalRaised minus snapFee and adds the otkBonus. It is the amount client received in their check/deposit. */
  netRaisedTotal?: Maybe<Scalars['Int']>;
  /** Notes for settlement for this campaign */
  notes?: Maybe<Scalars['String']>;
  /** The legal name of a fundraisers organization */
  organizationLegalName?: Maybe<Scalars['String']>;
  /** The tin number of the organization */
  organizationTin?: Maybe<Scalars['String']>;
  /** Total bonus amount of otk in cents */
  otkBonus?: Maybe<Scalars['Int']>;
  /** The statistics of participants's activity of campaign */
  participantStats?: Maybe<DriveParticipantStats>;
  /** Processing Fee when settled/finalized. */
  processingFee?: Maybe<Scalars['Int']>;
  /** The date where the campaign has settle its payments from snap */
  settlementDate?: Maybe<Scalars['DateTime']>;
  /** How the funds has delivered to the organization. Values are 'check_fundraiser', 'check_salesrep', 'check_office' and 'direct_deposit' */
  settlementMethod?: Maybe<Scalars['String']>;
  /** The amount in cents collected as fee when a campaign ends based of the fee type */
  snapFee?: Maybe<Scalars['Float']>;
  /** Location of this fundraiser */
  territory?: Maybe<Scalars['String']>;
  /** The amount of purchase in cents. */
  totalPurchaseCents?: Maybe<Scalars['Int']>;
  /** Total raised of a fundraiser */
  totalRaisedCents?: Maybe<Scalars['Int']>;
  /** The total raised combined this organization has previously ran campaigns */
  totalRaisedHistory?: Maybe<Scalars['Int']>;
};

/** Account balance information */
export type AccountBalanceReturn = {
  __typename?: 'AccountBalanceReturn';
  /** Available balance in cents */
  available?: Maybe<Scalars['Int']>;
  /** Pending balance in cents */
  pending?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Pulls data on a campaigns donation broken down */
export type DriveCampaignDonationStats = {
  __typename?: 'DriveCampaignDonationStats';
  ccCoverageAmountCents?: Maybe<Scalars['Int']>;
  donationAppFeeCents?: Maybe<Scalars['Int']>;
  /** The amount that been raised */
  donationRaisedCents?: Maybe<Scalars['Int']>;
  /** The total count of donations */
  donationsCount?: Maybe<Scalars['Int']>;
  offlineTotalCents?: Maybe<Scalars['Int']>;
  onlineTotalCents?: Maybe<Scalars['Int']>;
  /** The count of participants */
  participantCount?: Maybe<Scalars['Int']>;
  /** The donated amount in cents that been raised by emails delivered */
  totalEmailDonations?: Maybe<Scalars['Int']>;
  /** The amount that been raised by miscellaneous forms */
  totalExtraDonations?: Maybe<Scalars['Int']>;
  /** The donated amount that been raised by sharing through social media */
  totalSocialDonations?: Maybe<Scalars['Int']>;
  /** The donated amount in cents that been raised by text message */
  totalTextDonations?: Maybe<Scalars['Int']>;
};

/** Group Leader information in Drive */
export type DriveGroupLeader = {
  __typename?: 'DriveGroupLeader';
  /** The full name of the group leader */
  name?: Maybe<Scalars['String']>;
};

/** Statistics information related to Participants in one campaign */
export type DriveParticipantStats = {
  __typename?: 'DriveParticipantStats';
  /** Count of participants who had logged in */
  loggedInCount?: Maybe<Scalars['Int']>;
  /** Count of participants with 20 emails sent */
  participantsWithAtLeastTwentyEmails?: Maybe<Scalars['Int']>;
  /** Percentage of active participants of campaign. */
  participationPercent?: Maybe<Scalars['Int']>;
  /** Count of participants with at least one donation */
  withAtLeastOneDonation?: Maybe<Scalars['Int']>;
};

/** Statistics for a set of campaigns in campaign-search. */
export type DriveCampaignSearchStatistics = {
  __typename?: 'DriveCampaignSearchStatistics';
  avgDonationDollars?: Maybe<Scalars['Float']>;
  avgEmailsDelivered?: Maybe<Scalars['Float']>;
  avgEmailsPerParticipant?: Maybe<Scalars['Float']>;
  avgRaisedDollarsPerCampaign?: Maybe<Scalars['Float']>;
  avgRaisedDollarsPerEmail?: Maybe<Scalars['Float']>;
  avgTeamSize?: Maybe<Scalars['Float']>;
  totalCampaign?: Maybe<Scalars['BigInt']>;
  totalCountDelivered?: Maybe<Scalars['BigInt']>;
  totalCountParticpants?: Maybe<Scalars['BigInt']>;
  totalDonations?: Maybe<Scalars['BigInt']>;
  totalRaisedByEmail?: Maybe<Scalars['Float']>;
  totalRaisedDollars?: Maybe<Scalars['Float']>;
};

/** Represents a Event object and its attributes */
export type DriveEvent = {
  __typename?: 'DriveEvent';
  /** List of messages in the activity feed. Order by posted ascending by default. */
  activityFeed?: Maybe<Array<Maybe<DriveEventActivityFeed>>>;
  /** Activity types for an event. e.g. `football`, 'basketball', etc. */
  activityTypes?: Maybe<Array<Scalars['String']>>;
  /** Event Agenda which include start-time/end-time of event dates. Should be empty is **agendaConfig.isSameTime** is true */
  agenda?: Maybe<Array<DriveEventAgendaItem>>;
  /** The configuration for agenda. Format as follows ```JSON { isSameTime: true, startTime: "09:00AM", endTime: "07:00PM" } ``` where **isSameTime** means all event dates will be occured at same **startTime** and **endTime**. If **isSameTime**, **startTime** and **endTime** should be filled-in */
  agendaConfig?: Maybe<Scalars['JSON']>;
  /** List of attendees. */
  attendees?: Maybe<Array<DriveEventAttendee>>;
  /** Booth information for an event. */
  booth?: Maybe<DriveEventBooth>;
  /** The user who is the clinic leader. */
  clinicLeader?: Maybe<User>;
  /** The user who created the event. */
  createdBy?: Maybe<User>;
  /** The description of an event. */
  description?: Maybe<Scalars['String']>;
  /** Indicator that event requires a door prize. */
  doorPrizedRequired?: Maybe<Scalars['Boolean']>;
  /** The end date of an event. */
  endDate: Scalars['String'];
  /** The hotel address for the attendees */
  hotelAddress?: Maybe<Scalars['String']>;
  /** The hotel name for the attendees */
  hotelName?: Maybe<Scalars['String']>;
  /** Url for hubspot link. */
  hubspotTrackingLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Notes associated for the event. */
  notes?: Maybe<Scalars['String']>;
  /** A indicator whether the event had been completed planning phase. */
  planningCompleted?: Maybe<Scalars['Boolean']>;
  /** Description for the sponsorship */
  sponsorDescription?: Maybe<Scalars['String']>;
  /** Indicator whether the door prize has been confirmed. */
  sponsorDoorPrized?: Maybe<Scalars['Boolean']>;
  /** The start date of an event. */
  startDate: Scalars['String'];
  /** The events status. */
  status: DriveEventStatus;
  /** The tier level for this event. Valid values is `1`, `2` and `3` */
  tier?: Maybe<Scalars['Int']>;
  /** The name of the event. */
  title: Scalars['String'];
  /** Venue location information for an event. */
  venue?: Maybe<DriveVenue>;
  /** Website link for an event. */
  websiteLink?: Maybe<Scalars['String']>;
};

/** Information of a activity feed message */
export type DriveEventActivityFeed = {
  __typename?: 'DriveEventActivityFeed';
  /** A list of replies the message */
  children?: Maybe<Array<Maybe<DriveEventActivityFeed>>>;
  /** The date this post was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The event id */
  eventId: Scalars['ID'];
  /** If the message is pinned to the top */
  featured?: Maybe<Scalars['Boolean']>;
  /** The ID of the message */
  id: Scalars['String'];
  /** The message posted */
  message?: Maybe<Scalars['String']>;
  /** The date when this post has been updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** A users first name and last and link to profile photo */
  user?: Maybe<User>;
  /** The id of the user who posted the message */
  userId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  apps?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  kyc?: Maybe<VaultKyc>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  occupation?: Maybe<UserOccupation>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  /** @deprecated will be removed in the next release */
  snapRaiseId?: Maybe<Scalars['String']>;
  /** @deprecated will be removed in the next release */
  snapSpendId?: Maybe<Scalars['String']>;
  walletOrganization?: Maybe<Organization>;
  walletTerms?: Maybe<Scalars['Boolean']>;
};

/** Individuals */
export type VaultKyc = {
  __typename?: 'VaultKyc';
  address: VaultAddress;
  director?: Maybe<Scalars['Boolean']>;
  dob: VaultDob;
  email: Scalars['String'];
  executive?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  owner?: Maybe<Scalars['Boolean']>;
  /** If owner=true, percentOwnership is required */
  percentOwnership?: Maybe<Scalars['Int']>;
  phoneNumber: Scalars['String'];
  representative?: Maybe<Scalars['Boolean']>;
  ssn?: Maybe<Scalars['String']>;
  /** String that represents individual's title in the organization */
  title?: Maybe<Scalars['String']>;
};

/** Used for addresses in VaultKyb and VaultKyc */
export type VaultAddress = {
  __typename?: 'VaultAddress';
  city: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
  street: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
};

/** Day, Month and Year of birth */
export type VaultDob = {
  __typename?: 'VaultDob';
  day?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export enum UserOccupation {
  DistrictAdministrator = 'district_administrator',
  FinancialAdministrator = 'financial_administrator',
  GroupLeader = 'group_leader',
  Other = 'other',
  Parent = 'parent',
  SchoolDirector = 'school_director',
  StateAdministrator = 'state_administrator',
  StudentOrParticipant = 'student_or_participant',
  Unknown = 'unknown'
}

/** Attributes for an events agenda */
export type DriveEventAgendaItem = {
  __typename?: 'DriveEventAgendaItem';
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

/** Represents an events attendee attributes */
export type DriveEventAttendee = {
  __typename?: 'DriveEventAttendee';
  /** The department the attendee is in. */
  department?: Maybe<Scalars['String']>;
  /** The event ID */
  eventId: Scalars['ID'];
  /** The status of an attendee flight request. Default is `NO_REQUEST`. */
  flightRequest?: Maybe<EventAttendeeRequestStatus>;
  /** The status of an attendee hotel request. Default is `NO_REQUEST`. */
  hotelRequest?: Maybe<EventAttendeeRequestStatus>;
  /** @deprecated Use userId instead */
  id: Scalars['ID'];
  /** Indication whether this attendee a clinic leader. */
  isClinicLeader?: Maybe<Scalars['Boolean']>;
  /** The status of an attendee attendence. */
  status: DriveAttendanceStatus;
  /** User Information of attendee, includes `firstName`, `lastName`, `email`, etc. defined in UserDirectory. */
  user?: Maybe<User>;
  /** The udId of an attendee. e.g. `ud_abc123` */
  userId: Scalars['ID'];
};

export enum EventAttendeeRequestStatus {
  NoRequest = 'NO_REQUEST',
  Processed = 'PROCESSED',
  Request = 'REQUEST'
}

export enum DriveAttendanceStatus {
  Attending = 'ATTENDING',
  NotAttending = 'NOT_ATTENDING'
}

/** Booth attributes */
export type DriveEventBooth = {
  __typename?: 'DriveEventBooth';
  /** Notes for the booth e.g. Electricity is paid for */
  boothNotes?: Maybe<Scalars['String']>;
  /** The time to end breakdown or clean up event equipment in Venue. */
  breakdownEndTime?: Maybe<Scalars['DateTime']>;
  /** The time to start breakdown or clean up event equipment in Venue. */
  breakdownStartTime?: Maybe<Scalars['DateTime']>;
  /** Indication whether electricity is provided. */
  electricityProvided?: Maybe<Scalars['Boolean']>;
  /** Indication whether flooring is provided. */
  flooringProvided?: Maybe<Scalars['Boolean']>;
  /** Indication whether internet is provided. */
  internetProvided?: Maybe<Scalars['Boolean']>;
  /** The time to end setup for event */
  setupEndTime?: Maybe<Scalars['DateTime']>;
  /** The time to begin setup for event */
  setupStartTime?: Maybe<Scalars['DateTime']>;
};

export enum DriveEventStatus {
  Closed = 'CLOSED',
  EmailSent = 'EMAIL_SENT',
  NotAttending = 'NOT_ATTENDING',
  Pending = 'PENDING',
  Registered = 'REGISTERED'
}

/** Venue or location for Event used by Event Clinic */
export type DriveVenue = {
  __typename?: 'DriveVenue';
  /** Building name or Room number. e.g. `Room 330` */
  buildingOrRoom?: Maybe<Scalars['String']>;
  /** City of Venue location, e.g. `Dallas` */
  city?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Venue Name. e.g. `Hillton Convention Center`, e.g. */
  name: Scalars['String'];
  /** The short-code for US States. e.g. `TX`, 'CA' */
  state?: Maybe<Scalars['String']>;
};

export type DriveEventSearchInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  attendees?: InputMaybe<Array<Scalars['String']>>;
  boothOptions?: InputMaybe<DriveEventBoothInput>;
  dateRange?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<DriveDateCompareInput>;
  eventStatus?: InputMaybe<EventDateStatus>;
  id?: InputMaybe<Scalars['ID']>;
  sponsor?: InputMaybe<DriveEventSponsorInput>;
  startDate?: InputMaybe<DriveDateCompareInput>;
  states?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<DriveEventStatus>>;
  tiers?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type DriveEventBoothInput = {
  boothNotes?: InputMaybe<Scalars['String']>;
  breakdownEndTime?: InputMaybe<Scalars['String']>;
  breakdownStartTime?: InputMaybe<Scalars['String']>;
  electricityProvided?: InputMaybe<Scalars['Boolean']>;
  flooringProvided?: InputMaybe<Scalars['Boolean']>;
  internetProvided?: InputMaybe<Scalars['Boolean']>;
  setupEndTime?: InputMaybe<Scalars['String']>;
  setupStartTime?: InputMaybe<Scalars['String']>;
};

export type DriveDateCompareInput = {
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
};

export enum EventDateStatus {
  Active = 'Active',
  Closed = 'Closed',
  Upcoming = 'Upcoming'
}

export type DriveEventSponsorInput = {
  doorPrized?: InputMaybe<Scalars['Boolean']>;
  doorPrizedRequired?: InputMaybe<Scalars['Boolean']>;
  sponsorDescription?: InputMaybe<Scalars['String']>;
};

/** Paginated list of drive events */
export type DriveEventResults = {
  __typename?: 'DriveEventResults';
  events?: Maybe<Array<DriveEvent>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** MDM Actor. e.g. Account Manager/Salereps/Sales Manager */
export type DriveAmSalesReps = {
  __typename?: 'DriveAmSalesReps';
  /** Primary contact email of salesrep */
  email?: Maybe<Scalars['String']>;
  /** End time of salesrep */
  endDate?: Maybe<Scalars['DateTime']>;
  /** First Name of Salesrep */
  firstName?: Maybe<Scalars['String']>;
  /** Last Name of Salesrep */
  lastName?: Maybe<Scalars['String']>;
  /** Primary phone number of salesrep */
  phone?: Maybe<Scalars['String']>;
  /** The sales manager of this salesrep */
  salesManager?: Maybe<DriveAmSalesReps>;
  /** Salesrep Id. This is Raise's account user id. */
  salesrepId?: Maybe<Scalars['Int']>;
  /** Start time of salesrep */
  startDate?: Maybe<Scalars['DateTime']>;
  /** actor type. e.g. 'salesrep', 'salesmanager', 'am' */
  type?: Maybe<Scalars['String']>;
};

export enum SalesrepType {
  AccountManager = 'ACCOUNT_MANAGER',
  SalesRep = 'SALES_REP'
}

export type DriveUserSearchInput = {
  isInternal?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DriveUsersResult = {
  __typename?: 'DriveUsersResult';
  nextPage?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<DriveAccountUser>>>;
};

/** Account User is a user that is registered in Raise's database. Deprecated: Use UserDirectory 's User instead instead */
export type DriveAccountUser = DriveUser & {
  __typename?: 'DriveAccountUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  snapRaiseId?: Maybe<Scalars['Int']>;
};

export type DriveVenueSearchInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type GetEventByIdInput = {
  event_id: Scalars['Int'];
};

export type CommonCalendarFiltersInput = {
  activity?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  facilities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  homeAway?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opponents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleType?: InputMaybe<Scalars['String']>;
};

export type CommonCalendar = {
  __typename?: 'CommonCalendar';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type EventContractItemInput = {
  event_id: Scalars['Int'];
};

export type ContractItem = {
  __typename?: 'ContractItem';
  event_contract?: Maybe<EventContract>;
  event_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventContract = {
  __typename?: 'EventContract';
  comments?: Maybe<Scalars['String']>;
  event_contract_number?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  main_event_id?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['String']>;
  signee_name?: Maybe<Scalars['String']>;
  signees?: Maybe<Array<Maybe<ContractSignees>>>;
  years?: Maybe<Scalars['String']>;
};

export type ContractSignees = {
  __typename?: 'ContractSignees';
  auth_hash?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  event_contract_number?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  original_contract?: Maybe<Scalars['String']>;
  sent_date?: Maybe<Scalars['Date']>;
  sign_contract?: Maybe<Scalars['String']>;
  sign_date?: Maybe<Scalars['Date']>;
  sign_status?: Maybe<Scalars['String']>;
};

export type GetOfficialByIdInput = {
  id: Scalars['Int'];
};

export type GetEventParticipantsByIdInput = {
  id: Scalars['Int'];
};

export type EventParticipants = {
  __typename?: 'EventParticipants';
  contract_received?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  school_code?: Maybe<Scalars['String']>;
  schoolInfo?: Maybe<SchoolInfo>;
};

export type GetEventPreparationsByIdInput = {
  id: Scalars['Int'];
};

export type GetEventPreparationsByEventIdInput = {
  event_id: Scalars['Int'];
};

export type GetWorkerByIdInput = {
  id: Scalars['Int'];
};

export type Facility = {
  __typename?: 'Facility';
  directions?: Maybe<Scalars['String']>;
  indoor?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  location_id?: Maybe<Scalars['Int']>;
  ml_site_id?: Maybe<Scalars['Int']>;
  ml_space?: Maybe<Scalars['String']>;
  ml_space_id?: Maybe<Scalars['Int']>;
  picture?: Maybe<Scalars['String']>;
  place_name: Scalars['String'];
  show?: Maybe<Scalars['String']>;
  specialDirections?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
};

export type GetFacilityByPlaceNameInput = {
  place_name: Scalars['String'];
};

export type CommonGridFiltersInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  facilities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CommonGrid = {
  __typename?: 'CommonGrid';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type Family = {
  __typename?: 'Family';
  children?: Maybe<Array<Maybe<User>>>;
  parents?: Maybe<Array<Maybe<User>>>;
};

export type CommonSheetFiltersInput = {
  activity?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  facilities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gender?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  homeAway?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  opponents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleType?: InputMaybe<Scalars['String']>;
};

export type CommonSheet = {
  __typename?: 'CommonSheet';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type FinancialAcctNode = {
  __typename?: 'FinancialAcctNode';
  acctId?: Maybe<Scalars['ID']>;
  applicationId?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  finAcctId?: Maybe<Scalars['ID']>;
  kybId?: Maybe<Scalars['ID']>;
  orgId?: Maybe<Scalars['ID']>;
  processor?: Maybe<Processor>;
  status?: Maybe<FinAcctStatus>;
};

export enum Processor {
  Stripe = 'STRIPE',
  Unit = 'UNIT'
}

export enum FinAcctStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  AwaitingReapproval = 'AWAITING_REAPPROVAL',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Terminated = 'TERMINATED',
  UnderReview = 'UNDER_REVIEW'
}

export type FundraiserDonations = {
  __typename?: 'FundraiserDonations';
  count?: Maybe<Scalars['Int']>;
  donations?: Maybe<Array<Maybe<CheerWall>>>;
};

export type CheerWall = {
  __typename?: 'CheerWall';
  createdAt?: Maybe<Scalars['DateTime']>;
  donorMessage?: Maybe<Scalars['String']>;
  donorName?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  participantName?: Maybe<Scalars['String']>;
  subtotalCents?: Maybe<Scalars['Int']>;
};

export type FundraiserEntityResource = {
  __typename?: 'FundraiserEntityResource';
  entityId?: Maybe<Scalars['Int']>;
};

export type FundraiserGroup = {
  __typename?: 'FundraiserGroup';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
};

export type FundraiserRaisedAmount = {
  __typename?: 'FundraiserRaisedAmount';
  subtotalCents?: Maybe<Scalars['Int']>;
};

export type FundraiserTopDonation = {
  __typename?: 'FundraiserTopDonation';
  donorName?: Maybe<Scalars['String']>;
  subtotalCents?: Maybe<Scalars['Int']>;
};

export type FundraiserUserRole = {
  __typename?: 'FundraiserUserRole';
  isGroupLeader?: Maybe<Scalars['Boolean']>;
  isParticipant?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InsOrg = {
  __typename?: 'InsOrg';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type ParticipantDonationLinkResult = {
  __typename?: 'ParticipantDonationLinkResult';
  participantDonationLink?: Maybe<Scalars['String']>;
};

export type HmSalesRep = {
  __typename?: 'HmSalesRep';
  rep_email?: Maybe<Scalars['String']>;
  sales_rep?: Maybe<Scalars['String']>;
};

export type GroupLeaderList = {
  __typename?: 'GroupLeaderList';
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  list: Array<Maybe<GroupLeader>>;
};

export type InsCampaignDonation = {
  __typename?: 'InsCampaignDonation';
  amount_cents?: Maybe<Scalars['Int']>;
  campaign_id: Scalars['Int'];
  campaign_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  donor_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  participant_name?: Maybe<Scalars['String']>;
};

export type InsCampaignRaiseEntityInfo = {
  __typename?: 'InsCampaignRaiseEntityInfo';
  campaign_id: Scalars['Int'];
  entity_id?: Maybe<Scalars['Int']>;
};

export type InsCampaignsData = {
  __typename?: 'InsCampaignsData';
  analyticsSummaryStats?: Maybe<Array<Maybe<InsAnalyticsSummaryStat>>>;
  campaignStats?: Maybe<Array<Maybe<InsCampaignStat>>>;
  donationMapStats?: Maybe<Array<Maybe<InsDonationMapStat>>>;
  inviteStats?: Maybe<Array<Maybe<InsInviteStat>>>;
  lTRChart?: Maybe<InsLtrChartData>;
  monthlyCampaignStats?: Maybe<Array<Maybe<InsMonthlyCampaignStat>>>;
};

export type InsAnalyticsSummaryStat = {
  __typename?: 'InsAnalyticsSummaryStat';
  amount_raised_cents: Scalars['Int'];
  campaign_id: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type InsCampaignStat = {
  __typename?: 'InsCampaignStat';
  donations_count?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['DateTime']>;
  forecasted_amount_cents?: Maybe<Scalars['Int']>;
  group_leader_email?: Maybe<Scalars['String']>;
  group_leader_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insights_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['Int']>;
  participation?: Maybe<Scalars['Float']>;
  preloading?: Maybe<Scalars['Float']>;
  start_date?: Maybe<Scalars['DateTime']>;
  total_raised_cents?: Maybe<Scalars['Int']>;
};

export type InsDonationMapStat = {
  __typename?: 'InsDonationMapStat';
  campaign_id?: Maybe<Scalars['Int']>;
  campaign_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  donations_amount_cents?: Maybe<Scalars['Int']>;
  donations_count?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  long?: Maybe<Scalars['Float']>;
  postal_code?: Maybe<Scalars['String']>;
};

export type InsInviteStat = {
  __typename?: 'InsInviteStat';
  campaign_id?: Maybe<Scalars['Int']>;
  campaign_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  invite_count: Scalars['Int'];
  invite_type: Scalars['String'];
  total_amount_cents: Scalars['Int'];
};

export type InsLtrChartData = {
  __typename?: 'InsLTRChartData';
  activeCampaignsCount?: Maybe<Scalars['Int']>;
  activeCampaignsParticipation?: Maybe<Scalars['Float']>;
  activeCampaignsTotalCents?: Maybe<Scalars['Int']>;
  avgDonationCents?: Maybe<Scalars['Int']>;
  closedCampaignsCount?: Maybe<Scalars['Int']>;
  closedCampaignsParticipation?: Maybe<Scalars['Float']>;
  closedCampaignsTotalCents?: Maybe<Scalars['Int']>;
  ltr?: Maybe<Scalars['Int']>;
  upcomingCampaignsCount?: Maybe<Scalars['Int']>;
  upcomingCampaignsForecastedAmountCents?: Maybe<Scalars['Int']>;
  upcomingCampaignsParticipantSignIn?: Maybe<Scalars['Float']>;
};

export type InsMonthlyCampaignStat = {
  __typename?: 'InsMonthlyCampaignStat';
  campaign_ids: Array<Maybe<Scalars['Int']>>;
  month: Scalars['Int'];
  participation?: Maybe<Scalars['Float']>;
  preloading?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export type InsCampaignSettlement = {
  __typename?: 'InsCampaignSettlement';
  amount_cents?: Maybe<Scalars['Int']>;
  campaign_id: Scalars['Int'];
  campaign_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last_updated?: Maybe<Scalars['DateTime']>;
  method?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type InsDonorParticipantContact = {
  __typename?: 'InsDonorParticipantContact';
  campaign_id: Scalars['Int'];
  donor_email?: Maybe<Scalars['String']>;
  donor_id?: Maybe<Scalars['Int']>;
  donor_name?: Maybe<Scalars['String']>;
  participant_email?: Maybe<Scalars['String']>;
  participant_id?: Maybe<Scalars['Int']>;
  participant_name?: Maybe<Scalars['String']>;
};

export type InsOrgCampaignSummaryInput = {
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  orgId?: InputMaybe<Scalars['String']>;
};

export type InsOrgCampaignSummary = {
  __typename?: 'InsOrgCampaignSummary';
  campaignsCount: Scalars['Int'];
  orgId?: Maybe<Scalars['String']>;
  totalRaisedCents: Scalars['Int'];
};

export type InsSalesRepInfo = {
  __typename?: 'InsSalesRepInfo';
  email: Scalars['String'];
  featured_image?: Maybe<Scalars['String']>;
  hubspot_calendar_link?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  post_title?: Maybe<Scalars['String']>;
};

export type InviteInfo = {
  __typename?: 'InviteInfo';
  email?: Maybe<Scalars['String']>;
  joincode?: Maybe<Scalars['String']>;
  requester?: Maybe<User>;
  status?: Maybe<Scalars['String']>;
};

export type GetLevelByIdInput = {
  ID: Scalars['Int'];
};

export type Level = {
  __typename?: 'Level';
  ID: Scalars['Int'];
  is_deleted?: Maybe<Scalars['Boolean']>;
  Level?: Maybe<Scalars['String']>;
};

export type ManageUsersListOptions = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ManageUsersList = {
  __typename?: 'ManageUsersList';
  items?: Maybe<Array<Maybe<ManageUser>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  totalFilteredItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type ManageUser = {
  __typename?: 'ManageUser';
  contracts?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['String']>;
  groups?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  maintenance?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  seasons?: Maybe<Scalars['String']>;
  teams?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_level?: Maybe<Scalars['String']>;
};

export type UserWithPermissions = {
  __typename?: 'UserWithPermissions';
  apps?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasFamily?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  kyc?: Maybe<VaultKyc>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  occupation?: Maybe<UserOccupation>;
  /** @deprecated use parents instead of parent */
  parent?: Maybe<Scalars['String']>;
  parents?: Maybe<Array<Maybe<Scalars['String']>>>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  /** @deprecated will be removed in the next release */
  snapRaiseId?: Maybe<Scalars['String']>;
  /** @deprecated will be removed in the next release */
  snapSpendId?: Maybe<Scalars['String']>;
  walletOrganization?: Maybe<Organization>;
  walletTerms?: Maybe<Scalars['Boolean']>;
};

export type Notice = {
  __typename?: 'Notice';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  isUrgent?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type GetOfficialDutiesByIdInput = {
  id: Scalars['Int'];
};

export type OfficialDuties = {
  __typename?: 'OfficialDuties';
  duty?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted?: Maybe<Scalars['Boolean']>;
};

export type GetOfficialPoolByIdInput = {
  ID?: InputMaybe<Scalars['String']>;
};

export type OfficialPool = {
  __typename?: 'OfficialPool';
  Address?: Maybe<Scalars['String']>;
  cell_phone?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  First?: Maybe<Scalars['String']>;
  Home_Phone?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  is_deleted?: Maybe<Scalars['Boolean']>;
  Last?: Maybe<Scalars['String']>;
  SSN?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  vendor_number?: Maybe<Scalars['String']>;
  Work_Phone?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

export type OfficialSchedules = {
  __typename?: 'OfficialSchedules';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  bus_departure_location?: Maybe<Scalars['String']>;
  bus_early_dismissal_time?: Maybe<Scalars['String']>;
  bus_estimated_return_time?: Maybe<Scalars['String']>;
  bus_time?: Maybe<Scalars['String']>;
  cancellation_status?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  official_address?: Maybe<Scalars['String']>;
  official_address_city?: Maybe<Scalars['String']>;
  official_address_state?: Maybe<Scalars['String']>;
  official_address_zip?: Maybe<Scalars['String']>;
  official_duty?: Maybe<Scalars['String']>;
  official_email?: Maybe<Scalars['String']>;
  official_first_name?: Maybe<Scalars['String']>;
  official_home_phone?: Maybe<Scalars['String']>;
  official_id?: Maybe<Scalars['String']>;
  official_last_name?: Maybe<Scalars['String']>;
  official_paid?: Maybe<Scalars['String']>;
  official_salary?: Maybe<Scalars['String']>;
  official_work_phone?: Maybe<Scalars['String']>;
  opponent?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type GetOpponentBySchoolCodeInput = {
  SchoolCode: Scalars['String'];
};

export type Opponent = {
  __typename?: 'Opponent';
  ad_name?: Maybe<Scalars['String']>;
  Address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  nces_id?: Maybe<Scalars['String']>;
  non_school?: Maybe<Scalars['Boolean']>;
  Phone?: Maybe<Scalars['String']>;
  SchoolCode?: Maybe<Scalars['String']>;
  SchoolName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

export type GetEventsFilteredByOpponentStartAndEndDate = {
  endDate: Scalars['String'];
  opponent: Scalars['String'];
  startDate: Scalars['String'];
};

export type EventsOpponent = {
  __typename?: 'EventsOpponent';
  activity?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['Date']>;
  eventId?: Maybe<Scalars['Int']>;
  eventsOpponentId?: Maybe<Scalars['Int']>;
  season_years?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
};

export type Org = {
  __typename?: 'Org';
  createdAt?: Maybe<Scalars['DateTime']>;
  fields?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type OrgFieldsArgs = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum Product {
  Connect = 'CONNECT',
  Insights = 'INSIGHTS',
  Manage = 'MANAGE',
  Raise = 'RAISE',
  Spend = 'SPEND',
  Sponsor = 'SPONSOR',
  Store = 'STORE'
}

export type UserNode = {
  __typename?: 'UserNode';
  id: Scalars['ID'];
  internal?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OtkFundraiserProduct = {
  __typename?: 'OtkFundraiserProduct';
  /** This otk item image will include the fundraiser logo. */
  dynamicImage?: Maybe<Scalars['String']>;
  incentives?: Maybe<OtkProduct>;
};

export type ParticipantDonations = {
  __typename?: 'ParticipantDonations';
  count?: Maybe<Scalars['Int']>;
  donations?: Maybe<Array<Maybe<ParticipantCheerWall>>>;
};

export type ParticipantCheerWall = {
  __typename?: 'ParticipantCheerWall';
  createdAt?: Maybe<Scalars['DateTime']>;
  donorMessage?: Maybe<Scalars['String']>;
  donorName?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtotalCents?: Maybe<Scalars['Int']>;
};

export type ParticipantList = {
  __typename?: 'ParticipantList';
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  list: Array<Maybe<Participant>>;
};

export type Participant = {
  __typename?: 'Participant';
  campaignId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ParticipantSsoid = {
  __typename?: 'ParticipantSSOID';
  userDirectoryId?: Maybe<Scalars['String']>;
};

export type ParticipantTextTemplate = {
  __typename?: 'ParticipantTextTemplate';
  guardianTemplate?: Maybe<Scalars['String']>;
  participantTemplate?: Maybe<Scalars['String']>;
};

export type ParticipantTopDonation = {
  __typename?: 'ParticipantTopDonation';
  donorName?: Maybe<Scalars['String']>;
  subtotalCents?: Maybe<Scalars['Int']>;
};

export type Payout = Check | Deposit;

export type Check = {
  __typename?: 'Check';
  amount: Scalars['Decimal'];
  campaignId: Scalars['Int'];
  checkNumber: Scalars['String'];
  created: Scalars['Timestamp'];
  destination: Account;
  effective: Scalars['Timestamp'];
  expiration: Scalars['Timestamp'];
  payee: Payee;
  status: CheckStatus;
  transactionId: Scalars['UUID'];
};

export type Account = ExternalBankAccount | StripeAccount;

export type ExternalBankAccount = {
  __typename?: 'ExternalBankAccount';
  accountId: Scalars['String'];
  accountType?: Maybe<AccountType>;
  bankName: Scalars['String'];
  campaignId: Scalars['String'];
  last4: Scalars['String'];
};

export enum AccountType {
  ExternalBank = 'EXTERNAL_BANK',
  /** more TK */
  Stripe = 'STRIPE'
}

export type StripeAccount = {
  __typename?: 'StripeAccount';
  accountId: Scalars['String'];
  accountType?: Maybe<AccountType>;
  campaignId: Scalars['String'];
};

export type Payee = {
  __typename?: 'Payee';
  address: PayeeAddress;
  name: Scalars['String'];
};

export type PayeeAddress = {
  __typename?: 'PayeeAddress';
  apartment?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  zip: Scalars['String'];
};

export enum CheckStatus {
  Deposited = 'DEPOSITED',
  /** TODO(SHR): update this once we get actual statuses from bill.com */
  Processing = 'PROCESSING',
  Sent = 'SENT'
}

export type Deposit = {
  __typename?: 'Deposit';
  amount: Scalars['Decimal'];
  campaignId: Scalars['Int'];
  created: Scalars['Timestamp'];
  description: Scalars['String'];
  destination: Account;
  effective: Scalars['Timestamp'];
  externalId: Scalars['String'];
  source: Account;
  transactionId: Scalars['UUID'];
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FundraiserSearchParams = {
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationSearchParams = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Information of premade email templates */
export type PremadeContactTemplate = {
  __typename?: 'PremadeContactTemplate';
  /** The message of the template. Plain text only */
  message?: Maybe<Scalars['String']>;
  /** The name of the template */
  name?: Maybe<Scalars['String']>;
  /** The subject of the template */
  subject?: Maybe<Scalars['String']>;
  templateMedium?: Maybe<ContactTemplateMedium>;
  /** The type of template */
  templateType?: Maybe<ContactTemplateType>;
};

export enum ContactTemplateMedium {
  Email = 'EMAIL',
  TextMessage = 'TEXT_MESSAGE'
}

export enum ContactTemplateType {
  GroupLeader = 'GROUP_LEADER',
  Participant = 'PARTICIPANT'
}

export type GetPreparationByIdInput = {
  id: Scalars['Int'];
};

export type PreparationSheet = {
  __typename?: 'PreparationSheet';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  preparations?: Maybe<Array<Maybe<PreparationReport>>>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type PreparationReport = {
  __typename?: 'PreparationReport';
  comments?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  prep?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['String']>;
};

export type PublicFundraiserData = {
  __typename?: 'PublicFundraiserData';
  alternateColor?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  fanStore?: Maybe<Scalars['Boolean']>;
  goal?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  incStore?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participantGoal?: Maybe<Scalars['Int']>;
  personalMessage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  programLeader?: Maybe<Scalars['String']>;
  programType?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  whyDonations?: Maybe<Scalars['String']>;
};

export type PublicParticipantData = {
  __typename?: 'PublicParticipantData';
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['Boolean']>;
};

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<RolePermission>>>;
  scope?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  id?: Maybe<Scalars['String']>;
  permission?: Maybe<Permission>;
  permissionId?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
};

export type GetSchoolInfoByIdInput = {
  id: Scalars['String'];
};

/** Paginated list of campaigns */
export type DriveCampaignList = {
  __typename?: 'DriveCampaignList';
  /** Total campaigns */
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<DriveCampaign>>>;
  offset?: Maybe<Scalars['Int']>;
};

/** Information of a single drive campaign */
export type DriveCampaign = {
  __typename?: 'DriveCampaign';
  /** The account manager of the campaign */
  accountManager?: Maybe<AccountManager>;
  /** @deprecated: not used, in favor of totalRaisedCents */
  donationRaisedCents?: Maybe<Scalars['Int']>;
  /** The date the campaign ends */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The date the campaign has been finalized/closed */
  finalizedDate?: Maybe<Scalars['DateTime']>;
  /** Indicate whether the campaign has any incentives, such as OTK */
  hasIncentive?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  /** Name of campaign */
  name?: Maybe<Scalars['String']>;
  /** Notes for a campaign */
  notes?: Maybe<Scalars['String']>;
  /** Url-slug of campaign name which is a unique identifier */
  slug?: Maybe<Scalars['String']>;
  /** The date campaign starts */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Current status of campaign */
  status?: Maybe<CampaignStatus>;
  /** The size of the team/group attached to campaign */
  teamSize?: Maybe<Scalars['Int']>;
  /** @deprecated: not used, in favor of `totalRaisedCents` */
  totalRaised?: Maybe<Scalars['BigInt']>;
  /** Total amount of donation of campaign in cents. */
  totalRaisedCents?: Maybe<Scalars['Int']>;
};

/** List of organizations used by Drive */
export type DriveOrganizationList = {
  __typename?: 'DriveOrganizationList';
  list: Array<Maybe<DriveOrganization>>;
  offset?: Maybe<Scalars['Int']>;
};

/** Organization used by Drive */
export type DriveOrganization = {
  __typename?: 'DriveOrganization';
  activity?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  legalName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type SeasonByIdInput = {
  season_id: Scalars['Int'];
};

export type Season = {
  __typename?: 'Season';
  budget?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['Date']>;
  default_time_for_event?: Maybe<Scalars['String']>;
  default_time_for_practice?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  preview?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  season_id: Scalars['Int'];
  sport?: Maybe<Team>;
  sport_code?: Maybe<Scalars['String']>;
  web_password?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type Team = {
  __typename?: 'Team';
  facility?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  groupval?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  level1?: Maybe<Scalars['String']>;
  sport_code: Scalars['String'];
  sport_description?: Maybe<Scalars['String']>;
  sport_name: Scalars['String'];
};

export type SeasonByYearTeamInput = {
  sport_code?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type SeasonEventWizardInput = {
  season_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ShipmentInput = {
  campaignId?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
};

export type ShipmentResponse = {
  __typename?: 'ShipmentResponse';
  shipments: Array<Maybe<Shipment>>;
  status: ResponseStatus;
};

export type Shipment = {
  __typename?: 'Shipment';
  carrier?: Maybe<ShipmentCarrier>;
  customer: Scalars['String'];
  destination?: Maybe<Scalars['String']>;
  externalId: ShipmentExternalId;
  netsuiteId: Scalars['String'];
  netsuiteSoTranId?: Maybe<Scalars['String']>;
  netsuiteTranId?: Maybe<Scalars['String']>;
  shippedDate?: Maybe<Scalars['Timestamp']>;
  source?: Maybe<ShipmentSource>;
  status?: Maybe<ShipmentStatus>;
  trackingNumbers: Array<Maybe<Scalars['String']>>;
  updated: Scalars['Timestamp'];
  workflowStage: Scalars['String'];
};

export enum ShipmentCarrier {
  Fedex = 'FEDEX',
  Unknown = 'UNKNOWN',
  Usps = 'USPS'
}

export type ShipmentExternalId = ShipmentCampaignId | ShipmentOtherId;

export type ShipmentCampaignId = {
  __typename?: 'ShipmentCampaignId';
  campaignId: Scalars['Int'];
};

export type ShipmentOtherId = {
  __typename?: 'ShipmentOtherId';
  externalId: Scalars['UUID'];
};

export enum ShipmentSource {
  Otf = 'OTF',
  OtkIncentive = 'OTK_INCENTIVE',
  Store = 'STORE'
}

export enum ShipmentStatus {
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED'
}

export enum ResponseStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type ExportFile = {
  __typename?: 'ExportFile';
  content?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type SpendBudgetResponse = {
  __typename?: 'SpendBudgetResponse';
  budgets?: Maybe<Array<Maybe<SpendBudget>>>;
  count?: Maybe<Scalars['Int']>;
};

export type SpendBudget = {
  __typename?: 'SpendBudget';
  category: SpendCategory;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<SpendInvoice>>>;
  isDefault?: Maybe<Scalars['Boolean']>;
  reconciledBudgetTotal?: Maybe<Scalars['Int']>;
  reconciledInvoicesTotal?: Maybe<Scalars['Int']>;
  reconciledTotal?: Maybe<Scalars['Int']>;
  season?: Maybe<SpendSeason>;
  targetAmount?: Maybe<Scalars['Int']>;
  targetDateAt?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<SpendReconciledBudgetTransaction>>>;
  updatedAt?: Maybe<Scalars['String']>;
  vaultId?: Maybe<Scalars['String']>;
};

export type SpendCategory = {
  __typename?: 'SpendCategory';
  budgets?: Maybe<Array<Maybe<SpendBudget>>>;
  createdAt: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type SpendInvoice = {
  __typename?: 'SpendInvoice';
  amount?: Maybe<Scalars['Int']>;
  balanceDue?: Maybe<Scalars['Int']>;
  budgetItemId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  groupRosterId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  isReconciled?: Maybe<Scalars['Boolean']>;
  lastNotifyDate?: Maybe<Scalars['String']>;
  lastNotifyId?: Maybe<Scalars['String']>;
  notificationAttempts?: Maybe<Scalars['Int']>;
  optedIn?: Maybe<Scalars['Boolean']>;
  paid?: Maybe<Scalars['Boolean']>;
  paidDate?: Maybe<Scalars['String']>;
  paymentScheduleInvoiceId?: Maybe<Scalars['String']>;
  reconciledTransactions?: Maybe<Array<Maybe<SpendReconciledInvoiceTransaction>>>;
  transaction?: Maybe<SpendTransaction>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SpendReconciledInvoiceTransaction = {
  __typename?: 'SpendReconciledInvoiceTransaction';
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  transaction?: Maybe<SpendBankTransaction>;
  transactionId?: Maybe<Scalars['String']>;
};

export type SpendBankTransaction = {
  __typename?: 'SpendBankTransaction';
  amount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  effective?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<SpendBankTransactionMetaData>;
  processor?: Maybe<Scalars['String']>;
  reconciliation?: Maybe<SpendReconciledTransaction>;
  snapAmount?: Maybe<Scalars['Int']>;
  stripeFee?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type SpendBankTransactionMetaData = {
  __typename?: 'SpendBankTransactionMetaData';
  destination?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type SpendReconciledTransaction = {
  __typename?: 'SpendReconciledTransaction';
  amount?: Maybe<Scalars['Int']>;
  budgetTransactions?: Maybe<Array<Maybe<SpendReconciledBudgetTransaction>>>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceTransactions?: Maybe<Array<Maybe<SpendReconciledInvoiceTransaction>>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SpendReconciledBudgetTransaction = {
  __typename?: 'SpendReconciledBudgetTransaction';
  amount?: Maybe<Scalars['Int']>;
  budgetItemId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  transaction?: Maybe<SpendBankTransaction>;
  transactionId?: Maybe<Scalars['String']>;
};

export type SpendTransaction = {
  __typename?: 'SpendTransaction';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type SpendSeason = {
  __typename?: 'SpendSeason';
  budgets?: Maybe<Array<Maybe<SpendBudget>>>;
  endDateAt?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  groupRoster?: Maybe<Array<Maybe<SpendGroupRoster>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentScheduleStatus?: Maybe<Scalars['String']>;
  playerCount?: Maybe<Scalars['Int']>;
  startDateAt?: Maybe<Scalars['String']>;
  transactionTotals?: Maybe<SpendTransactionTotals>;
};

export type SpendGroupRoster = {
  __typename?: 'SpendGroupRoster';
  archivedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  group?: Maybe<SpendGroup>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invite?: Maybe<SpendInvite>;
  inviteId?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<SpendInvoice>>>;
  isArchived?: Maybe<Scalars['Boolean']>;
  joinedAt?: Maybe<Scalars['String']>;
  roster?: Maybe<SpendRosterCore>;
  rosterId?: Maybe<Scalars['String']>;
  season?: Maybe<SpendSeason>;
  seasonId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type SpendGroup = {
  __typename?: 'SpendGroup';
  archivedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  seasons?: Maybe<Array<Maybe<SpendSeason>>>;
  seasonsList?: Maybe<Array<Maybe<SpendSeason>>>;
};

export type SpendInvite = {
  __typename?: 'SpendInvite';
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isUser?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type SpendRosterCore = {
  __typename?: 'SpendRosterCore';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SpendTransactionTotals = {
  __typename?: 'SpendTransactionTotals';
  credited?: Maybe<Scalars['Int']>;
  paid?: Maybe<Scalars['Int']>;
  pastDue?: Maybe<Scalars['Int']>;
  processing?: Maybe<Scalars['Int']>;
  upcoming?: Maybe<Scalars['Int']>;
};

export type SpendBudgetSummaryResponse = {
  __typename?: 'SpendBudgetSummaryResponse';
  summaryByCategory?: Maybe<Array<Maybe<SpendCategory>>>;
  summaryUnreconciled?: Maybe<SpendUnreconciledSummary>;
};

export type SpendUnreconciledSummary = {
  __typename?: 'SpendUnreconciledSummary';
  credits?: Maybe<TransactionTotalCount>;
  debits?: Maybe<TransactionTotalCount>;
};

export type TransactionTotalCount = {
  __typename?: 'TransactionTotalCount';
  count?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export enum CategoryFilterEnum {
  Name = 'name',
  Type = 'type'
}

export type SpendCategoryResponse = {
  __typename?: 'SpendCategoryResponse';
  categories?: Maybe<Array<Maybe<SpendCategory>>>;
  count?: Maybe<Scalars['Int']>;
};

export type HmSpendData = {
  __typename?: 'HmSpendData';
  credited?: Maybe<Scalars['Int']>;
  inactiveCards?: Maybe<Scalars['Int']>;
  paid?: Maybe<Scalars['Int']>;
  pastDue?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
  upcoming?: Maybe<Scalars['Int']>;
};

export type SpendRoster = {
  __typename?: 'SpendRoster';
  group?: Maybe<SpendGroup>;
  member?: Maybe<SpendMember>;
  season?: Maybe<SpendSeason>;
};

export type SpendMember = {
  __typename?: 'SpendMember';
  child?: Maybe<SpendMemberChild>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  signedUp?: Maybe<Scalars['Boolean']>;
};

export type SpendMemberChild = {
  __typename?: 'SpendMemberChild';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum GroupRosterFilterEnum {
  GroupId = 'groupId',
  MemberId = 'memberId',
  RosterId = 'rosterId',
  SeasonId = 'seasonId'
}

export type SpendGroupRosterResponse = {
  __typename?: 'SpendGroupRosterResponse';
  count?: Maybe<Scalars['Int']>;
  groupRosters?: Maybe<Array<Maybe<SpendGroupRoster>>>;
};

export type SpendGroupResponse = {
  __typename?: 'SpendGroupResponse';
  count?: Maybe<Scalars['Int']>;
  groups?: Maybe<Array<Maybe<SpendGroup>>>;
};

export enum InviteFilterEnum {
  Group = 'group',
  Program = 'program',
  Status = 'status',
  Type = 'type'
}

export type SpendInviteResponse = {
  __typename?: 'SpendInviteResponse';
  count?: Maybe<Scalars['Int']>;
  invites?: Maybe<Array<Maybe<SpendInvite>>>;
};

export enum InvoiceFilterEnum {
  Date = 'date',
  GroupId = 'groupId',
  GroupName = 'groupName',
  PlayerName = 'playerName',
  Status = 'status',
  Unreconciled = 'unreconciled'
}

export type SpendInvoiceResponse = {
  __typename?: 'SpendInvoiceResponse';
  count?: Maybe<Scalars['Int']>;
  invoices?: Maybe<Array<Maybe<SpendInvoice>>>;
};

export type SpendMockInvoiceResponse = {
  __typename?: 'SpendMockInvoiceResponse';
  count?: Maybe<Scalars['Int']>;
  invoices?: Maybe<Array<Maybe<SpendInvoiceMock>>>;
};

export type SpendInvoiceMock = {
  __typename?: 'SpendInvoiceMock';
  amount?: Maybe<Scalars['Int']>;
  balanceDue?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  group?: Maybe<SpendGroup>;
  id?: Maybe<Scalars['String']>;
  isReconciled?: Maybe<Scalars['Boolean']>;
  lastNotifyDate?: Maybe<Scalars['String']>;
  member?: Maybe<SpendMember>;
  paid?: Maybe<Scalars['Boolean']>;
  paidDate?: Maybe<Scalars['String']>;
  paymentScheduleInvoiceId?: Maybe<Scalars['String']>;
  season?: Maybe<SpendSeason>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SpendOrganization = {
  __typename?: 'SpendOrganization';
  address: SpendAddress;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  legalName: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type SpendAddress = {
  __typename?: 'SpendAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum OrganizationFilterEnum {
  Pending = 'pending'
}

export type SpendPaymentSchedule = {
  __typename?: 'SpendPaymentSchedule';
  amountDue?: Maybe<Scalars['Int']>;
  budgetItemId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SpendPolicy = {
  __typename?: 'SpendPolicy';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SpendRole = {
  __typename?: 'SpendRole';
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  permissions: Array<Maybe<Scalars['String']>>;
};

export type SpendRoleResponse = {
  __typename?: 'SpendRoleResponse';
  count?: Maybe<Scalars['Int']>;
  roles?: Maybe<Array<Maybe<SpendRole>>>;
};

export enum RosterFilterEnum {
  GroupName = 'groupName',
  MemberName = 'memberName',
  RosterName = 'rosterName',
  SeasonName = 'seasonName'
}

export type SpendRosterResponse = {
  __typename?: 'SpendRosterResponse';
  count?: Maybe<Scalars['Int']>;
  rosters?: Maybe<Array<Maybe<SpendRoster>>>;
};

export enum TransactionFilterEnum {
  Date = 'date',
  GroupName = 'groupName',
  Method = 'method',
  ReconciledStatus = 'reconciledStatus',
  SeasonName = 'seasonName',
  Status = 'status',
  Type = 'type'
}

export type SpendBankTransactionResponse = {
  __typename?: 'SpendBankTransactionResponse';
  count?: Maybe<Scalars['Int']>;
  transactions?: Maybe<Array<Maybe<SpendBankTransaction>>>;
};

export type Sponsor = {
  __typename?: 'Sponsor';
  assets?: Maybe<Array<Maybe<Asset>>>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Industry>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  socialMediaAccounts?: Maybe<SocialMediaAccounts>;
  state?: Maybe<SponsorState>;
  status?: Maybe<Scalars['Boolean']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  assetId?: Maybe<Scalars['Int']>;
  assetType?: Maybe<AssetType>;
  assetTypeId?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isSponsored?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  sponsors?: Maybe<Array<Maybe<SponsorInAssets>>>;
  sponsorshipGroup?: Maybe<SponsorshipGroup>;
  sponsorshipGroupId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AssetType = {
  __typename?: 'AssetType';
  assetTypeValue?: Maybe<Array<Maybe<AssetTypeValue>>>;
  attachmentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  minPrice?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['Int']>;
  productionSource?: Maybe<Scalars['String']>;
};

export type AssetTypeValue = {
  __typename?: 'AssetTypeValue';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type SponsorInAssets = {
  __typename?: 'SponsorInAssets';
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SponsorshipGroup = {
  __typename?: 'SponsorshipGroup';
  activity?: Maybe<Activity>;
  assets?: Maybe<Array<Maybe<Asset>>>;
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isStripeVerified?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  motive?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  qrCode?: Maybe<Scalars['String']>;
  socialMediaAccounts?: Maybe<SocialMediaAccounts>;
  state?: Maybe<SponsorState>;
  status?: Maybe<Scalars['Boolean']>;
  streetAddress?: Maybe<Scalars['String']>;
  stripeAccountStatus?: Maybe<Scalars['String']>;
  stripeConnectAccountId?: Maybe<Scalars['String']>;
  teamPhoto?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Activity = {
  __typename?: 'Activity';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SocialMediaAccounts = {
  __typename?: 'SocialMediaAccounts';
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type SponsorState = {
  __typename?: 'SponsorState';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Industry = {
  __typename?: 'Industry';
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderByClauseGroups = {
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
};

export type WhereClauseAssets = {
  activityId?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assetTypeId?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<SearchByName>;
  radius?: InputMaybe<Scalars['Int']>;
  sponsorshipGroupId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type SearchByName = {
  contains?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
};

export type Assets = {
  __typename?: 'Assets';
  assets?: Maybe<Array<Maybe<Asset>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorsOnAssets = {
  __typename?: 'SponsorsOnAssets';
  assetId?: Maybe<Scalars['String']>;
  assignedAt?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  sponsorId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AssetsCount = {
  __typename?: 'AssetsCount';
  sponsoredCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type HmSponsorData = {
  __typename?: 'HmSponsorData';
  activeSponsorships?: Maybe<Scalars['Int']>;
  assetCount?: Maybe<Scalars['Int']>;
  available?: Maybe<Scalars['Int']>;
  sponsorShipValue?: Maybe<Scalars['Int']>;
  totalAssets?: Maybe<Scalars['Int']>;
};

export type SponsorDistrict = {
  __typename?: 'SponsorDistrict';
  fields?: Maybe<SponsorDistrictFields>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SponsorDistrictFields = {
  __typename?: 'SponsorDistrictFields';
  name?: Maybe<Scalars['String']>;
};

export type SponsorDistricts = {
  __typename?: 'SponsorDistricts';
  districts?: Maybe<Array<Maybe<SponsorDistrict>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsoredSponsorShipGroups = {
  __typename?: 'SponsoredSponsorShipGroups';
  sponsorShipGroups?: Maybe<Array<Maybe<SponsoredSponsorShipGroup>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsoredSponsorShipGroup = {
  __typename?: 'SponsoredSponsorShipGroup';
  assets?: Maybe<Array<Maybe<Asset>>>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  fees?: Maybe<Scalars['Float']>;
  orderdate?: Maybe<Array<Maybe<Scalars['String']>>>;
  orderId?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  receiptPDF?: Maybe<Scalars['String']>;
  sponsorshipgroups?: Maybe<Array<Maybe<SponsorshipGroup>>>;
  subTotal?: Maybe<Scalars['Float']>;
  types?: Maybe<Array<Maybe<AssetType>>>;
};

export type Attachment = {
  __typename?: 'Attachment';
  assetId?: Maybe<Scalars['String']>;
  assignedAt?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['String']>;
  sponsorId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  billingDetails?: Maybe<BillingDetails>;
  card?: Maybe<CardDetails>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  sponsorId?: Maybe<Scalars['String']>;
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address?: Maybe<BillingAddress>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CardDetails = {
  __typename?: 'CardDetails';
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
};

export type WhereClauseSponsors = {
  name?: InputMaybe<SearchByName>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type Sponsors = {
  __typename?: 'Sponsors';
  sponsors?: Maybe<Array<Maybe<Sponsor>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorSchool = {
  __typename?: 'SponsorSchool';
  fields?: Maybe<SponsorSchoolFields>;
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type SponsorSchoolFields = {
  __typename?: 'SponsorSchoolFields';
  name?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type SponsorSchoolProgram = {
  __typename?: 'SponsorSchoolProgram';
  fields?: Maybe<SponsorSchoolProgramFields>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SponsorSchoolProgramFields = {
  __typename?: 'SponsorSchoolProgramFields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SponsorSchoolPrograms = {
  __typename?: 'SponsorSchoolPrograms';
  sponsorSchoolPrograms?: Maybe<Array<Maybe<SponsorSchoolProgram>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorSchools = {
  __typename?: 'SponsorSchools';
  schools?: Maybe<Array<Maybe<SponsorSchool>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Link = {
  __typename?: 'Link';
  dest?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type AccountLink = {
  __typename?: 'AccountLink';
  created?: Maybe<Scalars['Int']>;
  expires_at?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type WhereClauseAssetTypes = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type OrderByClauseInvites = {
  business?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type WhereClauseInvites = {
  email?: InputMaybe<SearchByName>;
  sponsorshipGroupId: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
};

export type Invites = {
  __typename?: 'Invites';
  invites?: Maybe<Array<Maybe<Invite>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Invite = {
  __typename?: 'Invite';
  assignedAt?: Maybe<Scalars['String']>;
  business?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type WhereClauseSponsorshipGroupOrders = {
  name?: InputMaybe<SearchByName>;
  sponsorshipGroupId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderStatus>;
};

export enum OrderStatus {
  Approved = 'APPROVED',
  Complete = 'COMPLETE',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RequireApproval = 'REQUIRE_APPROVAL'
}

export type SponsorshipGroupOnOrders = {
  __typename?: 'SponsorshipGroupOnOrders';
  orders?: Maybe<Array<Maybe<SponsorshipGroupOnOrder>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorshipGroupOnOrder = {
  __typename?: 'SponsorshipGroupOnOrder';
  assignedAt?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  package?: Maybe<SponsorShipPackage>;
  packageId?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  sponsorshipGroupId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SponsorShipPackage = {
  __typename?: 'SponsorShipPackage';
  assets?: Maybe<Array<Maybe<Asset>>>;
  id?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  receiptPDF?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SponsorshipGroupOrdersStats = {
  __typename?: 'SponsorshipGroupOrdersStats';
  completed?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  requireApproval?: Maybe<Scalars['Int']>;
  totalValue?: Maybe<Scalars['Int']>;
};

export type SumResponse = {
  __typename?: 'sumResponse';
  sum?: Maybe<Scalars['Float']>;
};

export type SponsorshipGroupUser = {
  __typename?: 'sponsorshipGroupUser';
  sponsorshipGroupId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
};

export type WhereClauseSponsorShipGroups = {
  activityId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<SearchByName>;
  schoolId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type SponsorshipGroups = {
  __typename?: 'SponsorshipGroups';
  sponsorShipGroups?: Maybe<Array<Maybe<SponsorshipGroup>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Packages = {
  __typename?: 'packages';
  id?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<PackageAsset>>>;
};

export type PackageAsset = {
  __typename?: 'packageAsset';
  asset?: Maybe<Asset>;
};

export type OrderByPackages = {
  orderedAt?: InputMaybe<Scalars['String']>;
};

export type WhereClausePackages = {
  status?: InputMaybe<Scalars['String']>;
};

export type SponsoredOrders = {
  __typename?: 'sponsoredOrders';
  orders?: Maybe<Array<Maybe<SponsorshipOrders>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorshipOrders = {
  __typename?: 'sponsorshipOrders';
  assets?: Maybe<Array<Maybe<Asset>>>;
  id?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
};

export type MySponsorships = {
  __typename?: 'mySponsorships';
  packages?: Maybe<Array<Maybe<Packages>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SponsorSubDistrict = {
  __typename?: 'SponsorSubDistrict';
  fields?: Maybe<SponsorDistrictFields>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SponsorSubDistricts = {
  __typename?: 'SponsorSubDistricts';
  subDistricts?: Maybe<Array<Maybe<SponsorSubDistrict>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Union Types Queries */
export type StoreUnionType = OnException | Store;

export type OnException = {
  __typename?: 'OnException';
  exceptionCode?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** This is Store Type. That represent store of Magento. This is Own-Used By Store-Dashboard-Team. */
export type Store = {
  __typename?: 'Store';
  accountManagerId?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  campaignEndDate?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['Int']>;
  campaignStartDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  digitalLogo?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  embroideryLogo?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Int']>;
  entityId?: Maybe<Scalars['Int']>;
  favicon?: Maybe<Scalars['String']>;
  groupLeaderEmail?: Maybe<Scalars['String']>;
  hatLogo?: Maybe<Scalars['String']>;
  headerLogo?: Maybe<Scalars['String']>;
  heroSliderVariableId?: Maybe<Scalars['Int']>;
  homepageId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  manager?: Maybe<StoreCustomer>;
  name?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['Int']>;
  orderConfirmationEmailTemplate?: Maybe<Scalars['String']>;
  orders?: Maybe<Scalars['Int']>;
  organizationName?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  parentStoreId?: Maybe<Scalars['Int']>;
  pointsPercentage?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['Int']>;
  qrCode?: Maybe<Scalars['String']>;
  raiseId?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['Float']>;
  salesRepId?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  shipmentEmailTemplate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['Int']>;
  storeName?: Maybe<Scalars['String']>;
  storeVariablesId?: Maybe<Scalars['Int']>;
  stripeCreditCardDescriptor?: Maybe<Scalars['String']>;
  teamName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['Int']>;
};

/** This is Store-Customer Type. That represent customer of Magento. This is Own-Used By Store-Dashboard-Team. */
export type StoreCustomer = {
  __typename?: 'StoreCustomer';
  createdIn?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  points?: Maybe<StoreRewardPoint>;
  scopeId?: Maybe<Scalars['Int']>;
};

/** This is Store-Reward-Point Type. That represent customer reward points of Magento. This is Own-Used By Store-Dashboard-Team. */
export type StoreRewardPoint = {
  __typename?: 'StoreRewardPoint';
  customerId?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  rewardpointId?: Maybe<Scalars['Int']>;
};

export type StoreBaseSellerUnionType = OnException | StoreScopeBestSeller;

export type StoreScopeBestSeller = {
  __typename?: 'StoreScopeBestSeller';
  bestSellers?: Maybe<Array<Maybe<StoreBestSeller>>>;
};

/** This is Store-Best-Seller Type. That represent the best seller products of specific store of magento. This is Own-Used By Store-Dashboard-Team. */
export type StoreBestSeller = {
  __typename?: 'StoreBestSeller';
  productId?: Maybe<Scalars['Int']>;
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productPrice?: Maybe<Scalars['Float']>;
  productQuantity?: Maybe<Scalars['Int']>;
  productType?: Maybe<Scalars['String']>;
};

export type StoreCampaignUnionType = OnException | StoreCampaignInfo;

/** This is Store-Campaign-Info Type. That is used represent the response of storeCampaigns queries. This is Own-Used By Store-Dashboard-Team. */
export type StoreCampaignInfo = {
  __typename?: 'StoreCampaignInfo';
  campaigns?: Maybe<Array<Maybe<StoreCampaign>>>;
  saved?: Maybe<Scalars['Boolean']>;
  userInfo?: Maybe<StoreSsoUserInfo>;
};

/** This is Store-Campaign Type. That is used represent the campaigns in store-dashboard. This type maybe exist in Campaign-Service but we have approval to use our type and queries MVP 1. For MVP 2 we will revamp our backend to consume Campaign-Service. And will remove Store-Campaign from our code. This is Own-Used By Store-Dashboard-Team. */
export type StoreCampaign = {
  __typename?: 'StoreCampaign';
  accountManagerId?: Maybe<Scalars['Int']>;
  commissionEligibleSalesrepId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['Int']>;
  gool?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  initialGoalCents?: Maybe<Scalars['Int']>;
  joinCode?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  originalSalesrepId?: Maybe<Scalars['Int']>;
  salesrepId?: Maybe<Scalars['Int']>;
  settlementConfirmationStatus?: Maybe<Scalars['String']>;
  settlementMethod?: Maybe<Scalars['String']>;
  settlementStatus?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teamSize?: Maybe<Scalars['Int']>;
  totalRaisedCents?: Maybe<Scalars['Int']>;
  userDirectoryId?: Maybe<Scalars['String']>;
};

/** This is Store-Sso-User-Info Type. That is used represent the GL info that we store in our local DB. This is Own-Used By Store-Dashboard-Team. */
export type StoreSsoUserInfo = {
  __typename?: 'StoreSsoUserInfo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userRole?: Maybe<StoreRolesOnPermissions>;
  userSsoId?: Maybe<Scalars['String']>;
};

/** This is Store-Roles-On-Permissions Type. That is used represent store-dashboard-roles-and-permissions. This is Own-Used By Store-Dashboard-Team. */
export type StoreRolesOnPermissions = {
  __typename?: 'StoreRolesOnPermissions';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userRoleOnPermissions?: Maybe<Array<Maybe<StorePermission>>>;
};

/** This is Store-Permission Type. That is used represent store-dashboard-permissions-objects. This is Own-Used By Store-Dashboard-Team. */
export type StorePermission = {
  __typename?: 'StorePermission';
  permission?: Maybe<StorePermissionInfo>;
};

/** This is Store-Permission-Info Type. That is used represent store-dashboard-permissions-info. This is Own-Used By Store-Dashboard-Team. */
export type StorePermissionInfo = {
  __typename?: 'StorePermissionInfo';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type HmStore = {
  __typename?: 'HmStore';
  active_stores?: Maybe<Scalars['String']>;
  monthly_sales?: Maybe<Array<Maybe<HmGraphSales>>>;
  total_orders?: Maybe<Scalars['String']>;
  total_points?: Maybe<Scalars['String']>;
  total_sales?: Maybe<Scalars['String']>;
};

export type HmGraphSales = {
  __typename?: 'HmGraphSales';
  soldDuringWeek?: Maybe<Scalars['Int']>;
  weekName?: Maybe<Scalars['String']>;
};

export type StoresFilterUnionType = OnException | StoreFilter;

/** This is Store-Filter Type. That represent the response of storeFilter Query. This is Own-Used By Store-Dashboard-Team. */
export type StoreFilter = {
  __typename?: 'StoreFilter';
  paging?: Maybe<StorePaging>;
  stores?: Maybe<Array<Maybe<Store>>>;
  totalPoints?: Maybe<Scalars['Float']>;
  totalStores?: Maybe<Scalars['Int']>;
};

/** This is Store-Paging Type. That represent the response of pagination of storeFilter Query. This is Own-Used By Store-Dashboard-Team. */
export type StorePaging = {
  __typename?: 'StorePaging';
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type StoreManagerUnionType = OnException | StoreManagers;

export type StoreManagers = {
  __typename?: 'StoreManagers';
  managers?: Maybe<Array<Maybe<StoreManager>>>;
};

/** This is Store-Manager Type. That represent customer with role manager of Magento. This is Own-Used By Store-Dashboard-Team. */
export type StoreManager = {
  __typename?: 'StoreManager';
  customerId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Int']>;
  scopeId?: Maybe<Scalars['Int']>;
  storeId?: Maybe<Scalars['Int']>;
  storeName?: Maybe<Scalars['String']>;
};

export type StoreNewActivityUnionType = OnException | StoreNewActivity;

/** This is Store-New-Activity Type. That is used to check new activities in raward-points-activity. */
export type StoreNewActivity = {
  __typename?: 'StoreNewActivity';
  count?: Maybe<Scalars['Int']>;
  newActivities?: Maybe<Scalars['Boolean']>;
};

export type StoreNewOrdersCheckUnionType = OnException | StoreNewOrdersCheck;

/** This is Store-New-Orders-Check Type. That is used check new orders. This is Own-Used By Store-Dashboard-Team. */
export type StoreNewOrdersCheck = {
  __typename?: 'StoreNewOrdersCheck';
  count?: Maybe<Scalars['Int']>;
  newOrders?: Maybe<Scalars['Boolean']>;
};

export type StoreOrderUnionType = OnException | StoreOrder;

/** This is Store-Order Type. That represent orders of stores. This is Own-Used By Store-Dashboard-Team. */
export type StoreOrder = {
  __typename?: 'StoreOrder';
  createdAt?: Maybe<Scalars['String']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerFirstName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  customerLastName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  incrementId?: Maybe<Scalars['String']>;
  isChecked?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<StoreItem>>>;
  orderId?: Maybe<Scalars['Int']>;
  scopeId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  store?: Maybe<Store>;
  storeId?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** This is Store-Item Type. That represent items of orders. This is Own-Used By Store-Dashboard-Team. */
export type StoreItem = {
  __typename?: 'StoreItem';
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<Scalars['String']>;
  qtyOrdered?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
};

export type StoreOrdersUnionType = OnException | StoreOrders;

export type StoreOrders = {
  __typename?: 'StoreOrders';
  orders?: Maybe<Array<Maybe<StoreOrder>>>;
};

export type StoreFilterInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
  optionValue?: InputMaybe<Scalars['ID']>;
  scopeId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

export type StoreOrdersListingUnionType = OnException | StoreOrdersListing;

/** This is Store-Orders-Listing Type. That represent the response. This is Own-Used By Store-Dashboard-Team. */
export type StoreOrdersListing = {
  __typename?: 'StoreOrdersListing';
  orders?: Maybe<Array<Maybe<StoreOrder>>>;
  pagination?: Maybe<StorePagination>;
};

/** This is Store-Pagination Type. That represent pagination in orders/activities listing. This is Own-Used By Store-Dashboard-Team. */
export type StorePagination = {
  __typename?: 'StorePagination';
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type StoreOrdersSummaryUnionType = OnException | StoreOrdersSummary;

/** This is Store-Orders-Summary Type. That is used to represent the orders per store details. This is Own-Used By Store-Dashboard-Team. */
export type StoreOrdersSummary = {
  __typename?: 'StoreOrdersSummary';
  complete?: Maybe<Scalars['Int']>;
  processing?: Maybe<Scalars['Int']>;
  shipped?: Maybe<Scalars['Int']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type StoreParticipantUnionType = OnException | StoreCampaignParticipant;

export type StoreCampaignParticipant = {
  __typename?: 'StoreCampaignParticipant';
  participants?: Maybe<Array<Maybe<StoreParticipant>>>;
};

/** This is Store-Participant Type. That is used represent participent in campaigns. This is Own-Used By Store-Dashboard-Team. */
export type StoreParticipant = {
  __typename?: 'StoreParticipant';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type StorePointsActivityReturnUnionType = OnException | StoresPointsActivityReturn;

export type StoresPointsActivityReturn = {
  __typename?: 'StoresPointsActivityReturn';
  pointsActivity?: Maybe<Array<Maybe<StorePointsActivityReturn>>>;
};

/** This is Store-Points-Activity-Return Type. That represent the reward-point-activity for specific reward-points. This is Own-Used By Store-Dashboard-Team. */
export type StorePointsActivityReturn = {
  __typename?: 'StorePointsActivityReturn';
  createdAt?: Maybe<Scalars['String']>;
  customer?: Maybe<StoreCustomer>;
  customerId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  eventCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pointsBalance?: Maybe<Scalars['Float']>;
  pointsDelta?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  store?: Maybe<Store>;
  storeId?: Maybe<Scalars['Int']>;
  transactionId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type StorePointsActivityFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
  optionValue?: InputMaybe<Scalars['ID']>;
  scopeId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

export type StorePointsActivityFilterUnionType = OnException | StoreFilterActivity;

/** This is Store-Filter-Activity Type. That represent the response of storePointsActivityFilter Query. This is Own-Used By Store-Dashboard-Team. */
export type StoreFilterActivity = {
  __typename?: 'StoreFilterActivity';
  activities?: Maybe<Array<Maybe<StorePointsActivityReturn>>>;
  pagination?: Maybe<StorePagination>;
};

export type StorePointsEarned = {
  customerId: Scalars['Int'];
  scopeId: Scalars['Int'];
};

export type StorePointsEarnedGraphUnionType = OnException | StoresPointsEarnedGraph;

export type StoresPointsEarnedGraph = {
  __typename?: 'StoresPointsEarnedGraph';
  graph?: Maybe<Array<Maybe<StorePointsEarnedGraph>>>;
};

/** This is Store-Points-Earned-Graph Type. That used to show how much point earn by store manager in month. This is Own-Used By Store-Dashboard-Team. */
export type StorePointsEarnedGraph = {
  __typename?: 'StorePointsEarnedGraph';
  endDate?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
};

/** This is Store-Product Type. That is used represent the store-product. This is Own-Used By Store-Dashboard-Team. */
export type StoreProduct = {
  __typename?: 'StoreProduct';
  attributeSetId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  customAttributes?: Maybe<Array<Maybe<StoreCustomizedAttributes>>>;
  extensionAttributes?: Maybe<StoreExtendedAttributes>;
  id?: Maybe<Scalars['String']>;
  mediaGalleryEntries?: Maybe<Array<Maybe<StoreMediaGalleries>>>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<StoreOptionProducts>>>;
  price?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  productLinks?: Maybe<Array<Maybe<StoreProductionLinks>>>;
  scope?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  storeId?: Maybe<Scalars['Int']>;
  tierPrices?: Maybe<Array<Maybe<StoreTierPrices>>>;
  typeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
};

/** This is Store-Customized-Attributes Type. That is used represent the store-products-customized-attributes. This is Own-Used By Store-Dashboard-Team. */
export type StoreCustomizedAttributes = {
  __typename?: 'StoreCustomizedAttributes';
  attributeCode?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** This is Store-Extended-Attributes Type. That is used represent the store-product-extended-attributes. This is Own-Used By Store-Dashboard-Team. */
export type StoreExtendedAttributes = {
  __typename?: 'StoreExtendedAttributes';
  bundleProductOptions?: Maybe<Array<Maybe<StoreProductOptions>>>;
  categoryLinks?: Maybe<Array<Maybe<StoreCatagory>>>;
  configurableProductLinks?: Maybe<Array<Maybe<Scalars['Int']>>>;
  configurableProductOptions?: Maybe<Array<Maybe<StoreConfigProducts>>>;
  customImage?: Maybe<Scalars['String']>;
  downloadableProductLinks?: Maybe<Array<Maybe<StoreDownloads>>>;
  downloadableProductSamples?: Maybe<Array<Maybe<StoreProductSamples>>>;
  stockItem?: Maybe<StoreStock>;
  websiteIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** This is Store-Product-Options Type. That is used represent the store-product-options. This is Own-Used By Store-Dashboard-Team. */
export type StoreProductOptions = {
  __typename?: 'StoreProductOptions';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  optionId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  productLinks?: Maybe<Array<Maybe<StoreProductsLinks>>>;
  required?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** This is Store-Products-Links Type. That is used represent the store-product-links. This is Own-Used By Store-Dashboard-Team. */
export type StoreProductsLinks = {
  __typename?: 'StoreProductsLinks';
  canChangeQuantity?: Maybe<Scalars['Int']>;
  extensionAttributes?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  optionId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  priceType?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
};

/** This is Store-Extended-Attributes Type. That is used represent the store-product-catagory. This is Own-Used By Store-Dashboard-Team. */
export type StoreCatagory = {
  __typename?: 'StoreCatagory';
  categoryId?: Maybe<Scalars['String']>;
  extensionAttributes?: Maybe<Scalars['JSON']>;
  position?: Maybe<Scalars['Int']>;
};

/** This is Store-Config-Products Type. That is used represent the store-product-config. This is Own-Used By Store-Dashboard-Team. */
export type StoreConfigProducts = {
  __typename?: 'StoreConfigProducts';
  attributeId?: Maybe<Scalars['String']>;
  extensionAttributes?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isUseDefault?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<StoreValueProducts>>>;
};

/** This is Store-Value-Products Type. That is used represent the store-product-values. This is Own-Used By Store-Dashboard-Team. */
export type StoreValueProducts = {
  __typename?: 'StoreValueProducts';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  valueIndex?: Maybe<Scalars['Int']>;
};

/** This is Store-Downloads Type. That is used represent the store-product-download. This is Own-Used By Store-Dashboard-Team. */
export type StoreDownloads = {
  __typename?: 'StoreDownloads';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  isShareable?: Maybe<Scalars['Int']>;
  linkFile?: Maybe<Scalars['String']>;
  linkFileString?: Maybe<StoreLinkFile>;
  linkType?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  numberOfDownloads?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  sampleFile?: Maybe<Scalars['String']>;
  sampleFileContent?: Maybe<StoreSampleFile>;
  sampleType?: Maybe<Scalars['String']>;
  sampleUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** This is Store-Link-File Type. That is used represent the store-product-link-file. This is Own-Used By Store-Dashboard-Team. */
export type StoreLinkFile = {
  __typename?: 'StoreLinkFile';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  fileData?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** This is Store-Sample-File Type. That is used represent the store-sample-file. This is Own-Used By Store-Dashboard-Team. */
export type StoreSampleFile = {
  __typename?: 'StoreSampleFile';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  fileData?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** This is Store-Product-Samples Type. That is used represent the store-product-sample. This is Own-Used By Store-Dashboard-Team. */
export type StoreProductSamples = {
  __typename?: 'StoreProductSamples';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['Int']>;
  sampleFile?: Maybe<Scalars['String']>;
  sampleFileContent?: Maybe<StoreSampleFile>;
  sampleType?: Maybe<Scalars['String']>;
  sampleUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** This is Store-Stock Type. That is used represent the store-product-stock. */
export type StoreStock = {
  __typename?: 'StoreStock';
  backorders?: Maybe<Scalars['Int']>;
  enableQtyIncrements?: Maybe<Scalars['Boolean']>;
  extensionAttributes?: Maybe<Scalars['JSON']>;
  isDecimalDivided?: Maybe<Scalars['Boolean']>;
  isInStock?: Maybe<Scalars['Boolean']>;
  isQtyDecimal?: Maybe<Scalars['Boolean']>;
  itemId?: Maybe<Scalars['Int']>;
  lowStockDate?: Maybe<Scalars['String']>;
  manageStock?: Maybe<Scalars['Boolean']>;
  maxSaleQty?: Maybe<Scalars['Int']>;
  minQty?: Maybe<Scalars['Int']>;
  minSaleQty?: Maybe<Scalars['Int']>;
  notifyStockQty?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  qtyIncrements?: Maybe<Scalars['Int']>;
  showDefaultNotificationMessage?: Maybe<Scalars['Boolean']>;
  stockId?: Maybe<Scalars['Int']>;
  stockStatusChangedAuto?: Maybe<Scalars['Int']>;
  useConfigBackorders?: Maybe<Scalars['Boolean']>;
  useConfigEnableQtyInc?: Maybe<Scalars['Boolean']>;
  useConfigManageStock?: Maybe<Scalars['Boolean']>;
  useConfigMaxSaleQty?: Maybe<Scalars['Boolean']>;
  useConfigMinQty?: Maybe<Scalars['Boolean']>;
  useConfigMinSaleQty?: Maybe<Scalars['Int']>;
  useConfigNotifyStockQty?: Maybe<Scalars['Boolean']>;
  useConfigQtyIncrements?: Maybe<Scalars['Boolean']>;
};

/** This is Store-Media-Galleries Type. That is used represent the store-option-galleries. This is Own-Used By Store-Dashboard-Team. */
export type StoreMediaGalleries = {
  __typename?: 'StoreMediaGalleries';
  content?: Maybe<StoreContent>;
  disabled?: Maybe<Scalars['Boolean']>;
  extensionAttributes?: Maybe<StoreExtensiveAttributes>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** This is Store-Content Type. That is used represent the store-products-content. This is Own-Used By Store-Dashboard-Team. */
export type StoreContent = {
  __typename?: 'StoreContent';
  base64EncodedData?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** This is Store-Extensive-Attributes Type. That is used represent the store-extensive-attributes. This is Own-Used By Store-Dashboard-Team. */
export type StoreExtensiveAttributes = {
  __typename?: 'StoreExtensiveAttributes';
  videoContent?: Maybe<StoreVideoContent>;
};

/** This is Store-Video-Content Type. That is used represent the store-video-content. This is Own-Used By Store-Dashboard-Team. */
export type StoreVideoContent = {
  __typename?: 'StoreVideoContent';
  mediaType?: Maybe<Scalars['String']>;
  videoDescription?: Maybe<Scalars['String']>;
  videoMetadata?: Maybe<Scalars['String']>;
  videoProvider?: Maybe<Scalars['String']>;
  videoTitle?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

/** This is Store-Option-Products Type. That is used represent the store-options-products. This is Own-Used By Store-Dashboard-Team. */
export type StoreOptionProducts = {
  __typename?: 'StoreOptionProducts';
  extensionAttributes?: Maybe<Scalars['JSON']>;
  fileExtension?: Maybe<Scalars['String']>;
  imageSizeX?: Maybe<Scalars['Int']>;
  imageSizeY?: Maybe<Scalars['Int']>;
  isRequire?: Maybe<Scalars['Boolean']>;
  maxCharacters?: Maybe<Scalars['Int']>;
  optionId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  priceType?: Maybe<Scalars['String']>;
  productSku?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<StoreOptionProductsValues>>>;
};

/** This is Store-Option-Products-Values Type. That is used represent the store-option-products-values. */
export type StoreOptionProductsValues = {
  __typename?: 'StoreOptionProductsValues';
  optionTypeId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  priceType?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** This is Store-Production-Links Type. That is used represent the store-production-links. This is Own-Used By Store-Dashboard-Team. */
export type StoreProductionLinks = {
  __typename?: 'StoreProductionLinks';
  extensionAttributes?: Maybe<StoreExtensAttributes>;
  linkedProductSku?: Maybe<Scalars['String']>;
  linkedProductType?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
};

/** This is Store-Extens-Attributes Type. That is used represent the store-extens-attributes. This is Own-Used By Store-Dashboard-Team. */
export type StoreExtensAttributes = {
  __typename?: 'StoreExtensAttributes';
  qty?: Maybe<Scalars['Int']>;
};

/** This is Store-Tier-Prices Type. That is used represent the store-products-tier-prices. This is Own-Used By Store-Dashboard-Team. */
export type StoreTierPrices = {
  __typename?: 'StoreTierPrices';
  customerGroupId?: Maybe<Scalars['Int']>;
  extensionAttributes?: Maybe<StoreExtendAttributes>;
  qty?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** This is Store-Extend-Attributes Type. That is used represent the store-products-extend-attributes. This is Own-Used By Store-Dashboard-Team. */
export type StoreExtendAttributes = {
  __typename?: 'StoreExtendAttributes';
  percentageValue?: Maybe<Scalars['Int']>;
  websiteId?: Maybe<Scalars['Int']>;
};

export type CampaignStoresUnionType = OnException | Stores;

export type Stores = {
  __typename?: 'Stores';
  stores?: Maybe<Array<Maybe<Store>>>;
};

export type StoreSalesReport = {
  duration?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['Int'];
};

export type StoreSalesGraphUnionType = OnException | StoreSalesGraph;

export type StoreSalesGraph = {
  __typename?: 'StoreSalesGraph';
  graph?: Maybe<Array<Maybe<StoreSalesReportGraph>>>;
};

/** This is Store-NewOrders-Check Type That is used check new orders. This is Own-Used By Store-Dashboard-Team. */
export type StoreSalesReportGraph = {
  __typename?: 'StoreSalesReportGraph';
  endDate?: Maybe<Scalars['String']>;
  sales?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
};

export type StoreOrdersDetailsUnionType = OnException | StoreOrderDetails;

/** This is Store-Order-Details Type. That represent stores orders details. This is Own-Used By Store-Dashboard-Team. */
export type StoreOrderDetails = {
  __typename?: 'StoreOrderDetails';
  orders?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Float']>;
  sales?: Maybe<Scalars['Float']>;
};

export type StoreTicketUnionType = OnException | StoreTickets;

export type StoreTickets = {
  __typename?: 'StoreTickets';
  tickets?: Maybe<Array<Maybe<StoreTicket>>>;
};

/** This is Store-Ticket Type. That represent the zendesk-tickets store in our DB. This is Own-Used By Store-Dashboard-Team. */
export type StoreTicket = {
  __typename?: 'StoreTicket';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['Int']>;
  store?: Maybe<Store>;
  subject?: Maybe<Scalars['String']>;
  ticketId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type TeamByCodeInput = {
  sport_code: Scalars['String'];
};

export type OfficialByIdInput = {
  id: Scalars['Int'];
};

export type TemplateOfficial = {
  __typename?: 'TemplateOfficial';
  id: Scalars['Int'];
  pay?: Maybe<Scalars['Float']>;
  pay_code?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  worker_duty?: Maybe<Scalars['String']>;
};

export type PreparationByIdInput = {
  id: Scalars['Int'];
};

export type TemplatePreparation = {
  __typename?: 'TemplatePreparation';
  id: Scalars['Int'];
  prep?: Maybe<Scalars['Int']>;
  preparation_id?: Maybe<Scalars['String']>;
  preparation_name?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
};

export type WorkerByIdInput = {
  id: Scalars['Int'];
};

export type TemplateWorker = {
  __typename?: 'TemplateWorker';
  home_field?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  pay?: Maybe<Scalars['Float']>;
  pay_code?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  worker_duty?: Maybe<Scalars['String']>;
  worker_name?: Maybe<Scalars['String']>;
};

/** Indexes for table twispCardBalances */
export enum TwispCardBalances_Indexes {
  CardId = 'card_id'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Input object for index query filters. */
export type Where = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gt?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gte?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lte?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partition?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TwispCardBalances = {
  __typename?: 'twispCardBalances';
  allTxs?: Maybe<Array<Maybe<TwispTransactions>>>;
  authorization_balance?: Maybe<Scalars['Int64']>;
  balance?: Maybe<Scalars['Int64']>;
  card_id?: Maybe<Scalars['String']>;
  card_limit?: Maybe<Scalars['Int64']>;
  history?: Maybe<Array<Maybe<TwispCardBalances>>>;
  seq?: Maybe<Scalars['Uint64']>;
  settled_balance?: Maybe<Scalars['Int64']>;
  visibleTxs?: Maybe<Array<Maybe<TwispTransactions>>>;
};


export type TwispCardBalancesHistoryArgs = {
  limit?: InputMaybe<Scalars['Int32']>;
  sort?: InputMaybe<Sort>;
};

export type TwispTransactions = {
  __typename?: 'twispTransactions';
  amount?: Maybe<Scalars['Int64']>;
  card_id?: Maybe<Scalars['String']>;
  correlation?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int64']>;
  description?: Maybe<Scalars['String']>;
  event_created?: Maybe<Scalars['Int64']>;
  history?: Maybe<Array<Maybe<TwispTransactions>>>;
  id?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  seq?: Maybe<Scalars['Uint64']>;
  status?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};


export type TwispTransactionsHistoryArgs = {
  limit?: InputMaybe<Scalars['Int32']>;
  sort?: InputMaybe<Sort>;
};


export type TwispTransactionsMetaArgs = {
  expression?: InputMaybe<Scalars['String']>;
};

/** Indexes for table twispCards */
export enum TwispCards_Indexes {
  CardId = 'card_id'
}

export type TwispCards = {
  __typename?: 'twispCards';
  card_id?: Maybe<Scalars['String']>;
  history?: Maybe<Array<Maybe<TwispCards>>>;
  last4?: Maybe<Scalars['String']>;
  seq?: Maybe<Scalars['Uint64']>;
};


export type TwispCardsHistoryArgs = {
  limit?: InputMaybe<Scalars['Int32']>;
  sort?: InputMaybe<Sort>;
};

/** Indexes for table twispStripeHooks */
export enum TwispStripeHooks_Indexes {
  Id = 'id'
}

export type TwispStripeHooks = {
  __typename?: 'twispStripeHooks';
  account?: Maybe<Scalars['String']>;
  api_version?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int64']>;
  data?: Maybe<Scalars['JSON']>;
  history?: Maybe<Array<Maybe<TwispStripeHooks>>>;
  id?: Maybe<Scalars['String']>;
  livemode?: Maybe<Scalars['Boolean']>;
  object?: Maybe<Scalars['String']>;
  pending_webhooks?: Maybe<Scalars['Int64']>;
  processed?: Maybe<Scalars['Timestamp']>;
  request?: Maybe<Scalars['JSON']>;
  seq?: Maybe<Scalars['Uint64']>;
  type?: Maybe<Scalars['String']>;
};


export type TwispStripeHooksDataArgs = {
  expression?: InputMaybe<Scalars['String']>;
};


export type TwispStripeHooksHistoryArgs = {
  limit?: InputMaybe<Scalars['Int32']>;
  sort?: InputMaybe<Sort>;
};


export type TwispStripeHooksRequestArgs = {
  expression?: InputMaybe<Scalars['String']>;
};

/** Indexes for table twispTransactions */
export enum TwispTransactions_Indexes {
  CardId = 'card_id',
  CardIdViz = 'card_id_viz',
  Id = 'id'
}

export type UnconfirmedEventsFiltersInput = {
  activity?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  opponents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  year?: InputMaybe<Scalars['String']>;
};

export type UnconfirmedEventsList = {
  __typename?: 'UnconfirmedEventsList';
  items?: Maybe<Array<Maybe<UnconfirmedEvents>>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  totalFilteredItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type UnconfirmedEvents = {
  __typename?: 'UnconfirmedEvents';
  activity?: Maybe<Scalars['String']>;
  bus_count?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_phone?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  g_s?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  home_field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['String']>;
  opponent?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  season_id?: Maybe<Scalars['Int']>;
  sports_code?: Maybe<Scalars['String']>;
  sports_description?: Maybe<Scalars['String']>;
  sports_group?: Maybe<Scalars['String']>;
  sports_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type UserPermissionsList = {
  __typename?: 'UserPermissionsList';
  id?: Maybe<Scalars['String']>;
  negativePermissions?: Maybe<Array<Maybe<UserPermission>>>;
  permissions?: Maybe<Array<Maybe<UserPermission>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  id: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
};

export type UserPublic = {
  __typename?: 'UserPublic';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  notMigrated?: Maybe<Scalars['Boolean']>;
  profilePicture?: Maybe<Scalars['String']>;
};

export type Users = {
  __typename?: 'Users';
  nextPage?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<User>>>;
};

/** Organizations/Companies */
export type VaultKyb = {
  __typename?: 'VaultKyb';
  address: VaultAddress;
  customerFacingName: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  legalName: Scalars['String'];
  phoneNumber: Scalars['String'];
  structure: Kyb_Structure;
  taxId: Scalars['String'];
  type: Kyb_Type;
  url: Scalars['String'];
};

export enum Kyb_Structure {
  FreeZoneEstablishment = 'free_zone_establishment',
  FreeZoneLlc = 'free_zone_llc',
  GovernmentInstrumentality = 'government_instrumentality',
  GovernmentalUnit = 'governmental_unit',
  IncorporatedNonProfit = 'incorporated_non_profit',
  LimitedLiabilityPartnership = 'limited_liability_partnership',
  Llc = 'llc',
  MultiMemberLlc = 'multi_member_llc',
  PrivateCompany = 'private_company',
  PrivateCorporation = 'private_corporation',
  PrivatePartnership = 'private_partnership',
  PublicCompany = 'public_company',
  PublicCorporation = 'public_corporation',
  PublicPartnership = 'public_partnership',
  SingleMemberLlc = 'single_member_llc',
  SoleEstablishment = 'sole_establishment',
  SoleProprietorship = 'sole_proprietorship',
  TaxExemptGovernmentInstrumentality = 'tax_exempt_government_instrumentality',
  UnincorporatedAssociation = 'unincorporated_association',
  UnincorporatedNonProfit = 'unincorporated_non_profit'
}

export enum Kyb_Type {
  Company = 'company',
  GovernmentEntity = 'government_entity',
  Individual = 'individual',
  NonProfit = 'non_profit'
}

export type GetVehicleByIdInput = {
  id: Scalars['Int'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['Int'];
  is_deleted?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  vehicle_type?: Maybe<Scalars['String']>;
};

export type GetWorkerPoolByIdInput = {
  ID: Scalars['Int'];
};

export type WorkerPool = {
  __typename?: 'WorkerPool';
  Address?: Maybe<Scalars['String']>;
  cell_phone?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  First?: Maybe<Scalars['String']>;
  Home_Phone?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  is_deleted?: Maybe<Scalars['String']>;
  Last?: Maybe<Scalars['String']>;
  pay_rate?: Maybe<Scalars['Float']>;
  SSN?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Work_Phone?: Maybe<Scalars['String']>;
  worker_type?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateWalletCard?: Maybe<Scalars['String']>;
  activateWalletVirtualCard?: Maybe<Scalars['Boolean']>;
  activateWalletVirtualCardConfirm?: Maybe<Scalars['Boolean']>;
  campaignPersonListCreate?: Maybe<CampaignPersonList>;
  campaignPersonListEntryUpdate?: Maybe<Scalars['String']>;
  /** Create saved search filters for campaigns for current user. */
  campaignSearchFilterCreate?: Maybe<CampaignSearchFilter>;
  /** Remove saved search filters for campaigns for current user. */
  campaignSearchFilterDelete?: Maybe<CampaignSearchFilter>;
  completeWalletRegister?: Maybe<Scalars['Boolean']>;
  confirmPassword?: Maybe<Scalars['String']>;
  confirmWalletOrganizationInfo?: Maybe<WalletConfirmOrganizationInfoResult>;
  /** Deletes a custom template based off ID */
  contactTemplateDelete?: Maybe<CustomContactTemplates>;
  /** Saves custom contact-template for current user */
  contactTemplateSave?: Maybe<CustomContactTemplates>;
  /** @deprecated This will be replaced with latestCreateCard after data has been migrated from Spend and Raise */
  createCard: CoreCardFields;
  createFundraiserUser?: Maybe<CreatedFundraiserUser>;
  createOtkParticipantEntry?: Maybe<CreatedOtkEntry>;
  createPrefund?: Maybe<Prefund>;
  createPrefundTopup?: Maybe<Scalars['Boolean']>;
  /** Finalize the (closed) fundraiser after campaign settled. */
  driveCampaignFinalize?: Maybe<IMutationResult>;
  /** Settle the fundraiser when campaigns start to be closed campaigns. */
  driveCampaignSettle?: Maybe<IMutationResult>;
  /** Update the fundraiser. Right now only fundraiser notes can be updated. */
  driveCampaignUpdate?: Maybe<IMutationResult>;
  /** Posts a message in the activity feed */
  driveEventActivityCreate?: Maybe<DriveEventActivityFeed>;
  /** Removeds an activity feed message */
  driveEventActivityRemove?: Maybe<Scalars['String']>;
  /** Updates the message and feature toggle in a activity message */
  driveEventActivityUpdate?: Maybe<DriveEventActivityFeed>;
  /** Takes in 2 arguments to post the agendas */
  driveEventAgendaCreate?: Maybe<DriveEventAgendaItem>;
  /** Adds an attendee to event. */
  driveEventAttendeeAdd?: Maybe<DriveEventAttendee>;
  /** Removes an attendee from event. */
  driveEventAttendeesRemove?: Maybe<Scalars['Int']>;
  /** Updates attendance information of attendee. */
  driveEventAttendeeUpdate?: Maybe<DriveEventAttendee>;
  /** Create Event (Drive Event-Tracker) */
  driveEventCreate?: Maybe<DriveEvent>;
  /** Delete Event (Drive Event-Tracker) */
  driveEventRemove?: Maybe<Scalars['String']>;
  /** Update Event (Drive Event-Tracker) */
  driveEventUpdate?: Maybe<DriveEvent>;
  /** Resizes the uploaded attachment in S3 in Drive. */
  driveS3ImageResize?: Maybe<Scalars['String']>;
  /** Generate S3 generate pre-signed url for Drive to upload. This is used for uploading big attachments to the support ticket */
  driveUploadUrlCreate: Scalars['String'];
  eventCreate?: Maybe<Event>;
  eventDelete?: Maybe<Event>;
  eventModify?: Maybe<Event>;
  eventParticipantsCreate?: Maybe<EventParticipants>;
  eventParticipantsDelete?: Maybe<EventParticipants>;
  eventParticipantsModify?: Maybe<EventParticipants>;
  eventPreparationCreate?: Maybe<DailyCalendarPreparation>;
  eventPreparationDelete?: Maybe<DailyCalendarPreparation>;
  eventPreparationModify?: Maybe<DailyCalendarPreparation>;
  eventPreparationsCreate?: Maybe<EventPreparations>;
  eventPreparationsCreateMany?: Maybe<Array<Maybe<EventPreparations>>>;
  eventPreparationsDelete?: Maybe<EventPreparations>;
  eventPreparationsDeleteMany?: Maybe<ModifyDeleteCount>;
  eventPreparationsModify?: Maybe<EventPreparations>;
  eventPreparationsModifyMany?: Maybe<ModifyDeleteCount>;
  eventPreparationsUpsert?: Maybe<EventPreparations>;
  eventTransportDetailsCreate?: Maybe<EventTransportDetails>;
  eventTransportDetailsDelete?: Maybe<EventTransportDetails>;
  eventTransportDetailsModify?: Maybe<EventTransportDetails>;
  facilityCreate?: Maybe<Facility>;
  facilityDelete?: Maybe<Facility>;
  facilityModify?: Maybe<Facility>;
  financialAcctCreate?: Maybe<MutationResponse>;
  financialAcctDelete?: Maybe<MutationResponse>;
  financialAcctUpdate?: Maybe<MutationResponse>;
  financialAcctUserAssociate?: Maybe<MutationResponse>;
  /** Send out email to group-leader. Support CC emails */
  groupLeaderEmailSend?: Maybe<IMutationResult>;
  /** Update hubspot call engagement for fundraiser */
  hubspotCallEngagementToDealAdd?: Maybe<HubspotCallEngagement>;
  /** Update hubspot note engagement for fundraiser */
  hubspotNoteEngagementToDealAdd?: Maybe<HubspotCallEngagement>;
  issuePendingCards?: Maybe<Array<Scalars['ID']>>;
  joinFundraiserUser: JoinedFundraiserId;
  latestVaultCardCreate: Scalars['ID'];
  levelCreate?: Maybe<Level>;
  levelDelete?: Maybe<Level>;
  levelModify?: Maybe<Level>;
  linkUserToSponsor?: Maybe<Scalars['Boolean']>;
  linkUserToSponsorSchool?: Maybe<Scalars['Boolean']>;
  login?: Maybe<Auth>;
  logout?: Maybe<Scalars['Boolean']>;
  manageUserCreate?: Maybe<ManageUser>;
  manageUserDelete?: Maybe<ManageUser>;
  manageUserUpdate?: Maybe<ManageUser>;
  noticeCreate?: Maybe<Notice>;
  noticeDelete?: Maybe<Notice>;
  notifyIncorrectWalletInfo?: Maybe<Scalars['Boolean']>;
  officialCreate?: Maybe<Official>;
  officialDelete?: Maybe<Official>;
  officialDutiesCreate?: Maybe<OfficialDuties>;
  officialDutiesDelete?: Maybe<OfficialDuties>;
  officialDutiesModify?: Maybe<OfficialDuties>;
  officialModify?: Maybe<Official>;
  officialPoolCreate?: Maybe<OfficialPool>;
  officialPoolDelete?: Maybe<Array<Maybe<OfficialPool>>>;
  officialPoolModify?: Maybe<OfficialPool>;
  officialsUpsert?: Maybe<Array<Maybe<OfficialPool>>>;
  opponentCreate?: Maybe<Opponent>;
  opponentDelete?: Maybe<Opponent>;
  opponentModify?: Maybe<Opponent>;
  opponentsUpsert?: Maybe<Array<Maybe<Opponent>>>;
  participantDonationInviteEmailAdd?: Maybe<DonorEmailData>;
  participantDonationInviteEmailFollowUp?: Maybe<DonationInviteFollowUpEmail>;
  participantDonationInviteSMSAdd?: Maybe<DonationInviteSmsData>;
  /** This will update the emails of a Participant's Guardian Email field */
  participantGuardianEmailUpdate: ParticipantGuardianEmailUpdate;
  participantIncentiveSelectionDelete?: Maybe<DeletedIncentiveRecord>;
  participantRewardsCreate?: Maybe<CreatedParticipantRewards>;
  /** Send out emails to particpants */
  participantsEmailSend?: Maybe<IMutationResult>;
  participantSignup: Array<TransportType>;
  /** Sends out texts to particpants */
  participantsTextSend?: Maybe<IMutationResult>;
  /** Schedule time (timezone-sensitive) to send out preload email to all participants */
  preloadEmailScheduleSend?: Maybe<PreloadEmailSchedule>;
  /** Send out preload email to all participants */
  preloadEmailSend?: Maybe<Scalars['String']>;
  preparationCreate?: Maybe<Preparation>;
  preparationDelete?: Maybe<Preparation>;
  preparationModify?: Maybe<Preparation>;
  registerWalletUser?: Maybe<WalletUserRegisterResult>;
  roleCreate?: Maybe<Role>;
  roleDelete?: Maybe<Role>;
  rolePermissionsUpdate?: Maybe<Role>;
  roleUpdate?: Maybe<Role>;
  samlCallback?: Maybe<Auth>;
  schoolInfoCreate?: Maybe<SchoolInfo>;
  schoolInfoDelete?: Maybe<SchoolInfo>;
  schoolInfoModify?: Maybe<SchoolInfo>;
  seasonCreate?: Maybe<Season>;
  seasonDelete?: Maybe<Array<Maybe<Season>>>;
  seasonModify?: Maybe<Season>;
  seasonPostponeModify?: Maybe<PostponeUnpostponeResponse>;
  seasonScheduleTeamsCreate?: Maybe<Array<Maybe<Season>>>;
  seasonUnpostponeModify?: Maybe<PostponeUnpostponeResponse>;
  /** Update settlement note for a fundraiser */
  settlementIssuesRecord?: Maybe<Scalars['String']>;
  /** Update settlement status for a fundraiser */
  settlementStatusUpdate?: Maybe<IMutationResult>;
  spendBudgetCreate?: Maybe<SpendBudgetId>;
  spendCategoryCreate?: Maybe<SpendCategoryId>;
  spendCategoryUpdate?: Maybe<SpendCategoryId>;
  spendCategoryUpsertBulk?: Maybe<Array<Maybe<SpendCategoryId>>>;
  spendGroupArchive?: Maybe<SpendGroupId>;
  spendGroupCreate?: Maybe<SpendGroupId>;
  spendGroupDuplicate?: Maybe<SpendGroupId>;
  spendGroupRosterCreate?: Maybe<SpendGroupRosterId>;
  spendGroupRostersCreate?: Maybe<Array<Maybe<SpendGroupRosterId>>>;
  spendGroupUpdate?: Maybe<SpendGroupId>;
  spendInvoiceCreate?: Maybe<SpendInvoiceId>;
  spendInvoiceReminderCreate?: Maybe<SpendNotificationId>;
  spendNotificationCreate?: Maybe<SpendNotificationStatus>;
  spendOrganizationApprove?: Maybe<SpendOrganizationStatus>;
  spendOrganizationCreate?: Maybe<SpendOrganizationId>;
  spendPaymentScheduleCreate?: Maybe<SpendPaymentScheduleId>;
  spendPaymentScheduleUpdate?: Maybe<SpendPaymentScheduleId>;
  spendRoleChange?: Maybe<SpendRoleId>;
  spendSeasonCreate?: Maybe<SpendSeasonId>;
  spendSeasonUpdate?: Maybe<SpendSeasonId>;
  spendSessionCreate?: Maybe<SpendSession>;
  spendSessionDelete?: Maybe<SpendSessionId>;
  spendSessionRefresh?: Maybe<SpendSessionId>;
  spendSettingsUpdate?: Maybe<SpendOrganizationId>;
  spendTransactionsCreate?: Maybe<SpendTransactionsIdList>;
  spendUserInviteCreate?: Maybe<SpendInviteId>;
  spendUserInviteResend?: Maybe<SpendInviteId>;
  spendUserInviteUpdate?: Maybe<SpendInviteId>;
  spendUserRoleArchive?: Maybe<SpendUserId>;
  spendUserRoleUpdate?: Maybe<SpendUserRoleId>;
  sponsorCartAssetAdd?: Maybe<SponsorsOnAssets>;
  sponsorCartAssetRemove?: Maybe<SponsorsOnAssets>;
  sponsorCartCheckout?: Maybe<Array<Maybe<Asset>>>;
  sponsorCreate?: Maybe<Sponsor>;
  sponsorDistrictCreate?: Maybe<SponsorDistrict>;
  sponsorDistrictDelete?: Maybe<SponsorDistrict>;
  sponsorDistrictUpdate?: Maybe<SponsorDistrict>;
  sponsorInvitationCreate?: Maybe<Array<Maybe<Invite>>>;
  sponsorLogoUpdate?: Maybe<Sponsor>;
  sponsorPackageAttachmentUpdate?: Maybe<SponsorsOnAssets>;
  sponsorPaymentIntentCreate?: Maybe<PaymentIntent>;
  sponsorPaymentMethodEnable?: Maybe<SponsorPaymentMethod>;
  sponsorPaymentMethodSave?: Maybe<SponsorPaymentMethod>;
  sponsorSchoolCreate?: Maybe<SponsorSchool>;
  sponsorSchoolDelete?: Maybe<SponsorSchool>;
  sponsorSchoolProgramCreate?: Maybe<SponsorSchoolProgram>;
  sponsorSchoolProgramDelete?: Maybe<SponsorSchoolProgram>;
  sponsorSchoolProgramUpdate?: Maybe<SponsorSchoolProgram>;
  sponsorSchoolUpdate?: Maybe<SponsorSchool>;
  sponsorshipGroupAssetCreate?: Maybe<MultipleCreationResponse>;
  sponsorshipGroupAssetDelete?: Maybe<Asset>;
  sponsorshipGroupAssetDuplicate?: Maybe<Asset>;
  sponsorshipGroupAssetUpdate?: Maybe<Asset>;
  sponsorshipGroupCreate?: Maybe<SponsorshipGroup>;
  sponsorshipGroupDelete?: Maybe<SponsorshipGroup>;
  sponsorshipGroupInviteRemind?: Maybe<Scalars['Boolean']>;
  sponsorshipGroupOrderStatusUpdate?: Maybe<SponsorshipGroupOnOrder>;
  sponsorshipGroupUpdate?: Maybe<SponsorshipGroup>;
  sponsorShipGroupUserAssociation?: Maybe<MultipleCreationResponse>;
  sponsorshipGroupUserInvite?: Maybe<Scalars['Boolean']>;
  sponsorShipLogoUpdate?: Maybe<SponsorshipGroup>;
  sponsorShipTeamPhotoUpdate?: Maybe<SponsorshipGroup>;
  sponsorSubDistrictCreate?: Maybe<SponsorDistrict>;
  sponsorSubDistrictDelete?: Maybe<SponsorSubDistrict>;
  sponsorSubDistrictUpdate?: Maybe<SponsorSubDistrict>;
  sponsorUpdate?: Maybe<Sponsor>;
  /** This is Store-Activities-Checked-Mutation. That is used to update points-activity isChecked flag. Using storeId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeActivitiesChecked: Scalars['Boolean'];
  /** This is Store-Create-Mutation. That is used to create new store. Using input StoreInput Own-Used By Store-Dashboard-Team. */
  storeCreate: Store;
  /** This is Store-Manager-Points-Update-Mutation. That is used update points of store manager. Using input StoreTransferCustomer as param Own-Used By Store-Dashboard-Team. */
  storeManagerPointsUpdate?: Maybe<StoreManagerUpdatePointsUnionType>;
  /** This is Store-Order-Change-Status-Mutation. That is used to change status of Order. Using orderId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeOrderChangeStatus: StoreOrder;
  /** This is Store-Order-Delete-Mutation. That is used to change the type of Order. Using orderId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeOrderChangeType: StoreOrder;
  /** This is Store-Order-Checked-Mutation. That is used to update the check flag. Using storeId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeOrderChecked: Scalars['Boolean'];
  /** This is Store-Order-Create-Mutation. That is used to create new Order. Using input StoreInputOrder as param Own-Used By Store-Dashboard-Team. */
  storeOrderCreate: StoreOrder;
  /** This is Store-Order-Delete-mutation. That is used to delete Order. Using orderId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeOrderDelete: StoreOrder;
  /** This is Store-Order-Update-Mutation. That is used to update Order. Using input StoreUpdateOrder as param Own-Used By Store-Dashboard-Team. */
  storeOrderUpdate: StoreOrder;
  /** This is Store-Payment-Intent-Create-Mutation. That is used to create new payment intent of stripe. Using input StoreCreatePaymentIntent as param Own-Used By Store-Dashboard-Team. */
  storePaymentIntentCreate?: Maybe<StorePaymantIntentUnionType>;
  /** This is Store-Product-Create-Mutation. That is used to create new product. Using input StoreProductInput as param Own-Used By Store-Dashboard-Team. */
  storeProductCreate: StoreProduct;
  /** This is Store-Product-Remove-Mutation. That is used to remove product. Using productId(Int) as param Own-Used By Store-Dashboard-Team. */
  storeProductRemove: StoreProduct;
  /** This is Store-Product-Update-Mutation. That is used to update the product. Using input StoreProductUpdateInput as param Own-Used By Store-Dashboard-Team. */
  storeProductUpdate: StoreProduct;
  /** This is Store-Removed-Mutation. That is used to remove store. Using storeId (int) as param Own-Used By Store-Dashboard-Team. */
  storeRemove: Store;
  /** This is Store-Save-Points-Activity-Mutation. That is used to add new record in reward points activity. Using input StorePointsActivityInput as param Own-Used By Store-Dashboard-Team. */
  storeSavePointsActivity: StorePointsActivityReturn;
  /** This is Store-Sso-User-Save-Mutation. That is used to save the current logged in user info. Using input StoreCampaignInfoInput as param Own-Used By Store-Dashboard-Team. */
  storeSsoUserSave?: Maybe<StoreCampaignUnionType>;
  /** This is Store-Ticket-Create-Mutation. That is used to create new zendesk ticket. Using input StoreTicketInput as param Own-Used By Store-Dashboard-Team. */
  storeTicketCreate?: Maybe<StoreTicketsUnionType>;
  /** This is Store-Transaction-Save-Mutation. That is used to save transection detaits of stripe. Using input StoreSaveTransaction as param Own-Used By Store-Dashboard-Team. */
  storeTransactionSave?: Maybe<StoreTransactionUnionType>;
  /** This is Store-Transfer-To-Customer-Mutation. That is used to transfer points from store manager to customer of magento. Using input StoreTransferCustomer as param Own-Used By Store-Dashboard-Team. */
  storeTransferToCustomer?: Maybe<StoreTransferPointsUnionType>;
  /** This is Store-Transfer-To-GroupLeader-Mutation. That is used to transfer points from store manager to Group-Leader. Using input StoreTransferGL as param Own-Used By Store-Dashboard-Team. */
  storeTransferToGL?: Maybe<StoreTransferPointsUnionType>;
  /** This is Store-Transfer-To-Participant-Mutation. That is used to transfer points from store manager to participant. Using input StoreTransferParticipant as param Own-Used By Store-Dashboard-Team. */
  storeTransferToParticipant?: Maybe<StoreTransferPointsUnionType>;
  /** This is Store-Update-Mutation. That is used to update store. Using input StoreUpdate as param Own-Used By Store-Dashboard-Team. */
  storeUpdate: Store;
  /** This is Store-Update-Status-Mutation. That is used to update store status. Using input StoreStatusInput as param Own-Used By Store-Dashboard-Team. */
  storeUpdateStatus?: Maybe<StoreStatusUnionType>;
  /** Send support-ticket email to the support team. */
  supportTicketSend?: Maybe<IMutationResult>;
  teamCreate?: Maybe<Team>;
  teamDelete?: Maybe<Team>;
  teamModify?: Maybe<Team>;
  teamOfficialCreate?: Maybe<TemplateOfficial>;
  teamOfficialDelete?: Maybe<TemplateOfficial>;
  teamOfficialModify?: Maybe<TemplateOfficial>;
  teamPreparationCreate?: Maybe<TemplatePreparation>;
  teamPreparationDelete?: Maybe<TemplatePreparation>;
  teamPreparationModify?: Maybe<TemplatePreparation>;
  teamWorkerCreate?: Maybe<TemplateWorker>;
  teamWorkerDelete?: Maybe<TemplateWorker>;
  teamWorkerModify?: Maybe<TemplateWorker>;
  toggleCardActivation: Scalars['String'];
  updateCurrentOrganizationMailingAddress?: Maybe<Organization>;
  updateParticipantGroup?: Maybe<UpdatedParticipantGroupCount>;
  /** This will update the size of a Participant's OTK item */
  updateParticipantOtkSize: FundraiserUserIncentiveId;
  updatePrefund?: Maybe<Scalars['Boolean']>;
  updateWalletCardStatus?: Maybe<Scalars['String']>;
  updateWalletOrganization?: Maybe<Organization>;
  upgradeToManageUser?: Maybe<Scalars['String']>;
  upgradeToWalletUser?: Maybe<User>;
  userAssociate?: Maybe<MutationResponse>;
  userAssociationDelete?: Maybe<MutationResponse>;
  userCreate?: Maybe<User>;
  userEmailConfirm?: Maybe<Scalars['String']>;
  userFittingAdd?: Maybe<UserFitting>;
  userImpersonate?: Maybe<Auth>;
  userImpersonateLogout?: Maybe<Auth>;
  userInvite: Scalars['String'];
  userInviteAccept?: Maybe<UserInviteResponse>;
  userPermissionsUpdate?: Maybe<UserPermissionsList>;
  userPhoneNumberConfirm?: Maybe<Scalars['String']>;
  userRefreshSession?: Maybe<Auth>;
  userResetPassword?: Maybe<UserResetPasswordResponseWithAvailableTransport>;
  userSignup?: Maybe<SignUpResponseWithAvailableTransport>;
  userSignupConfirm?: Maybe<Auth>;
  userSignupConfirmationResend: Array<TransportType>;
  userUpdate?: Maybe<User>;
  userUpdatePassword?: Maybe<User>;
  vaultFinancialAccountCreate?: Maybe<Scalars['String']>;
  vaultKybCreate: Scalars['ID'];
  vaultKybUpdate: Scalars['ID'];
  vaultKycCreate: Scalars['ID'];
  vaultKycUpdate: Scalars['ID'];
  /** @deprecated Relationship data has been moved into VaultKyc */
  vaultRelationshipCreate: Scalars['ID'];
  vaultStripeConnectAccountCreate: Scalars['String'];
  vaultStripeConnectAccountUpdate: Scalars['String'];
  vaultStripePersonCreate: Scalars['String'];
  vaultStripePersonDelete: Scalars['String'];
  vaultStripePersonUpdate: Scalars['String'];
  vaultUnitBusinessApplicationAccountCreate: UnitBusinessApplicationResponse;
  vaultUnitDepositAccountCreate: Scalars['String'];
  vehicleCreate?: Maybe<Vehicle>;
  vehicleDelete?: Maybe<Vehicle>;
  vehicleModify?: Maybe<Vehicle>;
  /** Deprecated: use cron-jobs instead */
  weeklyEventEmailScheduleSend?: Maybe<IMutationResult>;
  workerCreate?: Maybe<Worker>;
  workerDelete?: Maybe<Worker>;
  workerModify?: Maybe<Worker>;
  workerPoolCreate?: Maybe<WorkerPool>;
  workerPoolDelete?: Maybe<Array<Maybe<WorkerPool>>>;
  workerPoolModify?: Maybe<WorkerPool>;
  workersUpsert?: Maybe<Array<Maybe<WorkerPool>>>;
};


export type MutationActivateWalletCardArgs = {
  last4: Scalars['String'];
};


export type MutationActivateWalletVirtualCardArgs = {
  id: Scalars['String'];
};


export type MutationActivateWalletVirtualCardConfirmArgs = {
  code: Scalars['String'];
  id: Scalars['String'];
};


export type MutationCampaignPersonListCreateArgs = {
  contextableId: Scalars['Int'];
  contextableType: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  participantUserId: Scalars['Int'];
  personListType: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationCampaignPersonListEntryUpdateArgs = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationCampaignSearchFilterCreateArgs = {
  filterCriteria?: InputMaybe<Scalars['JSON']>;
  filterName?: InputMaybe<Scalars['String']>;
};


export type MutationCampaignSearchFilterDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationCompleteWalletRegisterArgs = {
  altName?: InputMaybe<Scalars['String']>;
};


export type MutationConfirmPasswordArgs = {
  email: Scalars['String'];
  newPassword?: InputMaybe<Scalars['String']>;
  verificationCode: Scalars['String'];
};


export type MutationConfirmWalletOrganizationInfoArgs = {
  altName?: InputMaybe<Scalars['String']>;
};


export type MutationContactTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationContactTemplateSaveArgs = {
  templateMessage?: InputMaybe<Scalars['String']>;
  templateName?: InputMaybe<Scalars['String']>;
  templateSubject?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCardArgs = {
  card: IssueCardInput;
  gateway?: InputMaybe<Financial_Gateway>;
  organizationId?: InputMaybe<Scalars['String']>;
  raiseOrganizationId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFundraiserUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationCreateOtkParticipantEntryArgs = {
  fundraiserId: Scalars['Int'];
  fundraiserUserId: Scalars['ID'];
  incentiveId: Scalars['Int'];
  size: Scalars['String'];
};


export type MutationCreatePrefundArgs = {
  amount: Scalars['Int'];
  cardType?: InputMaybe<Card_Type>;
  email: Scalars['String'];
  fundraiserId: Scalars['Int'];
  nameOnCard?: InputMaybe<Scalars['String']>;
  shippingService?: InputMaybe<Shipping_Service>;
};


export type MutationCreatePrefundTopupArgs = {
  amount: Scalars['Int'];
  fundraiserId: Scalars['Int'];
};


export type MutationDriveCampaignFinalizeArgs = {
  fundraiserId: Scalars['Int'];
};


export type MutationDriveCampaignSettleArgs = {
  fundraiserIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationDriveCampaignUpdateArgs = {
  data: DriveCampaignUpdateInput;
  id: Scalars['Int'];
};


export type MutationDriveEventActivityCreateArgs = {
  eventId: Scalars['String'];
  input?: InputMaybe<DriveEventActivityInput>;
};


export type MutationDriveEventActivityRemoveArgs = {
  id: Scalars['ID'];
};


export type MutationDriveEventActivityUpdateArgs = {
  id: Scalars['ID'];
  input: DriveEventActivityInput;
};


export type MutationDriveEventAgendaCreateArgs = {
  eventId: Scalars['ID'];
  input: DriveEventAgendaInput;
};


export type MutationDriveEventAttendeeAddArgs = {
  eventId: Scalars['ID'];
  input: DriveEventAttendeeInput;
  update?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDriveEventAttendeesRemoveArgs = {
  eventId: Scalars['ID'];
  userIds: Array<Scalars['String']>;
};


export type MutationDriveEventAttendeeUpdateArgs = {
  eventId: Scalars['ID'];
  input: DriveEventAttendeeInput;
  userId: Scalars['ID'];
};


export type MutationDriveEventCreateArgs = {
  input: DriveEventInput;
};


export type MutationDriveEventRemoveArgs = {
  id: Scalars['ID'];
};


export type MutationDriveEventUpdateArgs = {
  id: Scalars['ID'];
  input: DriveEventInput;
};


export type MutationDriveS3ImageResizeArgs = {
  fileUploaded?: InputMaybe<Scalars['String']>;
};


export type MutationDriveUploadUrlCreateArgs = {
  fileName: Scalars['String'];
};


export type MutationEventCreateArgs = {
  input?: InputMaybe<CreateEventInput>;
};


export type MutationEventDeleteArgs = {
  input?: InputMaybe<DeleteEventInput>;
};


export type MutationEventModifyArgs = {
  input?: InputMaybe<ModifyEventInput>;
};


export type MutationEventParticipantsCreateArgs = {
  input?: InputMaybe<CreateEventParticipantsInput>;
};


export type MutationEventParticipantsDeleteArgs = {
  input?: InputMaybe<DeleteEventParticipantsInput>;
};


export type MutationEventParticipantsModifyArgs = {
  input?: InputMaybe<ModifyEventParticipantsInput>;
};


export type MutationEventPreparationCreateArgs = {
  input?: InputMaybe<CreateEventPreparationInput>;
};


export type MutationEventPreparationDeleteArgs = {
  input?: InputMaybe<DeleteEventPreparationInput>;
};


export type MutationEventPreparationModifyArgs = {
  input?: InputMaybe<ModifyEventPreparationInput>;
};


export type MutationEventPreparationsCreateArgs = {
  input?: InputMaybe<CreateEventPreparationsInput>;
};


export type MutationEventPreparationsCreateManyArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateEventPreparationsInput>>>;
};


export type MutationEventPreparationsDeleteArgs = {
  input?: InputMaybe<DeleteEventPreparationsInput>;
};


export type MutationEventPreparationsDeleteManyArgs = {
  input?: InputMaybe<DeleteManyEventPreparationsInput>;
};


export type MutationEventPreparationsModifyArgs = {
  input?: InputMaybe<ModifyEventPreparationsInput>;
};


export type MutationEventPreparationsModifyManyArgs = {
  input?: InputMaybe<ModifyManyEventPreparationsByEventInput>;
};


export type MutationEventPreparationsUpsertArgs = {
  input?: InputMaybe<UpsertEventPreparationsInput>;
};


export type MutationEventTransportDetailsCreateArgs = {
  input?: InputMaybe<CreateEventTransportDetailsInput>;
};


export type MutationEventTransportDetailsDeleteArgs = {
  input?: InputMaybe<DeleteEventTransportDetailsInput>;
};


export type MutationEventTransportDetailsModifyArgs = {
  input?: InputMaybe<ModifyEventTransportDetailsInput>;
};


export type MutationFacilityCreateArgs = {
  input?: InputMaybe<CreateFacilityInput>;
};


export type MutationFacilityDeleteArgs = {
  input?: InputMaybe<DeleteFacilityInput>;
};


export type MutationFacilityModifyArgs = {
  input?: InputMaybe<ModifyFacilityInput>;
};


export type MutationFinancialAcctCreateArgs = {
  acctId?: InputMaybe<Scalars['ID']>;
  applicationId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  kybId: Scalars['ID'];
  orgId: Scalars['ID'];
  processor: Processor;
  status?: InputMaybe<FinAcctStatus>;
};


export type MutationFinancialAcctDeleteArgs = {
  finAcctId: Scalars['ID'];
};


export type MutationFinancialAcctUpdateArgs = {
  acctId?: InputMaybe<Scalars['ID']>;
  applicationId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  finAcctId: Scalars['ID'];
  kybId?: InputMaybe<Scalars['ID']>;
  orgId: Scalars['ID'];
  status?: InputMaybe<FinAcctStatus>;
};


export type MutationFinancialAcctUserAssociateArgs = {
  finAcctId: Scalars['ID'];
  isBeneficialOwner?: InputMaybe<Scalars['Boolean']>;
  isContact?: InputMaybe<Scalars['Boolean']>;
  isPrincipal?: InputMaybe<Scalars['Boolean']>;
  isRepresentative?: InputMaybe<Scalars['Boolean']>;
  kycId?: InputMaybe<Scalars['ID']>;
  personId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationGroupLeaderEmailSendArgs = {
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  fundraiserId: Scalars['Int'];
  groupLeaderEmail: Scalars['String'];
  message: Scalars['String'];
  subject: Scalars['String'];
};


export type MutationHubspotCallEngagementToDealAddArgs = {
  fundraiserId: Scalars['Int'];
};


export type MutationHubspotNoteEngagementToDealAddArgs = {
  fundraiserId: Scalars['Int'];
};


export type MutationJoinFundraiserUserArgs = {
  joinCode: Scalars['String'];
  role: CampaignMemberAssociation;
  userId: Scalars['Int'];
};


export type MutationLatestVaultCardCreateArgs = {
  altName?: InputMaybe<Scalars['String']>;
  attachCardToKybBalance: Scalars['Boolean'];
  cardType: VaultCardType;
  kybId: Scalars['ID'];
  metadata?: InputMaybe<VaultCardMetadataInput>;
  recipientName?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<VaultAddressInput>;
  shippingService?: InputMaybe<VaultShippingService>;
  spendingLimitAmount: Scalars['Int'];
  spendingLimitInterval: VaultSpendingLimitInterval;
};


export type MutationLevelCreateArgs = {
  input?: InputMaybe<CreateLevelInput>;
};


export type MutationLevelDeleteArgs = {
  input?: InputMaybe<DeleteLevelInput>;
};


export type MutationLevelModifyArgs = {
  input?: InputMaybe<ModifyLevelInput>;
};


export type MutationLinkUserToSponsorArgs = {
  sponsorId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationLinkUserToSponsorSchoolArgs = {
  schoolId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationLoginArgs = {
  consumer?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationManageUserCreateArgs = {
  input?: InputMaybe<ManageUserCreateInput>;
};


export type MutationManageUserDeleteArgs = {
  input?: InputMaybe<ManageUserDeleteInput>;
};


export type MutationManageUserUpdateArgs = {
  input?: InputMaybe<ManageUserUpdateInput>;
};


export type MutationNoticeCreateArgs = {
  input?: InputMaybe<NoticeCreateInput>;
};


export type MutationNoticeDeleteArgs = {
  input?: InputMaybe<NoticeDeleteInput>;
};


export type MutationNotifyIncorrectWalletInfoArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationOfficialCreateArgs = {
  input?: InputMaybe<CreateOfficialInput>;
};


export type MutationOfficialDeleteArgs = {
  input?: InputMaybe<DeleteOfficialInput>;
};


export type MutationOfficialDutiesCreateArgs = {
  input?: InputMaybe<CreateOfficialDutiesInput>;
};


export type MutationOfficialDutiesDeleteArgs = {
  input?: InputMaybe<DeleteOfficialDutiesInput>;
};


export type MutationOfficialDutiesModifyArgs = {
  input?: InputMaybe<ModifyOfficialDutiesInput>;
};


export type MutationOfficialModifyArgs = {
  input?: InputMaybe<ModifyOfficialInput>;
};


export type MutationOfficialPoolCreateArgs = {
  input?: InputMaybe<CreateOfficialPoolByIdInput>;
};


export type MutationOfficialPoolDeleteArgs = {
  input?: InputMaybe<DeleteOfficialPoolInput>;
};


export type MutationOfficialPoolModifyArgs = {
  input?: InputMaybe<ModifyOfficialPoolByIdInput>;
};


export type MutationOfficialsUpsertArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertOfficialsInput>>>;
};


export type MutationOpponentCreateArgs = {
  input?: InputMaybe<CreateOpponentInput>;
};


export type MutationOpponentDeleteArgs = {
  input?: InputMaybe<DeleteOpponentInput>;
};


export type MutationOpponentModifyArgs = {
  input?: InputMaybe<ModifyOpponentInput>;
};


export type MutationOpponentsUpsertArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertOpponentsInput>>>;
};


export type MutationParticipantDonationInviteEmailAddArgs = {
  campaignID: Scalars['String'];
  email: Scalars['String'];
};


export type MutationParticipantDonationInviteEmailFollowUpArgs = {
  donationInviteEmailID: Scalars['Int'];
};


export type MutationParticipantDonationInviteSmsAddArgs = {
  campaignID: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationParticipantGuardianEmailUpdateArgs = {
  guardianEmail: Scalars['String'];
  secondGuardianEmail?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationParticipantIncentiveSelectionDeleteArgs = {
  fundraiserId: Scalars['ID'];
  fundraiserUserIncentiveId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationParticipantRewardsCreateArgs = {
  fundraiserId: Scalars['Int'];
  incentiveId: Scalars['Int'];
  size: Scalars['String'];
  tier: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationParticipantsEmailSendArgs = {
  fundraiserId: Scalars['Int'];
  message: Scalars['String'];
  subject: Scalars['String'];
};


export type MutationParticipantSignupArgs = {
  apps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationParticipantsTextSendArgs = {
  fundraiserId: Scalars['Int'];
  message: Scalars['String'];
};


export type MutationPreloadEmailScheduleSendArgs = {
  dateTime: Scalars['DateTime'];
  fundraiserId: Scalars['Int'];
  timezone: Scalars['String'];
};


export type MutationPreloadEmailSendArgs = {
  fundraiserId: Scalars['Int'];
};


export type MutationPreparationCreateArgs = {
  input?: InputMaybe<CreatePreparationInput>;
};


export type MutationPreparationDeleteArgs = {
  input?: InputMaybe<DeletePreparationInput>;
};


export type MutationPreparationModifyArgs = {
  input?: InputMaybe<ModifyPreparationInput>;
};


export type MutationRoleCreateArgs = {
  data: RoleArguments;
};


export type MutationRoleDeleteArgs = {
  id: Scalars['String'];
};


export type MutationRolePermissionsUpdateArgs = {
  permissionIds: Array<Scalars['String']>;
  roleId: Scalars['String'];
};


export type MutationRoleUpdateArgs = {
  data: RoleArguments;
  id: Scalars['String'];
};


export type MutationSamlCallbackArgs = {
  actualEmail?: InputMaybe<Scalars['String']>;
  apps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  consumer?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};


export type MutationSchoolInfoCreateArgs = {
  input?: InputMaybe<CreateSchoolInfoInput>;
};


export type MutationSchoolInfoDeleteArgs = {
  input?: InputMaybe<DeleteSchoolInfoInput>;
};


export type MutationSchoolInfoModifyArgs = {
  input?: InputMaybe<ModifySchoolInfoInput>;
};


export type MutationSeasonCreateArgs = {
  input?: InputMaybe<SeasonCreateInput>;
};


export type MutationSeasonDeleteArgs = {
  input?: InputMaybe<SeasonDeleteInput>;
};


export type MutationSeasonModifyArgs = {
  input?: InputMaybe<SeasonModifyInput>;
};


export type MutationSeasonPostponeModifyArgs = {
  input?: InputMaybe<SeasonPostponeUnpostponeInput>;
};


export type MutationSeasonScheduleTeamsCreateArgs = {
  input?: InputMaybe<SeasonScheduleTeamsCreateInput>;
};


export type MutationSeasonUnpostponeModifyArgs = {
  input?: InputMaybe<SeasonPostponeUnpostponeInput>;
};


export type MutationSettlementIssuesRecordArgs = {
  fundraiserId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationSettlementStatusUpdateArgs = {
  fundraiserId: Scalars['Int'];
  settlementStatus?: InputMaybe<SettlementStatus>;
};


export type MutationSpendBudgetCreateArgs = {
  input: SpendBudgetInput;
};


export type MutationSpendCategoryCreateArgs = {
  input: SpendCategoryInput;
};


export type MutationSpendCategoryUpdateArgs = {
  id: Scalars['String'];
  input: SpendCategoryInput;
};


export type MutationSpendCategoryUpsertBulkArgs = {
  input?: InputMaybe<Array<InputMaybe<SpendUpsertCategoryInput>>>;
};


export type MutationSpendGroupArchiveArgs = {
  id: Scalars['String'];
};


export type MutationSpendGroupCreateArgs = {
  input: SpendGroupInput;
};


export type MutationSpendGroupDuplicateArgs = {
  id: Scalars['String'];
};


export type MutationSpendGroupRosterCreateArgs = {
  input: SpendGroupRosterInput;
};


export type MutationSpendGroupRostersCreateArgs = {
  input: Array<InputMaybe<SpendGroupRosterInput>>;
};


export type MutationSpendGroupUpdateArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: SpendGroupInput;
};


export type MutationSpendInvoiceCreateArgs = {
  input: SpendInvoiceInput;
};


export type MutationSpendInvoiceReminderCreateArgs = {
  input: SpendInvoiceReminderInput;
};


export type MutationSpendNotificationCreateArgs = {
  input: SpendNotificationInput;
};


export type MutationSpendOrganizationApproveArgs = {
  id: Scalars['String'];
};


export type MutationSpendOrganizationCreateArgs = {
  input: SpendOrganizationInput;
};


export type MutationSpendPaymentScheduleCreateArgs = {
  input: SpendPaymentScheduleInput;
};


export type MutationSpendPaymentScheduleUpdateArgs = {
  id: Scalars['String'];
  input: SpendPaymentScheduleInput;
  rosterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSpendRoleChangeArgs = {
  roleId: Scalars['String'];
  sessionId: Scalars['String'];
};


export type MutationSpendSeasonCreateArgs = {
  input: SpendSeasonInput;
};


export type MutationSpendSeasonUpdateArgs = {
  id: Scalars['String'];
  input: SpendSeasonInput;
};


export type MutationSpendSessionDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSpendSessionRefreshArgs = {
  sessionId: Scalars['String'];
};


export type MutationSpendSettingsUpdateArgs = {
  input?: InputMaybe<SpendSettingsInput>;
};


export type MutationSpendTransactionsCreateArgs = {
  input: SpendTransactionInput;
};


export type MutationSpendUserInviteCreateArgs = {
  input: SpendInviteInput;
};


export type MutationSpendUserInviteResendArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationSpendUserInviteUpdateArgs = {
  id: Scalars['String'];
};


export type MutationSpendUserRoleArchiveArgs = {
  groupId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationSpendUserRoleUpdateArgs = {
  groupId?: InputMaybe<Scalars['String']>;
  roleName: SpendRoleNameEnum;
  userId: Scalars['String'];
};


export type MutationSponsorCartAssetAddArgs = {
  assetId: Scalars['String'];
  attachment?: InputMaybe<Scalars['String']>;
  sponsorId: Scalars['String'];
};


export type MutationSponsorCartAssetRemoveArgs = {
  assetId: Scalars['String'];
  sponsorId: Scalars['String'];
};


export type MutationSponsorCartCheckoutArgs = {
  emailAddress: Scalars['String'];
  orderId: Scalars['String'];
  sponsorId: Scalars['String'];
  sponsorName: Scalars['String'];
};


export type MutationSponsorCreateArgs = {
  city: Scalars['String'];
  email: Scalars['String'];
  industryId: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  stateId: Scalars['String'];
  streetAddress: Scalars['String'];
  zipCode: Scalars['String'];
};


export type MutationSponsorDistrictCreateArgs = {
  fields?: InputMaybe<ISponsorDistrictFields>;
};


export type MutationSponsorDistrictDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorDistrictUpdateArgs = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorInvitationCreateArgs = {
  emailData?: InputMaybe<DynamicEmailDataInput>;
  invites?: InputMaybe<Array<InputMaybe<InviteCreationInput>>>;
};


export type MutationSponsorLogoUpdateArgs = {
  file?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSponsorPackageAttachmentUpdateArgs = {
  assetId: Scalars['String'];
  attachment?: InputMaybe<Scalars['String']>;
  sponsorId: Scalars['String'];
};


export type MutationSponsorPaymentIntentCreateArgs = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  save: Scalars['Boolean'];
  sponsorId: Scalars['String'];
};


export type MutationSponsorPaymentMethodEnableArgs = {
  isEnabled: Scalars['Boolean'];
  paymentMethodId: Scalars['String'];
  sponsorId: Scalars['String'];
};


export type MutationSponsorPaymentMethodSaveArgs = {
  paymentMethodId: Scalars['String'];
  sponsorId: Scalars['String'];
};


export type MutationSponsorSchoolCreateArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  fields: ISponsorSchoolFields;
  subDistrictId?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorSchoolDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorSchoolProgramCreateArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  fields: ISponsorSchoolProgramFields;
  schoolId?: InputMaybe<Scalars['String']>;
  subDistrictId?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorSchoolProgramDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorSchoolProgramUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorSchoolUpdateArgs = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  subDistrictId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorshipGroupAssetCreateArgs = {
  data?: InputMaybe<AssetCreationInput>;
};


export type MutationSponsorshipGroupAssetDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorshipGroupAssetDuplicateArgs = {
  id: Scalars['String'];
};


export type MutationSponsorshipGroupAssetUpdateArgs = {
  assetTypeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sponsorshipGroupId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorshipGroupCreateArgs = {
  activityId: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  motive?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  schoolId: Scalars['String'];
  socialMediaAccounts?: InputMaybe<ISocialMediaAccounts>;
  stateId: Scalars['String'];
  streetAddress?: InputMaybe<Scalars['String']>;
  teamPhoto?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};


export type MutationSponsorshipGroupDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorshipGroupInviteRemindArgs = {
  email: Scalars['String'];
  emailData?: InputMaybe<DynamicEmailDataInput>;
  inviteId: Scalars['String'];
  sponsorshipGroupId: Scalars['String'];
};


export type MutationSponsorshipGroupOrderStatusUpdateArgs = {
  packageId: Scalars['String'];
  rejectionReason?: InputMaybe<Scalars['String']>;
  sponsorshipGroupId: Scalars['String'];
  status: OrderStatus;
};


export type MutationSponsorshipGroupUpdateArgs = {
  activityId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  motive?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  socialMediaAccounts?: InputMaybe<ISocialMediaAccounts>;
  stateId?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  stripeAccountStatus?: InputMaybe<Scalars['String']>;
  stripeConnectAccountId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorShipGroupUserAssociationArgs = {
  data?: InputMaybe<Array<InputMaybe<SponsorshipGroupUserLink>>>;
};


export type MutationSponsorshipGroupUserInviteArgs = {
  inviterName: Scalars['String'];
  organizationName: Scalars['String'];
  publicUrl: Scalars['String'];
  receiverEmail: Scalars['String'];
};


export type MutationSponsorShipLogoUpdateArgs = {
  file?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSponsorShipTeamPhotoUpdateArgs = {
  file?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSponsorSubDistrictCreateArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<ISponsorDistrictFields>;
};


export type MutationSponsorSubDistrictDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSponsorSubDistrictUpdateArgs = {
  districtId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationSponsorUpdateArgs = {
  city?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationStoreActivitiesCheckedArgs = {
  scopeId: Scalars['Int'];
};


export type MutationStoreCreateArgs = {
  input: StoreInput;
};


export type MutationStoreManagerPointsUpdateArgs = {
  input: StoreUpdatePoints;
};


export type MutationStoreOrderChangeStatusArgs = {
  input: StoreChangeStatus;
};


export type MutationStoreOrderChangeTypeArgs = {
  input: StoreChangeType;
};


export type MutationStoreOrderCheckedArgs = {
  scopeId: Scalars['Int'];
};


export type MutationStoreOrderCreateArgs = {
  input: StoreInputOrder;
};


export type MutationStoreOrderDeleteArgs = {
  orderId: Scalars['Int'];
};


export type MutationStoreOrderUpdateArgs = {
  Updateinput: StoreUpdateOrder;
};


export type MutationStorePaymentIntentCreateArgs = {
  input: StoreCreatePaymentIntent;
};


export type MutationStoreProductCreateArgs = {
  input?: InputMaybe<StoreProductInput>;
};


export type MutationStoreProductRemoveArgs = {
  productId: Scalars['Int'];
};


export type MutationStoreProductUpdateArgs = {
  input: StoreProductUpdateInput;
};


export type MutationStoreRemoveArgs = {
  scopeId: Scalars['Int'];
};


export type MutationStoreSavePointsActivityArgs = {
  input: StorePointsActivityInput;
};


export type MutationStoreSsoUserSaveArgs = {
  input?: InputMaybe<StoreCampaignInfoInput>;
};


export type MutationStoreTicketCreateArgs = {
  input: StoreTicketInput;
};


export type MutationStoreTransactionSaveArgs = {
  input: StoreSaveTransaction;
};


export type MutationStoreTransferToCustomerArgs = {
  input?: InputMaybe<StoreTransferCustomer>;
};


export type MutationStoreTransferToGlArgs = {
  input?: InputMaybe<StoreTransferGl>;
};


export type MutationStoreTransferToParticipantArgs = {
  input?: InputMaybe<StoreTransferParticipant>;
};


export type MutationStoreUpdateArgs = {
  input?: InputMaybe<StoreUpdate>;
};


export type MutationStoreUpdateStatusArgs = {
  input: StoreStatusInput;
};


export type MutationSupportTicketSendArgs = {
  attachments?: InputMaybe<Array<DriveFileInput>>;
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  deviceInfo?: InputMaybe<Scalars['String']>;
  fundraiserId?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  supportTicketInfo?: InputMaybe<Array<DriveFieldInput>>;
  templateId?: InputMaybe<Scalars['String']>;
  to: Support_Ticket_Department;
};


export type MutationTeamCreateArgs = {
  input?: InputMaybe<TeamCreateInput>;
};


export type MutationTeamDeleteArgs = {
  input?: InputMaybe<TeamDeleteInput>;
};


export type MutationTeamModifyArgs = {
  input?: InputMaybe<TeamModifyInput>;
};


export type MutationTeamOfficialCreateArgs = {
  input?: InputMaybe<TeamOfficialCreateInput>;
};


export type MutationTeamOfficialDeleteArgs = {
  input?: InputMaybe<TeamOfficialDeleteInput>;
};


export type MutationTeamOfficialModifyArgs = {
  input?: InputMaybe<TeamOfficialModifyInput>;
};


export type MutationTeamPreparationCreateArgs = {
  input?: InputMaybe<TeamPreparationCreateInput>;
};


export type MutationTeamPreparationDeleteArgs = {
  input?: InputMaybe<TeamPreparationDeleteInput>;
};


export type MutationTeamPreparationModifyArgs = {
  input?: InputMaybe<TeamPreparationModifyInput>;
};


export type MutationTeamWorkerCreateArgs = {
  input?: InputMaybe<TeamWorkerCreateInput>;
};


export type MutationTeamWorkerDeleteArgs = {
  input?: InputMaybe<TeamWorkerDeleteInput>;
};


export type MutationTeamWorkerModifyArgs = {
  input?: InputMaybe<TeamWorkerModifyInput>;
};


export type MutationToggleCardActivationArgs = {
  cardId: Scalars['String'];
  status: Card_Status;
};


export type MutationUpdateCurrentOrganizationMailingAddressArgs = {
  address: FinancialAddressInput;
};


export type MutationUpdateParticipantGroupArgs = {
  fundraiserId: Scalars['Int'];
  personListsId: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateParticipantOtkSizeArgs = {
  fundraiserUserIncentiveId: Scalars['Int'];
  size: Scalars['String'];
};


export type MutationUpdatePrefundArgs = {
  id: Scalars['String'];
  prefundAmount?: InputMaybe<Scalars['Int']>;
  shippingService?: InputMaybe<Shipping_Service>;
};


export type MutationUpdateWalletCardStatusArgs = {
  id: Scalars['String'];
  status: Card_Status;
};


export type MutationUpdateWalletOrganizationArgs = {
  altName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  mailingAddress?: InputMaybe<FinancialAddressInput>;
};


export type MutationUpgradeToWalletUserArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationUserAssociateArgs = {
  orgId: Scalars['ID'];
  product: Product;
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserAssociationDeleteArgs = {
  orgId: Scalars['ID'];
  product: Product;
  userId: Scalars['ID'];
};


export type MutationUserCreateArgs = {
  apps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<UserOccupation>;
  parentId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  profilePicture?: InputMaybe<Scalars['String']>;
  snapRaiseId?: InputMaybe<Scalars['Int']>;
};


export type MutationUserEmailConfirmArgs = {
  code: Scalars['String'];
};


export type MutationUserFittingAddArgs = {
  fitting: UserFittingPreference;
  userID: Scalars['ID'];
};


export type MutationUserImpersonateArgs = {
  userId: Scalars['String'];
};


export type MutationUserInviteArgs = {
  email?: InputMaybe<Scalars['String']>;
  joincode?: InputMaybe<Scalars['String']>;
};


export type MutationUserInviteAcceptArgs = {
  inviteId?: InputMaybe<Scalars['String']>;
};


export type MutationUserPermissionsUpdateArgs = {
  negativePermissions: Array<UserPermissionAssignment>;
  permissions: Array<UserPermissionAssignment>;
  roleIds: Array<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationUserPhoneNumberConfirmArgs = {
  code: Scalars['String'];
};


export type MutationUserRefreshSessionArgs = {
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  transport?: InputMaybe<TransportEnum>;
  withLink?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUserSignupArgs = {
  apps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  consumer?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<UserOccupation>;
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  profilePicture?: InputMaybe<Scalars['String']>;
};


export type MutationUserSignupConfirmArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
  skip?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUserSignupConfirmationResendArgs = {
  email: Scalars['String'];
  transport?: InputMaybe<TransportEnum>;
};


export type MutationUserUpdateArgs = {
  apps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<UserOccupation>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
};


export type MutationUserUpdatePasswordArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationVaultFinancialAccountCreateArgs = {
  stripeConnectAccountId: Scalars['String'];
};


export type MutationVaultKybCreateArgs = {
  address: VaultAddressInput;
  customerFacingName: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  legalName: Scalars['String'];
  phoneNumber: Scalars['String'];
  structure: Kyb_Structure;
  taxId: Scalars['String'];
  type: Kyb_Type;
  url: Scalars['String'];
};


export type MutationVaultKybUpdateArgs = {
  address?: InputMaybe<VaultAddressUpdateInput>;
  customerFacingName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  structure?: InputMaybe<Kyb_Structure>;
  taxId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Kyb_Type>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationVaultKycCreateArgs = {
  address: VaultAddressInput;
  director?: InputMaybe<Scalars['Boolean']>;
  dob: VaultDobInput;
  email: Scalars['String'];
  executive?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  owner?: InputMaybe<Scalars['Boolean']>;
  percentOwnership?: InputMaybe<Scalars['Int']>;
  phoneNumber: Scalars['String'];
  representative?: InputMaybe<Scalars['Boolean']>;
  ssn?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationVaultKycUpdateArgs = {
  address?: InputMaybe<VaultAddressUpdateInput>;
  director?: InputMaybe<Scalars['Boolean']>;
  dob?: InputMaybe<VaultDobInput>;
  email?: InputMaybe<Scalars['String']>;
  executive?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['Boolean']>;
  percentOwnership?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  representative?: InputMaybe<Scalars['Boolean']>;
  ssn?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationVaultRelationshipCreateArgs = {
  director?: InputMaybe<Scalars['Boolean']>;
  executive?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['Boolean']>;
  percentOwnership?: InputMaybe<Scalars['Int']>;
  representative?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationVaultStripeConnectAccountCreateArgs = {
  vaultKybId: Scalars['ID'];
};


export type MutationVaultStripeConnectAccountUpdateArgs = {
  stripeConnectAccountId: Scalars['String'];
  vaultKybId: Scalars['ID'];
};


export type MutationVaultStripePersonCreateArgs = {
  stripeConnectAccountId: Scalars['String'];
  vaultKycId: Scalars['ID'];
};


export type MutationVaultStripePersonDeleteArgs = {
  stripeConnectAccountId: Scalars['String'];
  stripePersonId: Scalars['String'];
};


export type MutationVaultStripePersonUpdateArgs = {
  stripeConnectAccountId: Scalars['String'];
  stripePersonId: Scalars['String'];
  vaultKycId: Scalars['ID'];
};


export type MutationVaultUnitBusinessApplicationAccountCreateArgs = {
  vaultBeneficiaryOwnersKycIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vaultKybId: Scalars['ID'];
  vaultOwnerKycId: Scalars['ID'];
};


export type MutationVaultUnitDepositAccountCreateArgs = {
  customerId: Scalars['ID'];
};


export type MutationVehicleCreateArgs = {
  input?: InputMaybe<CreateVehicleInput>;
};


export type MutationVehicleDeleteArgs = {
  input?: InputMaybe<DeleteVehicleInput>;
};


export type MutationVehicleModifyArgs = {
  input?: InputMaybe<ModifyVehicleInput>;
};


export type MutationWorkerCreateArgs = {
  input?: InputMaybe<CreateWorkerInput>;
};


export type MutationWorkerDeleteArgs = {
  input?: InputMaybe<DeleteWorkerInput>;
};


export type MutationWorkerModifyArgs = {
  input?: InputMaybe<ModifyWorkerInput>;
};


export type MutationWorkerPoolCreateArgs = {
  input?: InputMaybe<CreateWorkerPool>;
};


export type MutationWorkerPoolDeleteArgs = {
  input?: InputMaybe<DeleteWorkerPoolInput>;
};


export type MutationWorkerPoolModifyArgs = {
  input?: InputMaybe<ModifyWorkerPoolInput>;
};


export type MutationWorkersUpsertArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertWorkersInput>>>;
};

export type CampaignPersonList = {
  __typename?: 'CampaignPersonList';
  id: Scalars['Int'];
};

export type WalletConfirmOrganizationInfoResult = {
  __typename?: 'WalletConfirmOrganizationInfoResult';
  organization?: Maybe<Organization>;
  user?: Maybe<UserWithPermissions>;
};

/** Owned by Vault Only used in legacy createCard */
export type IssueCardInput = {
  altName?: InputMaybe<Scalars['String']>;
  cardType: Card_Type;
  metadata?: InputMaybe<VaultCardMetadataInput>;
  recipientName?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<FinancialAddressInput>;
  shippingService?: InputMaybe<Shipping_Service>;
  spendingLimitAmount: Scalars['Int'];
  spendingLimitInterval: Spending_Limit_Interval;
};

/** Additional data passed into the Stripe api Can be read in Stripe dashboard */
export type VaultCardMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  walletId?: InputMaybe<Scalars['String']>;
};

export type FinancialAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Owned by Vault Only used in legacy createCard */
export enum Spending_Limit_Interval {
  AllTime = 'all_time',
  Daily = 'daily',
  Monthly = 'monthly',
  PerAuthorization = 'per_authorization',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

/** Owned by Vault Only used in legacy createCard */
export enum Financial_Gateway {
  Stripe = 'stripe'
}

/** Owned by Vault Only used in legacy createCard */
export type CoreCardFields = {
  __typename?: 'CoreCardFields';
  cardId: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  gatewayId?: Maybe<Scalars['String']>;
  last4: Scalars['String'];
  name: Scalars['String'];
};

export type CreatedFundraiserUser = {
  __typename?: 'CreatedFundraiserUser';
  id: Scalars['Int'];
};

export type CreatedOtkEntry = {
  __typename?: 'CreatedOtkEntry';
  id: Scalars['Int'];
};

/** Common payload for mutations. */
export type IMutationResult = {
  __typename?: 'IMutationResult';
  data?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
};

export type DriveCampaignUpdateInput = {
  notes?: InputMaybe<Scalars['String']>;
};

export type DriveEventActivityInput = {
  featured?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
};

export type DriveEventAgendaInput = {
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type DriveEventAttendeeInput = {
  department?: InputMaybe<Scalars['String']>;
  flightRequest?: InputMaybe<EventAttendeeRequestStatus>;
  hotelRequest?: InputMaybe<EventAttendeeRequestStatus>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type DriveEventInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  agenda?: InputMaybe<Array<DriveEventAgendaInput>>;
  agendaConfig?: InputMaybe<Scalars['JSON']>;
  attendees?: InputMaybe<Array<DriveEventAttendeeInput>>;
  booth?: InputMaybe<DriveEventBoothInput>;
  clinicLeaderId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  hotelAddress?: InputMaybe<Scalars['String']>;
  hotelName?: InputMaybe<Scalars['String']>;
  hubspotTrackingLink?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  planningCompleted?: InputMaybe<Scalars['Boolean']>;
  sponsor?: InputMaybe<DriveEventSponsorInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DriveEventStatus>;
  tier?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  venue?: InputMaybe<DriveEventVenueInput>;
  websiteLink?: InputMaybe<Scalars['String']>;
};

export type DriveEventVenueInput = {
  buildingOrRoom?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateEventInput = {
  activity?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  bus_fee?: InputMaybe<Scalars['Float']>;
  bus_time?: InputMaybe<Scalars['String']>;
  cancellation_status?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  conference?: InputMaybe<Scalars['String']>;
  conference_event_id?: InputMaybe<Scalars['Int']>;
  conference_id?: InputMaybe<Scalars['Int']>;
  confirmed?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['Date']>;
  departure_location?: InputMaybe<Scalars['String']>;
  directions?: InputMaybe<Scalars['String']>;
  early_dismissal_required?: InputMaybe<Scalars['String']>;
  early_dismissal_time?: InputMaybe<Scalars['String']>;
  end_time?: InputMaybe<Scalars['String']>;
  estimated_return_time?: InputMaybe<Scalars['String']>;
  event_date?: InputMaybe<Scalars['Date']>;
  event_id: Scalars['Int'];
  exists_in_mls?: InputMaybe<Scalars['Int']>;
  fee?: InputMaybe<Scalars['Float']>;
  g_s?: InputMaybe<Scalars['String']>;
  gate_revenue?: InputMaybe<Scalars['Float']>;
  headline?: InputMaybe<Scalars['String']>;
  impact_event?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  loss_points?: InputMaybe<Scalars['Int']>;
  num_buses?: InputMaybe<Scalars['Int']>;
  opponent?: InputMaybe<Scalars['String']>;
  opponent_code?: InputMaybe<Scalars['String']>;
  opponent_score?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  prep_setup?: InputMaybe<Scalars['String']>;
  promote?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Float']>;
  rollover?: InputMaybe<Scalars['String']>;
  season_team?: InputMaybe<Scalars['Int']>;
  start_time?: InputMaybe<Scalars['String']>;
  team_score?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tournament?: InputMaybe<Scalars['String']>;
  trans_id?: InputMaybe<Scalars['Int']>;
  transport_comments?: InputMaybe<Scalars['String']>;
  transportation?: InputMaybe<Scalars['String']>;
  update_at?: InputMaybe<Scalars['Date']>;
  web_dir?: InputMaybe<Scalars['String']>;
  win_points?: InputMaybe<Scalars['Int']>;
  years?: InputMaybe<Scalars['String']>;
};

export type DeleteEventInput = {
  event_id: Scalars['Int'];
};

export type ModifyEventInput = {
  activity?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['String']>;
  bus_fee?: InputMaybe<Scalars['Float']>;
  bus_time?: InputMaybe<Scalars['String']>;
  cancellation_status?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  conference?: InputMaybe<Scalars['String']>;
  conference_event_id?: InputMaybe<Scalars['Int']>;
  conference_id?: InputMaybe<Scalars['Int']>;
  confirmed?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['Date']>;
  departure_location?: InputMaybe<Scalars['String']>;
  directions?: InputMaybe<Scalars['String']>;
  early_dismissal_required?: InputMaybe<Scalars['String']>;
  early_dismissal_time?: InputMaybe<Scalars['String']>;
  end_time?: InputMaybe<Scalars['String']>;
  estimated_return_time?: InputMaybe<Scalars['String']>;
  event_date?: InputMaybe<Scalars['Date']>;
  event_id: Scalars['Int'];
  exists_in_mls?: InputMaybe<Scalars['Int']>;
  fee?: InputMaybe<Scalars['Float']>;
  g_s?: InputMaybe<Scalars['String']>;
  gate_revenue?: InputMaybe<Scalars['Float']>;
  headline?: InputMaybe<Scalars['String']>;
  impact_event?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  loss_points?: InputMaybe<Scalars['Int']>;
  num_buses?: InputMaybe<Scalars['Int']>;
  opponent?: InputMaybe<Scalars['String']>;
  opponent_code?: InputMaybe<Scalars['String']>;
  opponent_score?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  prep_setup?: InputMaybe<Scalars['String']>;
  promote?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Float']>;
  rollover?: InputMaybe<Scalars['String']>;
  season_team?: InputMaybe<Scalars['Int']>;
  start_time?: InputMaybe<Scalars['String']>;
  team_score?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tournament?: InputMaybe<Scalars['String']>;
  trans_id?: InputMaybe<Scalars['Int']>;
  transport_comments?: InputMaybe<Scalars['String']>;
  transportation?: InputMaybe<Scalars['String']>;
  update_at?: InputMaybe<Scalars['Date']>;
  web_dir?: InputMaybe<Scalars['String']>;
  win_points?: InputMaybe<Scalars['Int']>;
  years?: InputMaybe<Scalars['String']>;
};

export type CreateEventParticipantsInput = {
  contract_received?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  school_code?: InputMaybe<Scalars['String']>;
};

export type DeleteEventParticipantsInput = {
  id: Scalars['Int'];
};

export type ModifyEventParticipantsInput = {
  contract_received?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  school_code?: InputMaybe<Scalars['String']>;
};

export type CreateEventPreparationInput = {
  comments?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type DeleteEventPreparationInput = {
  id: Scalars['Int'];
};

export type ModifyEventPreparationInput = {
  comments?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type CreateEventPreparationsInput = {
  comments?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type DeleteEventPreparationsInput = {
  id: Scalars['Int'];
};

export type DeleteManyEventPreparationsInput = {
  event: Scalars['Int'];
};

export type ModifyDeleteCount = {
  __typename?: 'ModifyDeleteCount';
  count?: Maybe<Scalars['Int']>;
};

export type ModifyEventPreparationsInput = {
  comments?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type ModifyManyEventPreparationsByEventInput = {
  comments?: InputMaybe<Scalars['String']>;
  event: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type UpsertEventPreparationsInput = {
  comments?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type CreateEventTransportDetailsInput = {
  driver_name?: InputMaybe<Scalars['String']>;
  driver_phone?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  vehicle_id?: InputMaybe<Scalars['String']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

export type DeleteEventTransportDetailsInput = {
  id: Scalars['Int'];
};

export type ModifyEventTransportDetailsInput = {
  driver_name?: InputMaybe<Scalars['String']>;
  driver_phone?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  vehicle_id?: InputMaybe<Scalars['String']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

export type CreateFacilityInput = {
  directions?: InputMaybe<Scalars['String']>;
  indoor?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  ml_site_id?: InputMaybe<Scalars['Int']>;
  ml_space_id?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<Scalars['String']>;
  place_name: Scalars['String'];
  show?: InputMaybe<Scalars['String']>;
  specialDirections?: InputMaybe<Scalars['String']>;
  web?: InputMaybe<Scalars['String']>;
};

export type DeleteFacilityInput = {
  place_name: Scalars['String'];
};

export type ModifyFacilityInput = {
  directions?: InputMaybe<Scalars['String']>;
  indoor?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  ml_site_id?: InputMaybe<Scalars['Int']>;
  ml_space_id?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<Scalars['String']>;
  place_name: Scalars['String'];
  show?: InputMaybe<Scalars['String']>;
  specialDirections?: InputMaybe<Scalars['String']>;
  web?: InputMaybe<Scalars['String']>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  errors?: Maybe<Array<Maybe<MutationError>>>;
  properties?: Maybe<OrgsProperties>;
  success: Scalars['Boolean'];
};

export type MutationError = {
  __typename?: 'MutationError';
  message: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type OrgsProperties = {
  __typename?: 'OrgsProperties';
  acctId?: Maybe<Scalars['ID']>;
  applicationId?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  finAcctId?: Maybe<Scalars['ID']>;
  internal?: Maybe<Scalars['Boolean']>;
  isBeneficialOwner?: Maybe<Scalars['Boolean']>;
  isContact?: Maybe<Scalars['Boolean']>;
  isPrincipal?: Maybe<Scalars['Boolean']>;
  isRepresentative?: Maybe<Scalars['Boolean']>;
  kybId?: Maybe<Scalars['ID']>;
  kycId?: Maybe<Scalars['ID']>;
  orgId?: Maybe<Scalars['ID']>;
  processor?: Maybe<Processor>;
  status?: Maybe<FinAcctStatus>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  userId?: Maybe<Scalars['ID']>;
};

/** Hubspot Engagement entity */
export type HubspotCallEngagement = {
  __typename?: 'HubspotCallEngagement';
  contactIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dealIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  engagementId?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type JoinedFundraiserId = {
  __typename?: 'JoinedFundraiserID';
  /** Returns the ID of the fundraiser */
  id?: Maybe<Scalars['Int']>;
};

/** Used for addresses in VaultKyb, VaultKyc and latestCreateCard */
export type VaultAddressInput = {
  city: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
  street: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
};

/** How to send a physical VaultCard */
export enum VaultShippingService {
  Express = 'express',
  Priority = 'priority',
  Standard = 'standard'
}

export type CreateLevelInput = {
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  Level?: InputMaybe<Scalars['String']>;
};

export type DeleteLevelInput = {
  ID: Scalars['Int'];
};

export type ModifyLevelInput = {
  ID: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  Level?: InputMaybe<Scalars['String']>;
};

export type Auth = {
  __typename?: 'Auth';
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type ManageUserCreateInput = {
  contractsPermissionLevel: Scalars['String'];
  email: Scalars['String'];
  eventsPermissionLevel: Scalars['String'];
  groups?: InputMaybe<Array<Scalars['String']>>;
  maintenancePermissionLevel: Scalars['String'];
  password: Scalars['String'];
  seasonsPermissionLevel: Scalars['String'];
  teamsPermissionLevel: Scalars['String'];
  userID: Scalars['String'];
  userPermissionLevel: Scalars['String'];
};

export type ManageUserDeleteInput = {
  id: Scalars['Int'];
};

export type ManageUserUpdateInput = {
  contractsPermissionLevel: Scalars['String'];
  email: Scalars['String'];
  eventsPermissionLevel: Scalars['String'];
  groups?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  maintenancePermissionLevel: Scalars['String'];
  password: Scalars['String'];
  seasonsPermissionLevel: Scalars['String'];
  teamsPermissionLevel: Scalars['String'];
  userID: Scalars['String'];
  userPermissionLevel: Scalars['String'];
};

export type NoticeCreateInput = {
  body?: InputMaybe<Scalars['String']>;
  isUrgent?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NoticeDeleteInput = {
  id: Scalars['Int'];
};

export type CreateOfficialInput = {
  duty?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  offic_id?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  pay_code?: InputMaybe<Scalars['String']>;
  received?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Float']>;
  ssn?: InputMaybe<Scalars['String']>;
  voucher_number?: InputMaybe<Scalars['String']>;
  worker_name?: InputMaybe<Scalars['String']>;
};

export type DeleteOfficialInput = {
  id: Scalars['Int'];
};

export type CreateOfficialDutiesInput = {
  duty?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteOfficialDutiesInput = {
  id: Scalars['Int'];
};

export type ModifyOfficialDutiesInput = {
  duty?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
};

export type ModifyOfficialInput = {
  duty?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  offic_id?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  pay_code?: InputMaybe<Scalars['String']>;
  received?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Float']>;
  ssn?: InputMaybe<Scalars['String']>;
  voucher_number?: InputMaybe<Scalars['String']>;
  worker_name?: InputMaybe<Scalars['String']>;
};

export type CreateOfficialPoolByIdInput = {
  Address?: InputMaybe<Scalars['String']>;
  cell_phone?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  First: Scalars['String'];
  Home_Phone?: InputMaybe<Scalars['String']>;
  ID: Scalars['String'];
  Last: Scalars['String'];
  SSN?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  vendor_number?: InputMaybe<Scalars['String']>;
  Work_Phone?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type DeleteOfficialPoolInput = {
  ids: Array<InputMaybe<Scalars['String']>>;
};

export type ModifyOfficialPoolByIdInput = {
  Address?: InputMaybe<Scalars['String']>;
  cell_phone?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  First?: InputMaybe<Scalars['String']>;
  Home_Phone?: InputMaybe<Scalars['String']>;
  ID: Scalars['String'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  Last?: InputMaybe<Scalars['String']>;
  SSN?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  vendor_number?: InputMaybe<Scalars['String']>;
  Work_Phone?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type UpsertOfficialsInput = {
  address?: InputMaybe<Scalars['String']>;
  cell_phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  home_phone?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  official_id: Scalars['String'];
  ssn?: InputMaybe<Scalars['String']>;
  work_phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateOpponentInput = {
  ad_name?: InputMaybe<Scalars['String']>;
  Address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  nces_id?: InputMaybe<Scalars['String']>;
  non_school?: InputMaybe<Scalars['Boolean']>;
  Phone?: InputMaybe<Scalars['String']>;
  SchoolCode: Scalars['String'];
  SchoolName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type DeleteOpponentInput = {
  SchoolCode: Scalars['String'];
};

export type ModifyOpponentInput = {
  ad_name?: InputMaybe<Scalars['String']>;
  Address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  nces_id?: InputMaybe<Scalars['String']>;
  non_school?: InputMaybe<Scalars['Boolean']>;
  Phone?: InputMaybe<Scalars['String']>;
  SchoolCode: Scalars['String'];
  SchoolName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type UpsertOpponentsInput = {
  ad_name?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  school_code: Scalars['String'];
  school_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type DonationInviteFollowUpEmail = {
  __typename?: 'DonationInviteFollowUpEmail';
  id: Scalars['Int'];
};

export type ParticipantGuardianEmailUpdate = {
  __typename?: 'ParticipantGuardianEmailUpdate';
  id?: Maybe<Scalars['Int']>;
};

export type DeletedIncentiveRecord = {
  __typename?: 'DeletedIncentiveRecord';
  id: Scalars['ID'];
};

export type CreatedParticipantRewards = {
  __typename?: 'CreatedParticipantRewards';
  id: Scalars['Int'];
};

export type TransportType = {
  __typename?: 'TransportType';
  recipient?: Maybe<Scalars['String']>;
  transport?: Maybe<TransportEnum>;
};

export enum TransportEnum {
  Email = 'email',
  Sms = 'sms'
}

/** Information of a emails scheduled for release */
export type PreloadEmailSchedule = {
  __typename?: 'PreloadEmailSchedule';
  /** The date and time for release */
  dateTime?: Maybe<Scalars['DateTime']>;
  /** The campaign id */
  fundraiserId?: Maybe<Scalars['Int']>;
  /** The timezone for scheduled release */
  timezone?: Maybe<Scalars['String']>;
};

export type CreatePreparationInput = {
  duty?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type DeletePreparationInput = {
  id: Scalars['Int'];
};

export type ModifyPreparationInput = {
  duty?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type WalletUserRegisterResult = {
  __typename?: 'WalletUserRegisterResult';
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type RoleArguments = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  scope?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateSchoolInfoInput = {
  ad?: InputMaybe<Scalars['String']>;
  ad_contract_signee?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  ccemail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  conf_text_type?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_reminder?: InputMaybe<Scalars['String']>;
  email_reminder_officials?: InputMaybe<Scalars['String']>;
  email_reminder_workers?: InputMaybe<Scalars['String']>;
  enable_cc_email_as_origin?: InputMaybe<Scalars['String']>;
  enable_ml_updates?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  mascot?: InputMaybe<Scalars['String']>;
  message_board_read_at?: InputMaybe<Scalars['Date']>;
  ml_key?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  principal?: InputMaybe<Scalars['String']>;
  school_timezone?: InputMaybe<Scalars['String']>;
  SchoolName?: InputMaybe<Scalars['String']>;
  secondary_ad_email?: InputMaybe<Scalars['String']>;
  secondary_ad_name?: InputMaybe<Scalars['String']>;
  signed_contract_notification?: InputMaybe<Scalars['String']>;
  ssn_on_file?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_org?: InputMaybe<Scalars['String']>;
  state_org_abbreviation?: InputMaybe<Scalars['String']>;
  use_security?: InputMaybe<Scalars['String']>;
  web_password?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type DeleteSchoolInfoInput = {
  id: Scalars['String'];
};

export type ModifySchoolInfoInput = {
  ad?: InputMaybe<Scalars['String']>;
  ad_contract_signee?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  ccemail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  conf_text_type?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_reminder?: InputMaybe<Scalars['String']>;
  email_reminder_officials?: InputMaybe<Scalars['String']>;
  email_reminder_workers?: InputMaybe<Scalars['String']>;
  enable_cc_email_as_origin?: InputMaybe<Scalars['String']>;
  enable_ml_updates?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  mascot?: InputMaybe<Scalars['String']>;
  message_board_read_at?: InputMaybe<Scalars['Date']>;
  ml_key?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  principal?: InputMaybe<Scalars['String']>;
  school_timezone?: InputMaybe<Scalars['String']>;
  SchoolName?: InputMaybe<Scalars['String']>;
  secondary_ad_email?: InputMaybe<Scalars['String']>;
  secondary_ad_name?: InputMaybe<Scalars['String']>;
  signed_contract_notification?: InputMaybe<Scalars['String']>;
  ssn_on_file?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_org?: InputMaybe<Scalars['String']>;
  state_org_abbreviation?: InputMaybe<Scalars['String']>;
  use_security?: InputMaybe<Scalars['String']>;
  web_password?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SeasonCreateInput = {
  budget?: InputMaybe<Scalars['Float']>;
  created_at?: InputMaybe<Scalars['Date']>;
  default_time_for_event?: InputMaybe<Scalars['String']>;
  default_time_for_practice?: InputMaybe<Scalars['String']>;
  home_field?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<Scalars['String']>;
  season_id: Scalars['Int'];
  sport_code?: InputMaybe<Scalars['String']>;
  web_password?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type SeasonDeleteInput = {
  season_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type SeasonModifyInput = {
  budget?: InputMaybe<Scalars['Float']>;
  created_at?: InputMaybe<Scalars['Date']>;
  default_time_for_event?: InputMaybe<Scalars['String']>;
  default_time_for_practice?: InputMaybe<Scalars['String']>;
  home_field?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<Scalars['String']>;
  season_id: Scalars['Int'];
  sport_code?: InputMaybe<Scalars['String']>;
  web_password?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type SeasonPostponeUnpostponeInput = {
  event_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  season_id?: InputMaybe<Scalars['Int']>;
};

export type PostponeUnpostponeResponse = {
  __typename?: 'PostponeUnpostponeResponse';
  affected_events?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SeasonScheduleTeamsCreateInput = {
  sport_codes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  year?: InputMaybe<Scalars['String']>;
};

/** Fixed statuses for a campaigns settlement status */
export enum SettlementStatus {
  InReview = 'IN_REVIEW',
  Unsubmitted = 'UNSUBMITTED',
  Verified = 'VERIFIED'
}

export type SpendBudgetInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  seasonId?: InputMaybe<Scalars['String']>;
  targetAmount?: InputMaybe<Scalars['Int']>;
  targetDateAt?: InputMaybe<Scalars['String']>;
  vaultId?: InputMaybe<Scalars['String']>;
};

export type SpendBudgetId = {
  __typename?: 'SpendBudgetID';
  id?: Maybe<Scalars['String']>;
};

export type SpendCategoryInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CategoryTypeEnum>;
};

export enum CategoryTypeEnum {
  Expense = 'expense',
  Income = 'income'
}

export type SpendCategoryId = {
  __typename?: 'SpendCategoryID';
  id?: Maybe<Scalars['String']>;
};

export type SpendUpsertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  name: Scalars['String'];
  type: CategoryTypeEnum;
};

export type SpendGroupId = {
  __typename?: 'SpendGroupID';
  id?: Maybe<Scalars['String']>;
};

export type SpendGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  hasOwnAccount?: InputMaybe<Scalars['Boolean']>;
  isBudgetShared?: InputMaybe<Scalars['Boolean']>;
  isLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  seasonEndAt?: InputMaybe<Scalars['String']>;
  seasonName?: InputMaybe<Scalars['String']>;
  seasonStartAt?: InputMaybe<Scalars['String']>;
};

export type SpendGroupRosterInput = {
  email: Scalars['String'];
  groupId: Scalars['String'];
  name: Scalars['String'];
  seasonId: Scalars['String'];
};

export type SpendGroupRosterId = {
  __typename?: 'SpendGroupRosterID';
  id?: Maybe<Scalars['String']>;
};

export type SpendInvoiceInput = {
  amount?: InputMaybe<Scalars['Int']>;
  balanceDue?: InputMaybe<Scalars['Int']>;
  budgetItemId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  groupRosterId?: InputMaybe<Scalars['String']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  optedIn?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paidDate?: InputMaybe<Scalars['String']>;
  paymentScheduleInvoiceId?: InputMaybe<Scalars['String']>;
};

export type SpendInvoiceId = {
  __typename?: 'SpendInvoiceID';
  id?: Maybe<Scalars['String']>;
};

export type SpendInvoiceReminderInput = {
  email?: InputMaybe<Scalars['String']>;
  failedPayment?: InputMaybe<Scalars['Boolean']>;
  groupName?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  pastDue?: InputMaybe<Scalars['Boolean']>;
};

export type SpendNotificationId = {
  __typename?: 'SpendNotificationID';
  id?: Maybe<Scalars['String']>;
};

export type SpendNotificationInput = {
  email: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  isEmailCCed: Scalars['Boolean'];
  message: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};

export type SpendNotificationStatus = {
  __typename?: 'SpendNotificationStatus';
  status?: Maybe<Scalars['String']>;
};

export type SpendOrganizationStatus = {
  __typename?: 'SpendOrganizationStatus';
  status?: Maybe<Scalars['Boolean']>;
};

export type SpendOrganizationInput = {
  address: SpendAddressInput;
  email: Scalars['String'];
  legalName: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type SpendAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SpendOrganizationId = {
  __typename?: 'SpendOrganizationID';
  id?: Maybe<Scalars['String']>;
};

export type SpendPaymentScheduleInput = {
  amountDue?: InputMaybe<Scalars['Int']>;
  budgetItemId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  seasonId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type SpendPaymentScheduleId = {
  __typename?: 'SpendPaymentScheduleID';
  id?: Maybe<Scalars['String']>;
};

export type SpendRoleId = {
  __typename?: 'SpendRoleID';
  id?: Maybe<Scalars['String']>;
};

export type SpendSeasonInput = {
  endDateAt?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  isBudgetShared?: InputMaybe<Scalars['Boolean']>;
  isLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  startDateAt?: InputMaybe<Scalars['String']>;
};

export type SpendSeasonId = {
  __typename?: 'SpendSeasonID';
  id?: Maybe<Scalars['String']>;
};

export type SpendSession = {
  __typename?: 'SpendSession';
  expiresAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  role?: Maybe<SpendRole>;
};

export type SpendSessionId = {
  __typename?: 'SpendSessionID';
  id?: Maybe<Scalars['String']>;
};

export type SpendSettingsInput = {
  enableGroupBanks?: InputMaybe<Scalars['Boolean']>;
  enableProgramAgreements?: InputMaybe<Scalars['Boolean']>;
  notifyBankActivityAdmins?: InputMaybe<Scalars['Boolean']>;
  notifyFailedAchAdmins?: InputMaybe<Scalars['Boolean']>;
  notifyPastDueAdmins?: InputMaybe<Scalars['Boolean']>;
  notifyPastDueNonUsers?: InputMaybe<Scalars['Boolean']>;
  notifyUpcomingNonUsers?: InputMaybe<Scalars['Boolean']>;
  pastDueFrequency?: InputMaybe<Scalars['Int']>;
};

export type SpendTransactionInput = {
  externalId?: InputMaybe<Scalars['String']>;
  invoiceIdList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
};

export type SpendTransactionsIdList = {
  __typename?: 'SpendTransactionsIdList';
  transactionIdList?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SpendInviteInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  type: SpendInviteType;
  userId?: InputMaybe<Scalars['String']>;
};

export enum SpendInviteType {
  GroupStaff = 'group_staff',
  Guardian = 'guardian',
  ProgramAdmin = 'program_admin',
  ProgramObserver = 'program_observer',
  ProgramStaff = 'program_staff'
}

export type SpendInviteId = {
  __typename?: 'SpendInviteID';
  id?: Maybe<Scalars['String']>;
};

export type SpendUserId = {
  __typename?: 'SpendUserID';
  id?: Maybe<Scalars['String']>;
};

export enum SpendRoleNameEnum {
  GroupStaff = 'group_staff',
  Guardian = 'guardian',
  ProgramObserver = 'program_observer',
  ProgramStaff = 'program_staff'
}

export type SpendUserRoleId = {
  __typename?: 'SpendUserRoleID';
  id?: Maybe<Scalars['String']>;
};

export type ISponsorDistrictFields = {
  name: Scalars['String'];
};

export type DynamicEmailDataInput = {
  inviterName?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  sponsorshipGroupName?: InputMaybe<Scalars['String']>;
  sponsorshipUrl?: InputMaybe<Scalars['String']>;
};

export type InviteCreationInput = {
  business: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sponsorshipGroups: CreateInviteSponsorshipGroupRelation;
  status?: InputMaybe<Scalars['String']>;
};

export type CreateInviteSponsorshipGroupRelation = {
  create?: InputMaybe<Array<InputMaybe<SponsorshipGroupConnect>>>;
};

export type SponsorshipGroupConnect = {
  sponsorshipGroup?: InputMaybe<Connect>;
};

export type Connect = {
  connect?: InputMaybe<ConnectId>;
};

export type ConnectId = {
  id?: InputMaybe<Scalars['String']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  clientSecret?: Maybe<Scalars['String']>;
  payment?: Maybe<Scalars['Boolean']>;
};

export type SponsorPaymentMethod = {
  __typename?: 'SponsorPaymentMethod';
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  sponsorId?: Maybe<Scalars['String']>;
};

export type ISponsorSchoolFields = {
  name: Scalars['String'];
  streetAddress: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ISponsorSchoolProgramFields = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type AssetCreationInput = {
  assetTypeId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pricing?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  sponsorshipGroupId: Scalars['String'];
  startDate: Scalars['String'];
};

export type MultipleCreationResponse = {
  __typename?: 'multipleCreationResponse';
  count?: Maybe<Scalars['Int']>;
};

export type ISocialMediaAccounts = {
  facebook?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type SponsorshipGroupUserLink = {
  sponsorshipGroupId: Scalars['String'];
  userId: Scalars['String'];
  userType?: InputMaybe<Scalars['String']>;
};

export type StoreInput = {
  accountManagerId: Scalars['String'];
  activityType: Scalars['String'];
  campaignEndDate: Scalars['String'];
  campaignId: Scalars['Int'];
  campaignStartDate: Scalars['String'];
  city: Scalars['String'];
  code: Scalars['String'];
  digitalLogo: Scalars['String'];
  domain: Scalars['String'];
  embroideryLogo: Scalars['String'];
  enabled: Scalars['Int'];
  entityId: Scalars['Int'];
  favicon: Scalars['String'];
  groupLeaderEmail: Scalars['String'];
  hatLogo: Scalars['String'];
  headerLogo: Scalars['String'];
  heroSliderVariableId?: InputMaybe<Scalars['Int']>;
  homepageId: Scalars['Int'];
  name: Scalars['String'];
  ncesId: Scalars['Int'];
  orderConfirmationEmailTemplate: Scalars['String'];
  organizationName: Scalars['String'];
  orgId: Scalars['Int'];
  parentStoreId: Scalars['Int'];
  pointsPercentage: Scalars['Int'];
  primaryColor: Scalars['String'];
  programId: Scalars['Int'];
  qrCode: Scalars['String'];
  raiseId: Scalars['Int'];
  salesRepId: Scalars['String'];
  secondaryColor: Scalars['String'];
  shipmentEmailTemplate: Scalars['String'];
  state: Scalars['String'];
  status: Scalars['String'];
  storeId: Scalars['Int'];
  storeName: Scalars['String'];
  storeVariablesId: Scalars['Int'];
  stripeCreditCardDescriptor: Scalars['String'];
  teamName: Scalars['String'];
  zipCode: Scalars['Int'];
};

export type StoreUpdatePoints = {
  customerEmail: Scalars['String'];
  customerId: Scalars['Int'];
  points: Scalars['Float'];
  scopeId: Scalars['Int'];
};

export type StoreManagerUpdatePointsUnionType = OnException | StoreCustomer;

export type StoreChangeStatus = {
  orderId: Scalars['Int'];
  status: Scalars['String'];
};

export type StoreChangeType = {
  orderId: Scalars['Int'];
  type: Scalars['String'];
};

export type StoreInputOrder = {
  createdAt: Scalars['String'];
  customerEmail: Scalars['String'];
  customerFirstName: Scalars['String'];
  customerId: Scalars['Int'];
  customerLastName: Scalars['String'];
  incrementId: Scalars['String'];
  items: Array<StoreItemInput>;
  orderId: Scalars['Int'];
  scopeId: Scalars['Int'];
  status: Scalars['String'];
  storeId: Scalars['Int'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type StoreItemInput = {
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['Int']>;
  qtyOrdered?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type StoreUpdateOrder = {
  createdAt?: InputMaybe<Scalars['String']>;
  customerEmail: Scalars['String'];
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerId: Scalars['Int'];
  customerLastName?: InputMaybe<Scalars['String']>;
  incrementId?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<StoreItemInput>>;
  orderId: Scalars['Int'];
  scopeId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Float']>;
  tax?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type StoreCreatePaymentIntent = {
  amount: Scalars['Float'];
  email: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSsoId: Scalars['String'];
};

export type StorePaymantIntentUnionType = OnException | StorePaymentIntent;

/** This is Store-Payment-Intent Type. That is used represent the payment intent. This is Own-Used By Store-Dashboard-Team. */
export type StorePaymentIntent = {
  __typename?: 'StorePaymentIntent';
  clientSecret?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userSsoId?: Maybe<Scalars['String']>;
};

export type StoreProductInput = {
  attributeSetId?: InputMaybe<Scalars['Int']>;
  customAttributes?: InputMaybe<Array<InputMaybe<StoreCustomizedAttributesInput>>>;
  extensionAttributes?: InputMaybe<StoreExtendedAttributesInput>;
  mediaGalleryEntries?: InputMaybe<Array<InputMaybe<StoreMediaGalleriesInput>>>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<StoreOptionProductsInput>>>;
  price?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  productLinks?: InputMaybe<Array<InputMaybe<StoreProductionLinksInput>>>;
  scopeId?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  storeId?: InputMaybe<Scalars['Int']>;
  tierPrices?: InputMaybe<Array<InputMaybe<StoreTierPricesInput>>>;
  typeId?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type StoreCustomizedAttributesInput = {
  attributeCode?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type StoreExtendedAttributesInput = {
  bundleProductOptions?: InputMaybe<Array<InputMaybe<StoreProductOptionsInput>>>;
  categoryLinks?: InputMaybe<Array<InputMaybe<StoreCatagoryInput>>>;
  configurableProductLinks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  configurableProductOptions?: InputMaybe<Array<InputMaybe<StoreConfigProductsInput>>>;
  customImage?: InputMaybe<Scalars['String']>;
  downloadableProductLinks?: InputMaybe<Array<InputMaybe<StoreDownloadsInput>>>;
  downloadableProductSamples?: InputMaybe<Array<InputMaybe<StoreProductSamplesInput>>>;
  stockItem?: InputMaybe<StoreStockInput>;
  websiteIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type StoreProductOptionsInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  optionId?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  productLinks?: InputMaybe<Array<InputMaybe<StoreProductsLinksInput>>>;
  required?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type StoreProductsLinksInput = {
  canChangeQuantity?: InputMaybe<Scalars['Int']>;
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  optionId?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  priceType?: InputMaybe<Scalars['Int']>;
  qty?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type StoreCatagoryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  position?: InputMaybe<Scalars['Int']>;
};

export type StoreConfigProductsInput = {
  attributeId?: InputMaybe<Scalars['String']>;
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  isUseDefault?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Array<InputMaybe<StoreValueProductsInput>>>;
};

export type StoreValueProductsInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  valueIndex?: InputMaybe<Scalars['Int']>;
};

export type StoreDownloadsInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  isShareable?: InputMaybe<Scalars['Int']>;
  linkFile?: InputMaybe<Scalars['String']>;
  linkFileString?: InputMaybe<StoreLinkFileInput>;
  linkType?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  numberOfDownloads?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  sampleFile?: InputMaybe<Scalars['String']>;
  sampleFileContent?: InputMaybe<StoreSampleFileInput>;
  sampleType?: InputMaybe<Scalars['String']>;
  sampleUrl?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type StoreLinkFileInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  fileData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StoreSampleFileInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  fileData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StoreProductSamplesInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  sampleFile?: InputMaybe<Scalars['String']>;
  sampleFileContent?: InputMaybe<StoreSampleFileInput>;
  sampleType?: InputMaybe<Scalars['String']>;
  sampleUrl?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type StoreStockInput = {
  backorders?: InputMaybe<Scalars['Int']>;
  enableQtyIncrements?: InputMaybe<Scalars['Boolean']>;
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  isDecimalDivided?: InputMaybe<Scalars['Boolean']>;
  isInStock?: InputMaybe<Scalars['Boolean']>;
  isQtyDecimal?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['Int']>;
  lowStockDate?: InputMaybe<Scalars['String']>;
  manageStock?: InputMaybe<Scalars['Boolean']>;
  maxSaleQty?: InputMaybe<Scalars['Int']>;
  minQty?: InputMaybe<Scalars['Int']>;
  minSaleQty?: InputMaybe<Scalars['Int']>;
  notifyStockQty?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  qty?: InputMaybe<Scalars['Int']>;
  qtyIncrements?: InputMaybe<Scalars['Int']>;
  showDefaultNotificationMessage?: InputMaybe<Scalars['Boolean']>;
  stockId?: InputMaybe<Scalars['Int']>;
  stockStatusChangedAuto?: InputMaybe<Scalars['Int']>;
  useConfigBackorders?: InputMaybe<Scalars['Boolean']>;
  useConfigEnableQtyInc?: InputMaybe<Scalars['Boolean']>;
  useConfigManageStock?: InputMaybe<Scalars['Boolean']>;
  useConfigMaxSaleQty?: InputMaybe<Scalars['Boolean']>;
  useConfigMinQty?: InputMaybe<Scalars['Boolean']>;
  useConfigMinSaleQty?: InputMaybe<Scalars['Int']>;
  useConfigNotifyStockQty?: InputMaybe<Scalars['Boolean']>;
  useConfigQtyIncrements?: InputMaybe<Scalars['Boolean']>;
};

export type StoreMediaGalleriesInput = {
  content?: InputMaybe<StoreContentInput>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  extensionAttributes?: InputMaybe<StoreExtensiveAttributesInput>;
  file?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mediaType?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StoreContentInput = {
  base64EncodedData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type StoreExtensiveAttributesInput = {
  videoContent?: InputMaybe<StoreVideoContentInput>;
};

export type StoreVideoContentInput = {
  mediaType?: InputMaybe<Scalars['String']>;
  videoDescription?: InputMaybe<Scalars['String']>;
  videoMetadata?: InputMaybe<Scalars['String']>;
  videoProvider?: InputMaybe<Scalars['String']>;
  videoTitle?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type StoreOptionProductsInput = {
  extensionAttributes?: InputMaybe<Scalars['JSON']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  imageSizeX?: InputMaybe<Scalars['Int']>;
  imageSizeY?: InputMaybe<Scalars['Int']>;
  isRequire?: InputMaybe<Scalars['Boolean']>;
  maxCharacters?: InputMaybe<Scalars['Int']>;
  optionId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  priceType?: InputMaybe<Scalars['String']>;
  productSku?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<StoreOptionProductsValuesInput>>>;
};

export type StoreOptionProductsValuesInput = {
  optionTypeId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  priceType?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type StoreProductionLinksInput = {
  extensionAttributes?: InputMaybe<StoreExtensAttributesInput>;
  linkedProductSku?: InputMaybe<Scalars['String']>;
  linkedProductType?: InputMaybe<Scalars['String']>;
  linkType?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type StoreExtensAttributesInput = {
  qty?: InputMaybe<Scalars['Int']>;
};

export type StoreTierPricesInput = {
  customerGroupId?: InputMaybe<Scalars['Int']>;
  extensionAttributes?: InputMaybe<StoreExtendAttributesInput>;
  qty?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type StoreExtendAttributesInput = {
  percentageValue?: InputMaybe<Scalars['Int']>;
  websiteId?: InputMaybe<Scalars['Int']>;
};

export type StoreProductUpdateInput = {
  attributeSetId?: InputMaybe<Scalars['Int']>;
  customAttributes?: InputMaybe<Array<InputMaybe<StoreCustomizedAttributesInput>>>;
  extensionAttributes?: InputMaybe<StoreExtendedAttributesInput>;
  mediaGalleryEntries?: InputMaybe<Array<InputMaybe<StoreMediaGalleriesInput>>>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<StoreOptionProductsInput>>>;
  price?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  productLinks?: InputMaybe<Array<InputMaybe<StoreProductionLinksInput>>>;
  scopeId?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  storeId?: InputMaybe<Scalars['Int']>;
  tierPrices?: InputMaybe<Array<InputMaybe<StoreTierPricesInput>>>;
  typeId?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type StorePointsActivityInput = {
  customerBalanceId: Scalars['Int'];
  customerId: Scalars['Int'];
  date: Scalars['String'];
  eventCode: Scalars['String'];
  eventData: Scalars['JSON'];
  pointsBalance: Scalars['Float'];
  pointsDelta: Scalars['String'];
  scopeId: Scalars['Int'];
  storeId: Scalars['Int'];
  transactionId: Scalars['Int'];
  websiteId: Scalars['Int'];
};

export type StoreCampaignInfoInput = {
  campaigns?: InputMaybe<Array<InputMaybe<StoreCampaignInput>>>;
  user?: InputMaybe<StoreSsoUserInfoInput>;
};

export type StoreCampaignInput = {
  accountManagerId?: InputMaybe<Scalars['Int']>;
  commissionEligibleSalesrepId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['Int']>;
  gool?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  initialGoalCents?: InputMaybe<Scalars['Int']>;
  joinCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  originalSalesrepId?: InputMaybe<Scalars['Int']>;
  salesrepId?: InputMaybe<Scalars['Int']>;
  settlementConfirmationStatus?: InputMaybe<Scalars['String']>;
  settlementMethod?: InputMaybe<Scalars['String']>;
  settlementStatus?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  teamSize?: InputMaybe<Scalars['Int']>;
  totalRaisedCents?: InputMaybe<Scalars['Int']>;
  userDirectoryId?: InputMaybe<Scalars['String']>;
};

export type StoreSsoUserInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userRoleId?: InputMaybe<Scalars['String']>;
  userSsoId?: InputMaybe<Scalars['String']>;
};

export type StoreTicketInput = {
  message: Scalars['String'];
  requester: StoreTicketRequester;
  scopeId: Scalars['Int'];
  storeCode: Scalars['String'];
  subject: Scalars['String'];
};

export type StoreTicketRequester = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type StoreTicketsUnionType = OnException | StoreTicket;

export type StoreSaveTransaction = {
  amount: Scalars['Float'];
  email: Scalars['String'];
  points: Scalars['Float'];
  scopeId: Scalars['Int'];
  transactionInfo: Scalars['String'];
  userSsoId: Scalars['String'];
};

export type StoreTransactionUnionType = OnException | StoreTransaction;

/** This is Store-Transaction Type. That is used represent the Stripe payment transection. This is Own-Used By Store-Dashboard-Team. */
export type StoreTransaction = {
  __typename?: 'StoreTransaction';
  amount?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  scopeId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  userSsoId?: Maybe<Scalars['String']>;
};

export type StoreTransferCustomer = {
  customer?: InputMaybe<StoreCustomerInput>;
  points?: InputMaybe<Scalars['Float']>;
  sender?: InputMaybe<StoreSender>;
};

export type StoreCustomerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type StoreSender = {
  email: Scalars['String'];
  scopeId: Scalars['Int'];
  senderId: Scalars['Int'];
};

/** Union Types Mutations */
export type StoreTransferPointsUnionType = OnException | StoreTransferReturn;

/** This is Store-Transfer-Return Type. That represent the response of toreTransferToCustomer/storeTransferToParticipent mutation. This is Own-Used By Store-Dashboard-Team. */
export type StoreTransferReturn = {
  __typename?: 'StoreTransferReturn';
  points?: Maybe<Scalars['Float']>;
  receiver?: Maybe<StoreReceiverData>;
  sender?: Maybe<StoreSenderData>;
  status?: Maybe<Scalars['String']>;
};

/** This is Store-Receiver-Data Type. That represent the response of Points receiver info. This is Own-Used By Store-Dashboard-Team. */
export type StoreReceiverData = {
  __typename?: 'StoreReceiverData';
  email?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  receiverId?: Maybe<Scalars['Int']>;
};

/** This is Store-Sender-Data Type. That represent the response of points sender info. This is Own-Used By Store-Dashboard-Team. */
export type StoreSenderData = {
  __typename?: 'StoreSenderData';
  email?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Float']>;
  senderId?: Maybe<Scalars['Int']>;
};

export type StoreTransferGl = {
  groupLeader?: InputMaybe<StoreGlInput>;
  points?: InputMaybe<Scalars['Float']>;
  sender?: InputMaybe<StoreSender>;
};

export type StoreGlInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type StoreTransferParticipant = {
  participant?: InputMaybe<StoreParticipantInput>;
  points?: InputMaybe<Scalars['Float']>;
  sender?: InputMaybe<StoreSender>;
};

export type StoreParticipantInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type StoreUpdate = {
  accountManagerId?: InputMaybe<Scalars['String']>;
  activityType?: InputMaybe<Scalars['String']>;
  campaignEndDate?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['Int']>;
  campaignStartDate?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  digitalLogo?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  embroideryLogo?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Int']>;
  entityId?: InputMaybe<Scalars['Int']>;
  favicon?: InputMaybe<Scalars['String']>;
  groupLeaderEmail?: InputMaybe<Scalars['String']>;
  hatLogo?: InputMaybe<Scalars['String']>;
  headerLogo?: InputMaybe<Scalars['String']>;
  heroSliderVariableId?: InputMaybe<Scalars['Int']>;
  homepageId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  ncesId?: InputMaybe<Scalars['Int']>;
  orderConfirmationEmailTemplate?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['Int']>;
  parentStoreId?: InputMaybe<Scalars['Int']>;
  pointsPercentage?: InputMaybe<Scalars['Int']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['Int']>;
  qrCode?: InputMaybe<Scalars['String']>;
  raiseId?: InputMaybe<Scalars['Int']>;
  salesRepId?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  shipmentEmailTemplate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  storeName?: InputMaybe<Scalars['String']>;
  storeVariablesId?: InputMaybe<Scalars['Int']>;
  stripeCreditCardDescriptor?: InputMaybe<Scalars['String']>;
  teamName?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type StoreStatusInput = {
  scopeId: Scalars['Int'];
  status: Scalars['Boolean'];
};

export type StoreStatusUnionType = OnException | Store;

export type DriveFileInput = {
  content: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DriveFieldInput = {
  label?: InputMaybe<Scalars['String']>;
  linkText?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: DriveFieldType;
  value: Scalars['String'];
};

export enum DriveFieldType {
  Html = 'HTML',
  Link = 'LINK',
  Text = 'TEXT'
}

export enum Support_Ticket_Department {
  Accounts = 'ACCOUNTS',
  Hubspot = 'HUBSPOT',
  It = 'IT',
  Pep = 'PEP',
  Sales = 'SALES',
  Sponsor = 'SPONSOR',
  Wallet = 'WALLET',
  Warehouse = 'WAREHOUSE'
}

export type TeamCreateInput = {
  facility?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groupval?: InputMaybe<Scalars['String']>;
  home_field?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  level1?: InputMaybe<Scalars['String']>;
  sport_code?: InputMaybe<Scalars['String']>;
  sport_description?: InputMaybe<Scalars['String']>;
  sport_name?: InputMaybe<Scalars['String']>;
};

export type TeamDeleteInput = {
  sport_code: Scalars['String'];
};

export type TeamModifyInput = {
  facility?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groupval?: InputMaybe<Scalars['String']>;
  home_field?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  level1?: InputMaybe<Scalars['String']>;
  sport_code?: InputMaybe<Scalars['String']>;
  sport_description?: InputMaybe<Scalars['String']>;
  sport_name?: InputMaybe<Scalars['String']>;
};

export type TeamOfficialCreateInput = {
  id: Scalars['Int'];
  pay?: InputMaybe<Scalars['Float']>;
  pay_code?: InputMaybe<Scalars['String']>;
  sport: Scalars['String'];
  worker_duty?: InputMaybe<Scalars['String']>;
};

export type TeamOfficialDeleteInput = {
  id: Scalars['Int'];
};

export type TeamOfficialModifyInput = {
  id: Scalars['Int'];
  pay?: InputMaybe<Scalars['Float']>;
  pay_code?: InputMaybe<Scalars['String']>;
  worker_duty?: InputMaybe<Scalars['String']>;
};

export type TeamPreparationCreateInput = {
  id: Scalars['Int'];
  prep: Scalars['Int'];
  qty?: InputMaybe<Scalars['String']>;
  sport: Scalars['String'];
};

export type TeamPreparationDeleteInput = {
  id: Scalars['Int'];
};

export type TeamPreparationModifyInput = {
  id: Scalars['Int'];
  prep?: InputMaybe<Scalars['Int']>;
  qty?: InputMaybe<Scalars['String']>;
};

export type TeamWorkerCreateInput = {
  home_field?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  pay?: InputMaybe<Scalars['Float']>;
  pay_code?: InputMaybe<Scalars['String']>;
  sport: Scalars['String'];
  worker_duty?: InputMaybe<Scalars['String']>;
  worker_name?: InputMaybe<Scalars['String']>;
};

export type TeamWorkerDeleteInput = {
  id: Scalars['Int'];
};

export type TeamWorkerModifyInput = {
  home_field?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  pay?: InputMaybe<Scalars['Float']>;
  pay_code?: InputMaybe<Scalars['String']>;
  worker_duty?: InputMaybe<Scalars['String']>;
  worker_name?: InputMaybe<Scalars['String']>;
};

export enum Card_Status {
  Active = 'active',
  Canceled = 'canceled',
  Inactive = 'inactive'
}

export type UpdatedParticipantGroupCount = {
  __typename?: 'UpdatedParticipantGroupCount';
  count?: Maybe<Scalars['Int']>;
};

export type FundraiserUserIncentiveId = {
  __typename?: 'FundraiserUserIncentiveID';
  id?: Maybe<Scalars['Int']>;
};

export enum UserFittingPreference {
  Mens = 'MENS',
  Womens = 'WOMENS'
}

export type UserInviteResponse = {
  __typename?: 'UserInviteResponse';
  redirect?: Maybe<Scalars['String']>;
};

export type UserPermissionAssignment = {
  id: Scalars['String'];
  scope?: InputMaybe<Scalars['String']>;
};

export type UserResetPasswordResponseWithAvailableTransport = {
  __typename?: 'UserResetPasswordResponseWithAvailableTransport';
  availableTransport: Array<TransportEnum>;
  info?: Maybe<Scalars['String']>;
  result: Array<TransportType>;
};

export type SignUpResponseWithAvailableTransport = {
  __typename?: 'SignUpResponseWithAvailableTransport';
  availableTransport: Array<TransportEnum>;
  result: Array<TransportType>;
};

/** used in vaultKybUpdate and vaultKycUpdate */
export type VaultAddressUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** Day, Month and Year of birth */
export type VaultDobInput = {
  day: Scalars['String'];
  month: Scalars['String'];
  year: Scalars['String'];
};

/** Unit API */
export type UnitBusinessApplicationResponse = {
  __typename?: 'UnitBusinessApplicationResponse';
  applicationId: Scalars['String'];
  customerId?: Maybe<Scalars['String']>;
};

export type CreateVehicleInput = {
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

export type DeleteVehicleInput = {
  id: Scalars['Int'];
};

export type ModifyVehicleInput = {
  id: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

export type CreateWorkerInput = {
  duty?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  organization?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  pay_code?: InputMaybe<Scalars['String']>;
  pay_rate?: InputMaybe<Scalars['Float']>;
  salary?: InputMaybe<Scalars['Float']>;
  ssn?: InputMaybe<Scalars['String']>;
  woker_name?: InputMaybe<Scalars['String']>;
  worker_end_time?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['String']>;
  worker_type?: InputMaybe<Scalars['String']>;
};

export type DeleteWorkerInput = {
  id: Scalars['Int'];
};

export type ModifyWorkerInput = {
  duty?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  organization?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  pay_code?: InputMaybe<Scalars['String']>;
  pay_rate?: InputMaybe<Scalars['Float']>;
  salary?: InputMaybe<Scalars['Float']>;
  ssn?: InputMaybe<Scalars['String']>;
  woker_name?: InputMaybe<Scalars['String']>;
  worker_end_time?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['String']>;
  worker_type?: InputMaybe<Scalars['String']>;
};

export type CreateWorkerPool = {
  Address?: InputMaybe<Scalars['String']>;
  cell_phone?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  First: Scalars['String'];
  Home_Phone?: InputMaybe<Scalars['String']>;
  Last: Scalars['String'];
  pay_rate?: InputMaybe<Scalars['Float']>;
  SSN?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Work_Phone?: InputMaybe<Scalars['String']>;
  worker_type?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type DeleteWorkerPoolInput = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};

export type ModifyWorkerPoolInput = {
  Address?: InputMaybe<Scalars['String']>;
  cell_phone?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  First?: InputMaybe<Scalars['String']>;
  Home_Phone?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  Last?: InputMaybe<Scalars['String']>;
  pay_rate?: InputMaybe<Scalars['Float']>;
  SSN?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Work_Phone?: InputMaybe<Scalars['String']>;
  worker_type?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type UpsertWorkersInput = {
  cell_phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  home_phone?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  pay_rate?: InputMaybe<Scalars['Float']>;
  ssn?: InputMaybe<Scalars['String']>;
  worker_type?: InputMaybe<WorkerTypes>;
};

export enum WorkerTypes {
  C = 'c',
  H = 'h'
}

export type CombinedPermissions = {
  __typename?: 'CombinedPermissions';
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Not used yet. Will be removed soon. */
export type DonationInvite = {
  __typename?: 'DonationInvite';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastEmailSentAt?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type FundraiserList = {
  __typename?: 'FundraiserList';
  hasMore?: Maybe<Scalars['Boolean']>;
  list: Array<Fundraiser>;
};

export type GetEventTransportDetailsByEventInput = {
  event: Scalars['Int'];
};

export type HmAccountRole = {
  __typename?: 'HmAccountRole';
  account_id?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  role_id?: Maybe<Scalars['Int']>;
};

export type HmSpendAccount = {
  __typename?: 'HmSpendAccount';
  id?: Maybe<Scalars['Int']>;
  orgTeamMembers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HmUser = {
  __typename?: 'HmUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type InsUser = {
  __typename?: 'InsUser';
  id: Scalars['Int'];
};

export type PrefundSearchParams = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Prefund_Status>>>;
};

export type RaiseUser = {
  __typename?: 'RaiseUser';
  email?: Maybe<Scalars['String']>;
  /** SSO User ID */
  id?: Maybe<Scalars['String']>;
};

export enum SchoolCategory {
  Charter = 'CHARTER',
  Magnet = 'MAGNET',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Attributes for settlement status */
export type SettlementStatusUpdate = {
  __typename?: 'SettlementStatusUpdate';
  fundraiserId?: Maybe<Scalars['Int']>;
  settlementStatus?: Maybe<SettlementStatus>;
};

export type SpendGroupRostersInput = {
  groupId: Scalars['String'];
  rosters?: InputMaybe<Array<InputMaybe<SpendRosterUser>>>;
  seasonId: Scalars['String'];
};

export type SpendRosterUser = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type SpendTransactionResponse = {
  __typename?: 'SpendTransactionResponse';
  count?: Maybe<Scalars['Int']>;
  transactions?: Maybe<Array<Maybe<SpendTransaction>>>;
};

export enum State {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  NewHampshire = 'NEW_HAMPSHIRE',
  NewJersey = 'NEW_JERSEY',
  NewMexico = 'NEW_MEXICO',
  NewYork = 'NEW_YORK',
  NorthCarolina = 'NORTH_CAROLINA',
  NorthDakota = 'NORTH_DAKOTA',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Oregon = 'OREGON',
  Pennsylvania = 'PENNSYLVANIA',
  RhodeIsland = 'RHODE_ISLAND',
  SouthCarolina = 'SOUTH_CAROLINA',
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  Washington = 'WASHINGTON',
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING'
}

export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Um = 'UM',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** ip and date of Stripe ToS acceptance */
export type VaultTosAcceptance = {
  date: Scalars['DateTime'];
  ip: Scalars['String'];
};

export type GetAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppsQuery = { __typename?: 'Query', me?: { __typename?: 'UserWithPermissions', id?: string | null, apps?: Array<string | null> | null, permissions?: Array<string | null> | null, isInternal?: boolean | null } | null, consumers?: Array<{ __typename?: 'Consumer', id: string, url: string, logo: string, icon: string, title: string, description: string, accessBy?: string | null, mask: string, modal?: { __typename?: 'ConsumerModal', header: string, descriptions: Array<string | null> } | null } | null> | null };

export type GetAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthStatusQuery = { __typename?: 'Query', apiReady?: boolean | null };

export type UpgradeToManagerUserMutationVariables = Exact<{ [key: string]: never; }>;


export type UpgradeToManagerUserMutation = { __typename?: 'Mutation', upgradeToManageUser?: string | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserWithPermissions', id?: string | null, firstName?: string | null, lastName?: string | null, profilePicture?: string | null, permissions?: Array<string | null> | null, parent?: string | null, email?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };


export const GetAppsDocument = gql`
    query GetApps {
  me {
    id
    apps
    permissions
    isInternal @client
  }
  consumers {
    id
    url
    logo
    icon
    title
    description
    modal {
      header
      descriptions
    }
    accessBy
    mask
  }
}
    `;
export const GetAuthStatusDocument = gql`
    query GetAuthStatus {
  apiReady @client
}
    `;
export const UpgradeToManagerUserDocument = gql`
    mutation UpgradeToManagerUser {
  upgradeToManageUser
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    profilePicture
    permissions
    parent
    email
  }
}
    `;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    GetApps(variables?: GetAppsQueryVariables, options?: C): Promise<GetAppsQuery> {
      return requester<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument, variables, options);
    },
    GetAuthStatus(variables?: GetAuthStatusQueryVariables, options?: C): Promise<GetAuthStatusQuery> {
      return requester<GetAuthStatusQuery, GetAuthStatusQueryVariables>(GetAuthStatusDocument, variables, options);
    },
    UpgradeToManagerUser(variables?: UpgradeToManagerUserMutationVariables, options?: C): Promise<UpgradeToManagerUserMutation> {
      return requester<UpgradeToManagerUserMutation, UpgradeToManagerUserMutationVariables>(UpgradeToManagerUserDocument, variables, options);
    },
    Me(variables?: MeQueryVariables, options?: C): Promise<MeQuery> {
      return requester<MeQuery, MeQueryVariables>(MeDocument, variables, options);
    },
    Logout(variables?: LogoutMutationVariables, options?: C): Promise<LogoutMutation> {
      return requester<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, options);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
